/* eslint-disable */
export const EPSG_DEFS: { name: string; code: number, projection: string }[] = [
  {
    "name": "TWD67",
    "code": 3821,
    "projection": "+proj=longlat +ellps=aust_SA +no_defs "
  },
  {
    "name": "TWD97",
    "code": 3824,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "IGRS",
    "code": 3889,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "MGI 1901",
    "code": 3906,
    "projection": "+proj=longlat +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Airy 1830 ellipsoid",
    "code": 4001,
    "projection": "+proj=longlat +ellps=airy +no_defs "
  },
  {
    "name": "Unknown datum based upon the Airy Modified 1849 ellipsoid",
    "code": 4002,
    "projection": "+proj=longlat +ellps=mod_airy +no_defs "
  },
  {
    "name": "Unknown datum based upon the Australian National Spheroid",
    "code": 4003,
    "projection": "+proj=longlat +ellps=aust_SA +no_defs "
  },
  {
    "name": "Unknown datum based upon the Bessel 1841 ellipsoid",
    "code": 4004,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Unknown datum based upon the Bessel Modified ellipsoid",
    "code": 4005,
    "projection": "+proj=longlat +a=6377492.018 +b=6356173.508712696 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Bessel Namibia ellipsoid",
    "code": 4006,
    "projection": "+proj=longlat +ellps=bess_nam +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1858 ellipsoid",
    "code": 4007,
    "projection": "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1866 ellipsoid",
    "code": 4008,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1866 Michigan ellipsoid",
    "code": 4009,
    "projection": "+proj=longlat +a=6378450.047548896 +b=6356826.621488444 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 (Benoit) ellipsoid",
    "code": 4010,
    "projection": "+proj=longlat +a=6378300.789 +b=6356566.435 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 (IGN) ellipsoid",
    "code": 4011,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 (RGS) ellipsoid",
    "code": 4012,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 (Arc) ellipsoid",
    "code": 4013,
    "projection": "+proj=longlat +a=6378249.145 +b=6356514.966398753 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 (SGA 1922) ellipsoid",
    "code": 4014,
    "projection": "+proj=longlat +a=6378249.2 +b=6356514.996941779 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest 1830 (1937 Adjustment) ellipsoid",
    "code": 4015,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest 1830 (1967 Definition) ellipsoid",
    "code": 4016,
    "projection": "+proj=longlat +ellps=evrstSS +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest 1830 Modified ellipsoid",
    "code": 4018,
    "projection": "+proj=longlat +a=6377304.063 +b=6356103.038993155 +no_defs "
  },
  {
    "name": "Unknown datum based upon the GRS 1980 ellipsoid",
    "code": 4019,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Helmert 1906 ellipsoid",
    "code": 4020,
    "projection": "+proj=longlat +ellps=helmert +no_defs "
  },
  {
    "name": "Unknown datum based upon the Indonesian National Spheroid",
    "code": 4021,
    "projection": "+proj=longlat +a=6378160 +b=6356774.50408554 +no_defs "
  },
  {
    "name": "Unknown datum based upon the International 1924 ellipsoid",
    "code": 4022,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "MOLDREF99",
    "code": 4023,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Krassowsky 1940 ellipsoid",
    "code": 4024,
    "projection": "+proj=longlat +ellps=krass +no_defs "
  },
  {
    "name": "Unknown datum based upon the NWL 9D ellipsoid",
    "code": 4025,
    "projection": "+proj=longlat +ellps=WGS66 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Plessis 1817 ellipsoid",
    "code": 4027,
    "projection": "+proj=longlat +a=6376523 +b=6355862.933255573 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Struve 1860 ellipsoid",
    "code": 4028,
    "projection": "+proj=longlat +a=6378298.3 +b=6356657.142669561 +no_defs "
  },
  {
    "name": "Unknown datum based upon the War Office ellipsoid",
    "code": 4029,
    "projection": "+proj=longlat +a=6378300 +b=6356751.689189189 +no_defs "
  },
  {
    "name": "Unknown datum based upon the WGS 84 ellipsoid",
    "code": 4030,
    "projection": "+proj=longlat +ellps=WGS84 +no_defs "
  },
  {
    "name": "Unknown datum based upon the GEM 10C ellipsoid",
    "code": 4031,
    "projection": "+proj=longlat +ellps=WGS84 +no_defs "
  },
  {
    "name": "Unknown datum based upon the OSU86F ellipsoid",
    "code": 4032,
    "projection": "+proj=longlat +a=6378136.2 +b=6356751.516927429 +no_defs "
  },
  {
    "name": "Unknown datum based upon the OSU91A ellipsoid",
    "code": 4033,
    "projection": "+proj=longlat +a=6378136.3 +b=6356751.616592146 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Clarke 1880 ellipsoid",
    "code": 4034,
    "projection": "+proj=longlat +a=6378249.144808011 +b=6356514.966204134 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Authalic Sphere",
    "code": 4035,
    "projection": "+proj=longlat +a=6371000 +b=6371000 +no_defs "
  },
  {
    "name": "Unknown datum based upon the GRS 1967 ellipsoid",
    "code": 4036,
    "projection": "+proj=longlat +ellps=GRS67 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Average Terrestrial System 1977 ellipsoid",
    "code": 4041,
    "projection": "+proj=longlat +a=6378135 +b=6356750.304921594 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest (1830 Definition) ellipsoid",
    "code": 4042,
    "projection": "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +no_defs "
  },
  {
    "name": "Unknown datum based upon the WGS 72 ellipsoid",
    "code": 4043,
    "projection": "+proj=longlat +ellps=WGS72 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest 1830 (1962 Definition) ellipsoid",
    "code": 4044,
    "projection": "+proj=longlat +a=6377301.243 +b=6356100.230165384 +no_defs "
  },
  {
    "name": "Unknown datum based upon the Everest 1830 (1975 Definition) ellipsoid",
    "code": 4045,
    "projection": "+proj=longlat +a=6377299.151 +b=6356098.145120132 +no_defs "
  },
  {
    "name": "RGRDC 2005",
    "code": 4046,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Unspecified datum based upon the GRS 1980 Authalic Sphere",
    "code": 4047,
    "projection": "+proj=longlat +a=6371007 +b=6371007 +no_defs "
  },
  {
    "name": "Unspecified datum based upon the Clarke 1866 Authalic Sphere",
    "code": 4052,
    "projection": "+proj=longlat +a=6370997 +b=6370997 +no_defs "
  },
  {
    "name": "Unspecified datum based upon the International 1924 Authalic Sphere",
    "code": 4053,
    "projection": "+proj=longlat +a=6371228 +b=6371228 +no_defs "
  },
  {
    "name": "Unspecified datum based upon the Hughes 1980 ellipsoid",
    "code": 4054,
    "projection": "+proj=longlat +a=6378273 +b=6356889.449 +no_defs "
  },
  {
    "name": "Popular Visualisation CRS",
    "code": 4055,
    "projection": "+proj=longlat +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "SREF98",
    "code": 4075,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "REGCAN95",
    "code": 4081,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Greek",
    "code": 4120,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "GGRS87",
    "code": 4121,
    "projection": "+proj=longlat +datum=GGRS87 +no_defs "
  },
  {
    "name": "ATS77",
    "code": 4122,
    "projection": "+proj=longlat +a=6378135 +b=6356750.304921594 +no_defs "
  },
  {
    "name": "KKJ",
    "code": 4123,
    "projection": "+proj=longlat +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +no_defs "
  },
  {
    "name": "RT90",
    "code": 4124,
    "projection": "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +no_defs "
  },
  {
    "name": "Samboja",
    "code": 4125,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-404.78,685.68,45.47,0,0,0,0 +no_defs "
  },
  {
    "name": "LKS94 (ETRS89)",
    "code": 4126,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "Tete",
    "code": 4127,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +no_defs "
  },
  {
    "name": "Madzansua",
    "code": 4128,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "Observatario",
    "code": 4129,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-132,-110,-335,0,0,0,0 +no_defs "
  },
  {
    "name": "Moznet",
    "code": 4130,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Indian 1960",
    "code": 4131,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +no_defs "
  },
  {
    "name": "FD58",
    "code": 4132,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-241.54,-163.64,396.06,0,0,0,0 +no_defs "
  },
  {
    "name": "EST92",
    "code": 4133,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +no_defs "
  },
  {
    "name": "PSD93",
    "code": 4134,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +no_defs "
  },
  {
    "name": "Old Hawaiian",
    "code": 4135,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +no_defs "
  },
  {
    "name": "St. Lawrence Island",
    "code": 4136,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "St. Paul Island",
    "code": 4137,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "St. George Island",
    "code": 4138,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "Puerto Rico",
    "code": 4139,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD83(CSRS98)",
    "code": 4140,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Israel 1993",
    "code": 4141,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=-48,55,52,0,0,0,0 +no_defs "
  },
  {
    "name": "Locodjo 1965",
    "code": 4142,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +no_defs "
  },
  {
    "name": "Abidjan 1987",
    "code": 4143,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +no_defs "
  },
  {
    "name": "Kalianpur 1937",
    "code": 4144,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +no_defs "
  },
  {
    "name": "Kalianpur 1962",
    "code": 4145,
    "projection": "+proj=longlat +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +no_defs "
  },
  {
    "name": "Kalianpur 1975",
    "code": 4146,
    "projection": "+proj=longlat +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +no_defs "
  },
  {
    "name": "Hanoi 1972",
    "code": 4147,
    "projection": "+proj=longlat +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +no_defs "
  },
  {
    "name": "Hartebeesthoek94",
    "code": 4148,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "CH1903",
    "code": 4149,
    "projection": "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs "
  },
  {
    "name": "CH1903+",
    "code": 4150,
    "projection": "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs "
  },
  {
    "name": "CHTRF95",
    "code": 4151,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD83(HARN)",
    "code": 4152,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Rassadiran",
    "code": 4153,
    "projection": "+proj=longlat +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +no_defs "
  },
  {
    "name": "ED50(ED77)",
    "code": 4154,
    "projection": "+proj=longlat +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +no_defs "
  },
  {
    "name": "Dabola 1981",
    "code": 4155,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +no_defs "
  },
  {
    "name": "S-JTSK",
    "code": 4156,
    "projection": "+proj=longlat +ellps=bessel +towgs84=589,76,480,0,0,0,0 +no_defs "
  },
  {
    "name": "Mount Dillon",
    "code": 4157,
    "projection": "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs "
  },
  {
    "name": "Naparima 1955",
    "code": 4158,
    "projection": "+proj=longlat +ellps=intl +towgs84=-0.465,372.095,171.736,0,0,0,0 +no_defs "
  },
  {
    "name": "ELD79",
    "code": 4159,
    "projection": "+proj=longlat +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +no_defs "
  },
  {
    "name": "Chos Malal 1914",
    "code": 4160,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Pampa del Castillo",
    "code": 4161,
    "projection": "+proj=longlat +ellps=intl +towgs84=27.5,14,186.4,0,0,0,0 +no_defs "
  },
  {
    "name": "Korean 1985",
    "code": 4162,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Yemen NGN96",
    "code": 4163,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "South Yemen",
    "code": 4164,
    "projection": "+proj=longlat +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +no_defs "
  },
  {
    "name": "Bissau",
    "code": 4165,
    "projection": "+proj=longlat +ellps=intl +towgs84=-173,253,27,0,0,0,0 +no_defs "
  },
  {
    "name": "Korean 1995",
    "code": 4166,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "NZGD2000",
    "code": 4167,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Accra",
    "code": 4168,
    "projection": "+proj=longlat +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +no_defs "
  },
  {
    "name": "American Samoa 1962",
    "code": 4169,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +no_defs "
  },
  {
    "name": "SIRGAS 1995",
    "code": 4170,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "RGF93",
    "code": 4171,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "POSGAR",
    "code": 4172,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "IRENET95",
    "code": 4173,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Sierra Leone 1924",
    "code": 4174,
    "projection": "+proj=longlat +a=6378300 +b=6356751.689189189 +no_defs "
  },
  {
    "name": "Sierra Leone 1968",
    "code": 4175,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +no_defs "
  },
  {
    "name": "Australian Antarctic",
    "code": 4176,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Pulkovo 1942(83)",
    "code": 4178,
    "projection": "+proj=longlat +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +no_defs "
  },
  {
    "name": "Pulkovo 1942(58)",
    "code": 4179,
    "projection": "+proj=longlat +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +no_defs "
  },
  {
    "name": "EST97",
    "code": 4180,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Luxembourg 1930",
    "code": 4181,
    "projection": "+proj=longlat +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +no_defs "
  },
  {
    "name": "Azores Occidental 1939",
    "code": 4182,
    "projection": "+proj=longlat +ellps=intl +towgs84=-425,-169,81,0,0,0,0 +no_defs "
  },
  {
    "name": "Azores Central 1948",
    "code": 4183,
    "projection": "+proj=longlat +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +no_defs "
  },
  {
    "name": "Azores Oriental 1940",
    "code": 4184,
    "projection": "+proj=longlat +ellps=intl +towgs84=-203,141,53,0,0,0,0 +no_defs "
  },
  {
    "name": "Madeira 1936",
    "code": 4185,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "OSNI 1952",
    "code": 4188,
    "projection": "+proj=longlat +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs "
  },
  {
    "name": "REGVEN",
    "code": 4189,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "POSGAR 98",
    "code": 4190,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Albanian 1987",
    "code": 4191,
    "projection": "+proj=longlat +ellps=krass +towgs84=-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703 +no_defs "
  },
  {
    "name": "Douala 1948",
    "code": 4192,
    "projection": "+proj=longlat +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +no_defs "
  },
  {
    "name": "Manoca 1962",
    "code": 4193,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +no_defs "
  },
  {
    "name": "Qornoq 1927",
    "code": 4194,
    "projection": "+proj=longlat +ellps=intl +towgs84=164,138,-189,0,0,0,0 +no_defs "
  },
  {
    "name": "Scoresbysund 1952",
    "code": 4195,
    "projection": "+proj=longlat +ellps=intl +towgs84=105,326,-102.5,0,0,0.814,-0.6 +no_defs "
  },
  {
    "name": "Ammassalik 1958",
    "code": 4196,
    "projection": "+proj=longlat +ellps=intl +towgs84=-45,417,-3.5,0,0,0.814,-0.6 +no_defs "
  },
  {
    "name": "Garoua",
    "code": 4197,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Kousseri",
    "code": 4198,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Egypt 1930",
    "code": 4199,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Pulkovo 1995",
    "code": 4200,
    "projection": "+proj=longlat +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +no_defs "
  },
  {
    "name": "Adindan",
    "code": 4201,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +no_defs "
  },
  {
    "name": "AGD66",
    "code": 4202,
    "projection": "+proj=longlat +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +no_defs "
  },
  {
    "name": "AGD84",
    "code": 4203,
    "projection": "+proj=longlat +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +no_defs "
  },
  {
    "name": "Ain el Abd",
    "code": 4204,
    "projection": "+proj=longlat +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +no_defs "
  },
  {
    "name": "Afgooye",
    "code": 4205,
    "projection": "+proj=longlat +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +no_defs "
  },
  {
    "name": "Agadez",
    "code": 4206,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Lisbon",
    "code": 4207,
    "projection": "+proj=longlat +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +no_defs "
  },
  {
    "name": "Aratu",
    "code": 4208,
    "projection": "+proj=longlat +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +no_defs "
  },
  {
    "name": "Arc 1950",
    "code": 4209,
    "projection": "+proj=longlat +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +no_defs "
  },
  {
    "name": "Arc 1960",
    "code": 4210,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +no_defs "
  },
  {
    "name": "Batavia",
    "code": 4211,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +no_defs "
  },
  {
    "name": "Barbados 1938",
    "code": 4212,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +no_defs "
  },
  {
    "name": "Beduaram",
    "code": 4213,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-106,-87,188,0,0,0,0 +no_defs "
  },
  {
    "name": "Beijing 1954",
    "code": 4214,
    "projection": "+proj=longlat +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +no_defs "
  },
  {
    "name": "Belge 1950",
    "code": 4215,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Bermuda 1957",
    "code": 4216,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-73,213,296,0,0,0,0 +no_defs "
  },
  {
    "name": "Bogota 1975",
    "code": 4218,
    "projection": "+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +no_defs "
  },
  {
    "name": "Bukit Rimpah",
    "code": 4219,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-384,664,-48,0,0,0,0 +no_defs "
  },
  {
    "name": "Camacupa",
    "code": 4220,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +no_defs "
  },
  {
    "name": "Campo Inchauspe",
    "code": 4221,
    "projection": "+proj=longlat +ellps=intl +towgs84=-148,136,90,0,0,0,0 +no_defs "
  },
  {
    "name": "Cape",
    "code": 4222,
    "projection": "+proj=longlat +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +no_defs "
  },
  {
    "name": "Carthage",
    "code": 4223,
    "projection": "+proj=longlat +datum=carthage +no_defs "
  },
  {
    "name": "Chua",
    "code": 4224,
    "projection": "+proj=longlat +ellps=intl +towgs84=-143.87,243.37,-33.52,0,0,0,0 +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72",
    "code": 4225,
    "projection": "+proj=longlat +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +no_defs "
  },
  {
    "name": "Cote d'Ivoire",
    "code": 4226,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Deir ez Zor",
    "code": 4227,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +no_defs "
  },
  {
    "name": "Douala",
    "code": 4228,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Egypt 1907",
    "code": 4229,
    "projection": "+proj=longlat +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +no_defs "
  },
  {
    "name": "ED50",
    "code": 4230,
    "projection": "+proj=longlat +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +no_defs "
  },
  {
    "name": "ED87",
    "code": 4231,
    "projection": "+proj=longlat +ellps=intl +towgs84=-83.11,-97.38,-117.22,0.005693,-0.044698,0.044285,0.1218 +no_defs "
  },
  {
    "name": "Fahud",
    "code": 4232,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +no_defs "
  },
  {
    "name": "Gandajika 1970",
    "code": 4233,
    "projection": "+proj=longlat +ellps=intl +towgs84=-133,-321,50,0,0,0,0 +no_defs "
  },
  {
    "name": "Garoua",
    "code": 4234,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Guyane Francaise",
    "code": 4235,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Hu Tzu Shan 1950",
    "code": 4236,
    "projection": "+proj=longlat +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +no_defs "
  },
  {
    "name": "HD72",
    "code": 4237,
    "projection": "+proj=longlat +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +no_defs "
  },
  {
    "name": "ID74",
    "code": 4238,
    "projection": "+proj=longlat +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +no_defs "
  },
  {
    "name": "Indian 1954",
    "code": 4239,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +no_defs "
  },
  {
    "name": "Indian 1975",
    "code": 4240,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +no_defs "
  },
  {
    "name": "Jamaica 1875",
    "code": 4241,
    "projection": "+proj=longlat +a=6378249.144808011 +b=6356514.966204134 +no_defs "
  },
  {
    "name": "JAD69",
    "code": 4242,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=70,207,389.5,0,0,0,0 +no_defs "
  },
  {
    "name": "Kalianpur 1880",
    "code": 4243,
    "projection": "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +no_defs "
  },
  {
    "name": "Kandawala",
    "code": 4244,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=-97,787,86,0,0,0,0 +no_defs "
  },
  {
    "name": "Kertau 1968",
    "code": 4245,
    "projection": "+proj=longlat +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +no_defs "
  },
  {
    "name": "KOC",
    "code": 4246,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +no_defs "
  },
  {
    "name": "La Canoa",
    "code": 4247,
    "projection": "+proj=longlat +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +no_defs "
  },
  {
    "name": "PSAD56",
    "code": 4248,
    "projection": "+proj=longlat +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +no_defs "
  },
  {
    "name": "Lake",
    "code": 4249,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Leigon",
    "code": 4250,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-130,29,364,0,0,0,0 +no_defs "
  },
  {
    "name": "Liberia 1964",
    "code": 4251,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-90,40,88,0,0,0,0 +no_defs "
  },
  {
    "name": "Lome",
    "code": 4252,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Luzon 1911",
    "code": 4253,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +no_defs "
  },
  {
    "name": "Hito XVIII 1963",
    "code": 4254,
    "projection": "+proj=longlat +ellps=intl +towgs84=16,196,93,0,0,0,0 +no_defs "
  },
  {
    "name": "Herat North",
    "code": 4255,
    "projection": "+proj=longlat +ellps=intl +towgs84=-333,-222,114,0,0,0,0 +no_defs "
  },
  {
    "name": "Mahe 1971",
    "code": 4256,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=41,-220,-134,0,0,0,0 +no_defs "
  },
  {
    "name": "Makassar",
    "code": 4257,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +no_defs "
  },
  {
    "name": "ETRS89",
    "code": 4258,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Malongo 1987",
    "code": 4259,
    "projection": "+proj=longlat +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +no_defs "
  },
  {
    "name": "Manoca",
    "code": 4260,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +no_defs "
  },
  {
    "name": "Merchich",
    "code": 4261,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +no_defs "
  },
  {
    "name": "Massawa",
    "code": 4262,
    "projection": "+proj=longlat +ellps=bessel +towgs84=639,405,60,0,0,0,0 +no_defs "
  },
  {
    "name": "Minna",
    "code": 4263,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +no_defs "
  },
  {
    "name": "Mhast",
    "code": 4264,
    "projection": "+proj=longlat +ellps=intl +towgs84=-252.95,-4.11,-96.38,0,0,0,0 +no_defs "
  },
  {
    "name": "Monte Mario",
    "code": 4265,
    "projection": "+proj=longlat +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +no_defs "
  },
  {
    "name": "M'poraloko",
    "code": 4266,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD27",
    "code": 4267,
    "projection": "+proj=longlat +datum=NAD27 +no_defs "
  },
  {
    "name": "NAD27 Michigan",
    "code": 4268,
    "projection": "+proj=longlat +a=6378450.047548896 +b=6356826.621488444 +no_defs "
  },
  {
    "name": "NAD83",
    "code": 4269,
    "projection": "+proj=longlat +datum=NAD83 +no_defs "
  },
  {
    "name": "Nahrwan 1967",
    "code": 4270,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +no_defs "
  },
  {
    "name": "Naparima 1972",
    "code": 4271,
    "projection": "+proj=longlat +ellps=intl +towgs84=-10,375,165,0,0,0,0 +no_defs "
  },
  {
    "name": "NZGD49",
    "code": 4272,
    "projection": "+proj=longlat +datum=nzgd49 +no_defs "
  },
  {
    "name": "NGO 1948",
    "code": 4273,
    "projection": "+proj=longlat +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +no_defs "
  },
  {
    "name": "Datum 73",
    "code": 4274,
    "projection": "+proj=longlat +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +no_defs "
  },
  {
    "name": "NTF",
    "code": 4275,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +no_defs "
  },
  {
    "name": "NSWC 9Z-2",
    "code": 4276,
    "projection": "+proj=longlat +ellps=WGS66 +no_defs "
  },
  {
    "name": "OSGB 1936",
    "code": 4277,
    "projection": "+proj=longlat +datum=OSGB36 +no_defs "
  },
  {
    "name": "OSGB70",
    "code": 4278,
    "projection": "+proj=longlat +ellps=airy +no_defs "
  },
  {
    "name": "OS(SN)80",
    "code": 4279,
    "projection": "+proj=longlat +ellps=airy +no_defs "
  },
  {
    "name": "Padang",
    "code": 4280,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Palestine 1923",
    "code": 4281,
    "projection": "+proj=longlat +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +no_defs "
  },
  {
    "name": "Pointe Noire",
    "code": 4282,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-148,51,-291,0,0,0,0 +no_defs "
  },
  {
    "name": "GDA94",
    "code": 4283,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Pulkovo 1942",
    "code": 4284,
    "projection": "+proj=longlat +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +no_defs "
  },
  {
    "name": "Qatar 1974",
    "code": 4285,
    "projection": "+proj=longlat +ellps=intl +towgs84=-128.16,-282.42,21.93,0,0,0,0 +no_defs "
  },
  {
    "name": "Qatar 1948",
    "code": 4286,
    "projection": "+proj=longlat +ellps=helmert +no_defs "
  },
  {
    "name": "Qornoq",
    "code": 4287,
    "projection": "+proj=longlat +ellps=intl +towgs84=164,138,-189,0,0,0,0 +no_defs "
  },
  {
    "name": "Loma Quintana",
    "code": 4288,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Amersfoort",
    "code": 4289,
    "projection": "+proj=longlat +ellps=bessel +towgs84=565.2369,50.0087,465.658,-0.406857,0.350733,-1.87035,4.0812 +no_defs "
  },
  {
    "name": "SAD69",
    "code": 4291,
    "projection": "+proj=longlat +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +no_defs "
  },
  {
    "name": "Sapper Hill 1943",
    "code": 4292,
    "projection": "+proj=longlat +ellps=intl +towgs84=-355,21,72,0,0,0,0 +no_defs "
  },
  {
    "name": "Schwarzeck",
    "code": 4293,
    "projection": "+proj=longlat +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +no_defs "
  },
  {
    "name": "Segora",
    "code": 4294,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +no_defs "
  },
  {
    "name": "Serindung",
    "code": 4295,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Sudan",
    "code": 4296,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Tananarive",
    "code": 4297,
    "projection": "+proj=longlat +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +no_defs "
  },
  {
    "name": "Timbalai 1948",
    "code": 4298,
    "projection": "+proj=longlat +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +no_defs "
  },
  {
    "name": "TM65",
    "code": 4299,
    "projection": "+proj=longlat +datum=ire65 +no_defs "
  },
  {
    "name": "TM75",
    "code": 4300,
    "projection": "+proj=longlat +ellps=mod_airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs "
  },
  {
    "name": "Tokyo",
    "code": 4301,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +no_defs "
  },
  {
    "name": "Trinidad 1903",
    "code": 4302,
    "projection": "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +no_defs "
  },
  {
    "name": "TC(1948)",
    "code": 4303,
    "projection": "+proj=longlat +ellps=helmert +no_defs "
  },
  {
    "name": "Voirol 1875",
    "code": 4304,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +no_defs "
  },
  {
    "name": "Bern 1938",
    "code": 4306,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Nord Sahara 1959",
    "code": 4307,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +no_defs "
  },
  {
    "name": "RT38",
    "code": 4308,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "Yacare",
    "code": 4309,
    "projection": "+proj=longlat +ellps=intl +towgs84=-155,171,37,0,0,0,0 +no_defs "
  },
  {
    "name": "Yoff",
    "code": 4310,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-30,190,89,0,0,0,0 +no_defs "
  },
  {
    "name": "Zanderij",
    "code": 4311,
    "projection": "+proj=longlat +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +no_defs "
  },
  {
    "name": "MGI",
    "code": 4312,
    "projection": "+proj=longlat +datum=hermannskogel +no_defs "
  },
  {
    "name": "Belge 1972",
    "code": 4313,
    "projection": "+proj=longlat +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +no_defs "
  },
  {
    "name": "DHDN",
    "code": 4314,
    "projection": "+proj=longlat +datum=potsdam +no_defs "
  },
  {
    "name": "Conakry 1905",
    "code": 4315,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +no_defs "
  },
  {
    "name": "Dealul Piscului 1930",
    "code": 4316,
    "projection": "+proj=longlat +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +no_defs "
  },
  {
    "name": "Dealul Piscului 1970",
    "code": 4317,
    "projection": "+proj=longlat +ellps=krass +towgs84=28,-121,-77,0,0,0,0 +no_defs "
  },
  {
    "name": "NGN",
    "code": 4318,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +no_defs "
  },
  {
    "name": "KUDAMS",
    "code": 4319,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +no_defs "
  },
  {
    "name": "WGS 72",
    "code": 4322,
    "projection": "+proj=longlat +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +no_defs "
  },
  {
    "name": "WGS 72BE",
    "code": 4324,
    "projection": "+proj=longlat +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +no_defs "
  },
  {
    "name": "WGS 84",
    "code": 4326,
    "projection": "+proj=longlat +datum=WGS84 +no_defs "
  },
  {
    "name": "RGSPM06",
    "code": 4463,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "RGM04",
    "code": 4470,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Cadastre 1997",
    "code": 4475,
    "projection": "+proj=longlat +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +no_defs "
  },
  {
    "name": "Mexico ITRF92",
    "code": 4483,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "China Geodetic Coordinate System 2000",
    "code": 4490,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "New Beijing",
    "code": 4555,
    "projection": "+proj=longlat +ellps=krass +no_defs "
  },
  {
    "name": "RRAF 1991",
    "code": 4558,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Anguilla 1957",
    "code": 4600,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Antigua 1943",
    "code": 4601,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-255,-15,71,0,0,0,0 +no_defs "
  },
  {
    "name": "Dominica 1945",
    "code": 4602,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=725,685,536,0,0,0,0 +no_defs "
  },
  {
    "name": "Grenada 1953",
    "code": 4603,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=72,213.7,93,0,0,0,0 +no_defs "
  },
  {
    "name": "Montserrat 1958",
    "code": 4604,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=174,359,365,0,0,0,0 +no_defs "
  },
  {
    "name": "St. Kitts 1955",
    "code": 4605,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=9,183,236,0,0,0,0 +no_defs "
  },
  {
    "name": "St. Lucia 1955",
    "code": 4606,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-149,128,296,0,0,0,0 +no_defs "
  },
  {
    "name": "St. Vincent 1945",
    "code": 4607,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=195.671,332.517,274.607,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD27(76)",
    "code": 4608,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "NAD27(CGQ77)",
    "code": 4609,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "Xian 1980",
    "code": 4610,
    "projection": "+proj=longlat +a=6378140 +b=6356755.288157528 +no_defs "
  },
  {
    "name": "Hong Kong 1980",
    "code": 4611,
    "projection": "+proj=longlat +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246 +no_defs "
  },
  {
    "name": "JGD2000",
    "code": 4612,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Segara",
    "code": 4613,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +no_defs "
  },
  {
    "name": "QND95",
    "code": 4614,
    "projection": "+proj=longlat +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +no_defs "
  },
  {
    "name": "Porto Santo",
    "code": 4615,
    "projection": "+proj=longlat +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +no_defs "
  },
  {
    "name": "Selvagem Grande",
    "code": 4616,
    "projection": "+proj=longlat +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD83(CSRS)",
    "code": 4617,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "SAD69",
    "code": 4618,
    "projection": "+proj=longlat +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +no_defs "
  },
  {
    "name": "SWEREF99",
    "code": 4619,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Point 58",
    "code": 4620,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-106,-129,165,0,0,0,0 +no_defs "
  },
  {
    "name": "Fort Marigot",
    "code": 4621,
    "projection": "+proj=longlat +ellps=intl +towgs84=137,248,-430,0,0,0,0 +no_defs "
  },
  {
    "name": "Guadeloupe 1948",
    "code": 4622,
    "projection": "+proj=longlat +ellps=intl +towgs84=-467,-16,-300,0,0,0,0 +no_defs "
  },
  {
    "name": "CSG67",
    "code": 4623,
    "projection": "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs "
  },
  {
    "name": "RGFG95",
    "code": 4624,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Martinique 1938",
    "code": 4625,
    "projection": "+proj=longlat +ellps=intl +towgs84=186,482,151,0,0,0,0 +no_defs "
  },
  {
    "name": "Reunion 1947",
    "code": 4626,
    "projection": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs "
  },
  {
    "name": "RGR92",
    "code": 4627,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Tahiti 52",
    "code": 4628,
    "projection": "+proj=longlat +ellps=intl +towgs84=162,117,154,0,0,0,0 +no_defs "
  },
  {
    "name": "Tahaa 54",
    "code": 4629,
    "projection": "+proj=longlat +ellps=intl +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746 +no_defs "
  },
  {
    "name": "IGN72 Nuku Hiva",
    "code": 4630,
    "projection": "+proj=longlat +ellps=intl +towgs84=84,274,65,0,0,0,0 +no_defs "
  },
  {
    "name": "K0 1949",
    "code": 4631,
    "projection": "+proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs "
  },
  {
    "name": "Combani 1950",
    "code": 4632,
    "projection": "+proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +no_defs "
  },
  {
    "name": "IGN56 Lifou",
    "code": 4633,
    "projection": "+proj=longlat +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +no_defs "
  },
  {
    "name": "IGN72 Grand Terre",
    "code": 4634,
    "projection": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs "
  },
  {
    "name": "ST87 Ouvea",
    "code": 4635,
    "projection": "+proj=longlat +ellps=intl +towgs84=-122.383,-188.696,103.344,3.5107,-4.9668,-5.7047,4.4798 +no_defs "
  },
  {
    "name": "Petrels 1972",
    "code": 4636,
    "projection": "+proj=longlat +ellps=intl +towgs84=365,194,166,0,0,0,0 +no_defs "
  },
  {
    "name": "Perroud 1950",
    "code": 4637,
    "projection": "+proj=longlat +ellps=intl +towgs84=325,154,172,0,0,0,0 +no_defs "
  },
  {
    "name": "Saint Pierre et Miquelon 1950",
    "code": 4638,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +no_defs "
  },
  {
    "name": "MOP78",
    "code": 4639,
    "projection": "+proj=longlat +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +no_defs "
  },
  {
    "name": "RRAF 1991",
    "code": 4640,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "IGN53 Mare",
    "code": 4641,
    "projection": "+proj=longlat +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +no_defs "
  },
  {
    "name": "ST84 Ile des Pins",
    "code": 4642,
    "projection": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs "
  },
  {
    "name": "ST71 Belep",
    "code": 4643,
    "projection": "+proj=longlat +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +no_defs "
  },
  {
    "name": "NEA74 Noumea",
    "code": 4644,
    "projection": "+proj=longlat +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +no_defs "
  },
  {
    "name": "RGNC 1991",
    "code": 4645,
    "projection": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Grand Comoros",
    "code": 4646,
    "projection": "+proj=longlat +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +no_defs "
  },
  {
    "name": "Reykjavik 1900",
    "code": 4657,
    "projection": "+proj=longlat +a=6377019.27 +b=6355762.5391 +towgs84=-28,199,5,0,0,0,0 +no_defs "
  },
  {
    "name": "Hjorsey 1955",
    "code": 4658,
    "projection": "+proj=longlat +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +no_defs "
  },
  {
    "name": "ISN93",
    "code": 4659,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Helle 1954",
    "code": 4660,
    "projection": "+proj=longlat +ellps=intl +towgs84=982.6087,552.753,-540.873,6.6816266,-31.6114924,-19.84816,16.805 +no_defs "
  },
  {
    "name": "LKS92",
    "code": 4661,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "IGN72 Grande Terre",
    "code": 4662,
    "projection": "+proj=longlat +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +no_defs "
  },
  {
    "name": "Porto Santo 1995",
    "code": 4663,
    "projection": "+proj=longlat +ellps=intl +towgs84=-502.862,-247.438,312.724,0,0,0,0 +no_defs "
  },
  {
    "name": "Azores Oriental 1995",
    "code": 4664,
    "projection": "+proj=longlat +ellps=intl +towgs84=-204.619,140.176,55.226,0,0,0,0 +no_defs "
  },
  {
    "name": "Azores Central 1995",
    "code": 4665,
    "projection": "+proj=longlat +ellps=intl +towgs84=-106.226,166.366,-37.893,0,0,0,0 +no_defs "
  },
  {
    "name": "Lisbon 1890",
    "code": 4666,
    "projection": "+proj=longlat +ellps=bessel +towgs84=508.088,-191.042,565.223,0,0,0,0 +no_defs "
  },
  {
    "name": "IKBD-92",
    "code": 4667,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "ED79",
    "code": 4668,
    "projection": "+proj=longlat +ellps=intl +towgs84=-86,-98,-119,0,0,0,0 +no_defs "
  },
  {
    "name": "LKS94",
    "code": 4669,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "IGM95",
    "code": 4670,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Voirol 1879",
    "code": 4671,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +no_defs "
  },
  {
    "name": "Chatham Islands 1971",
    "code": 4672,
    "projection": "+proj=longlat +ellps=intl +towgs84=175,-38,113,0,0,0,0 +no_defs "
  },
  {
    "name": "Chatham Islands 1979",
    "code": 4673,
    "projection": "+proj=longlat +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +no_defs "
  },
  {
    "name": "SIRGAS 2000",
    "code": 4674,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Guam 1963",
    "code": 4675,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-100,-248,259,0,0,0,0 +no_defs "
  },
  {
    "name": "Vientiane 1982",
    "code": 4676,
    "projection": "+proj=longlat +ellps=krass +no_defs "
  },
  {
    "name": "Lao 1993",
    "code": 4677,
    "projection": "+proj=longlat +ellps=krass +no_defs "
  },
  {
    "name": "Lao 1997",
    "code": 4678,
    "projection": "+proj=longlat +ellps=krass +towgs84=44.585,-131.212,-39.544,0,0,0,0 +no_defs "
  },
  {
    "name": "Jouik 1961",
    "code": 4679,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-80.01,253.26,291.19,0,0,0,0 +no_defs "
  },
  {
    "name": "Nouakchott 1965",
    "code": 4680,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=124.5,-63.5,-281,0,0,0,0 +no_defs "
  },
  {
    "name": "Mauritania 1999",
    "code": 4681,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Gulshan 303",
    "code": 4682,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=283.7,735.9,261.1,0,0,0,0 +no_defs "
  },
  {
    "name": "PRS92",
    "code": 4683,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +no_defs "
  },
  {
    "name": "Gan 1970",
    "code": 4684,
    "projection": "+proj=longlat +ellps=intl +towgs84=-133,-321,50,0,0,0,0 +no_defs "
  },
  {
    "name": "Gandajika",
    "code": 4685,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS",
    "code": 4686,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "RGPF",
    "code": 4687,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +no_defs "
  },
  {
    "name": "Fatu Iva 72",
    "code": 4688,
    "projection": "+proj=longlat +ellps=intl +towgs84=347.103,1078.125,2623.922,-33.8875,70.6773,-9.3943,186.074 +no_defs "
  },
  {
    "name": "IGN63 Hiva Oa",
    "code": 4689,
    "projection": "+proj=longlat +ellps=intl +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311 +no_defs "
  },
  {
    "name": "Tahiti 79",
    "code": 4690,
    "projection": "+proj=longlat +ellps=intl +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741 +no_defs "
  },
  {
    "name": "Moorea 87",
    "code": 4691,
    "projection": "+proj=longlat +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +no_defs "
  },
  {
    "name": "Maupiti 83",
    "code": 4692,
    "projection": "+proj=longlat +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +no_defs "
  },
  {
    "name": "Nakhl-e Ghanem",
    "code": 4693,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,-0.15,0.68,0,0,0,0 +no_defs "
  },
  {
    "name": "POSGAR 94",
    "code": 4694,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Katanga 1955",
    "code": 4695,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +no_defs "
  },
  {
    "name": "Kasai 1953",
    "code": 4696,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "IGC 1962 6th Parallel South",
    "code": 4697,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "IGN 1962 Kerguelen",
    "code": 4698,
    "projection": "+proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs "
  },
  {
    "name": "Le Pouce 1934",
    "code": 4699,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +no_defs "
  },
  {
    "name": "IGN Astro 1960",
    "code": 4700,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "IGCB 1955",
    "code": 4701,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +no_defs "
  },
  {
    "name": "Mauritania 1999",
    "code": 4702,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Mhast 1951",
    "code": 4703,
    "projection": "+proj=longlat +ellps=clrk80 +no_defs "
  },
  {
    "name": "Mhast (onshore)",
    "code": 4704,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Mhast (offshore)",
    "code": 4705,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Egypt Gulf of Suez S-650 TL",
    "code": 4706,
    "projection": "+proj=longlat +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +no_defs "
  },
  {
    "name": "Tern Island 1961",
    "code": 4707,
    "projection": "+proj=longlat +ellps=intl +towgs84=114,-116,-333,0,0,0,0 +no_defs "
  },
  {
    "name": "Cocos Islands 1965",
    "code": 4708,
    "projection": "+proj=longlat +ellps=aust_SA +towgs84=-491,-22,435,0,0,0,0 +no_defs "
  },
  {
    "name": "Iwo Jima 1945",
    "code": 4709,
    "projection": "+proj=longlat +ellps=intl +towgs84=145,75,-272,0,0,0,0 +no_defs "
  },
  {
    "name": "Astro DOS 71",
    "code": 4710,
    "projection": "+proj=longlat +ellps=intl +towgs84=-320,550,-494,0,0,0,0 +no_defs "
  },
  {
    "name": "Marcus Island 1952",
    "code": 4711,
    "projection": "+proj=longlat +ellps=intl +towgs84=124,-234,-25,0,0,0,0 +no_defs "
  },
  {
    "name": "Ascension Island 1958",
    "code": 4712,
    "projection": "+proj=longlat +ellps=intl +towgs84=-205,107,53,0,0,0,0 +no_defs "
  },
  {
    "name": "Ayabelle Lighthouse",
    "code": 4713,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-77,-128,142,0,0,0,0 +no_defs "
  },
  {
    "name": "Bellevue",
    "code": 4714,
    "projection": "+proj=longlat +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +no_defs "
  },
  {
    "name": "Camp Area Astro",
    "code": 4715,
    "projection": "+proj=longlat +ellps=intl +towgs84=-104,-129,239,0,0,0,0 +no_defs "
  },
  {
    "name": "Phoenix Islands 1966",
    "code": 4716,
    "projection": "+proj=longlat +ellps=intl +towgs84=298,-304,-375,0,0,0,0 +no_defs "
  },
  {
    "name": "Cape Canaveral",
    "code": 4717,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-2,151,181,0,0,0,0 +no_defs "
  },
  {
    "name": "Solomon 1968",
    "code": 4718,
    "projection": "+proj=longlat +ellps=intl +towgs84=230,-199,-752,0,0,0,0 +no_defs "
  },
  {
    "name": "Easter Island 1967",
    "code": 4719,
    "projection": "+proj=longlat +ellps=intl +towgs84=211,147,111,0,0,0,0 +no_defs "
  },
  {
    "name": "Fiji 1986",
    "code": 4720,
    "projection": "+proj=longlat +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +no_defs "
  },
  {
    "name": "Fiji 1956",
    "code": 4721,
    "projection": "+proj=longlat +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +no_defs "
  },
  {
    "name": "South Georgia 1968",
    "code": 4722,
    "projection": "+proj=longlat +ellps=intl +towgs84=-794,119,-298,0,0,0,0 +no_defs "
  },
  {
    "name": "GCGD59",
    "code": 4723,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +no_defs "
  },
  {
    "name": "Diego Garcia 1969",
    "code": 4724,
    "projection": "+proj=longlat +ellps=intl +towgs84=208,-435,-229,0,0,0,0 +no_defs "
  },
  {
    "name": "Johnston Island 1961",
    "code": 4725,
    "projection": "+proj=longlat +ellps=intl +towgs84=189,-79,-202,0,0,0,0 +no_defs "
  },
  {
    "name": "SIGD61",
    "code": 4726,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +no_defs "
  },
  {
    "name": "Midway 1961",
    "code": 4727,
    "projection": "+proj=longlat +ellps=intl +towgs84=403,-81,277,0,0,0,0 +no_defs "
  },
  {
    "name": "Pico de las Nieves 1984",
    "code": 4728,
    "projection": "+proj=longlat +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +no_defs "
  },
  {
    "name": "Pitcairn 1967",
    "code": 4729,
    "projection": "+proj=longlat +ellps=intl +towgs84=185,165,42,0,0,0,0 +no_defs "
  },
  {
    "name": "Santo 1965",
    "code": 4730,
    "projection": "+proj=longlat +ellps=intl +towgs84=170,42,84,0,0,0,0 +no_defs "
  },
  {
    "name": "Viti Levu 1916",
    "code": 4731,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=51,391,-36,0,0,0,0 +no_defs "
  },
  {
    "name": "Marshall Islands 1960",
    "code": 4732,
    "projection": "+proj=longlat +a=6378270 +b=6356794.343434343 +towgs84=102,52,-38,0,0,0,0 +no_defs "
  },
  {
    "name": "Wake Island 1952",
    "code": 4733,
    "projection": "+proj=longlat +ellps=intl +towgs84=276,-57,149,0,0,0,0 +no_defs "
  },
  {
    "name": "Tristan 1968",
    "code": 4734,
    "projection": "+proj=longlat +ellps=intl +towgs84=-632,438,-609,0,0,0,0 +no_defs "
  },
  {
    "name": "Kusaie 1951",
    "code": 4735,
    "projection": "+proj=longlat +ellps=intl +towgs84=647,1777,-1124,0,0,0,0 +no_defs "
  },
  {
    "name": "Deception Island",
    "code": 4736,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=260,12,-147,0,0,0,0 +no_defs "
  },
  {
    "name": "Korea 2000",
    "code": 4737,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Hong Kong 1963",
    "code": 4738,
    "projection": "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs "
  },
  {
    "name": "Hong Kong 1963(67)",
    "code": 4739,
    "projection": "+proj=longlat +ellps=intl +towgs84=-156,-271,-189,0,0,0,0 +no_defs "
  },
  {
    "name": "PZ-90",
    "code": 4740,
    "projection": "+proj=longlat +a=6378136 +b=6356751.361745712 +towgs84=0,0,1.5,0,0,0.076,0 +no_defs "
  },
  {
    "name": "FD54",
    "code": 4741,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "GDM2000",
    "code": 4742,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "Karbala 1979",
    "code": 4743,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +no_defs "
  },
  {
    "name": "Nahrwan 1934",
    "code": 4744,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +no_defs "
  },
  {
    "name": "RD/83",
    "code": 4745,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "PD/83",
    "code": 4746,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "GR96",
    "code": 4747,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Vanua Levu 1915",
    "code": 4748,
    "projection": "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=51,391,-36,0,0,0,0 +no_defs "
  },
  {
    "name": "RGNC91-93",
    "code": 4749,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "ST87 Ouvea",
    "code": 4750,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +no_defs "
  },
  {
    "name": "Kertau (RSO)",
    "code": 4751,
    "projection": "+proj=longlat +a=6377295.664 +b=6356094.667915204 +no_defs "
  },
  {
    "name": "Viti Levu 1912",
    "code": 4752,
    "projection": "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +no_defs "
  },
  {
    "name": "fk89",
    "code": 4753,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "LGD2006",
    "code": 4754,
    "projection": "+proj=longlat +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +no_defs "
  },
  {
    "name": "DGN95",
    "code": 4755,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "VN-2000",
    "code": 4756,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +no_defs "
  },
  {
    "name": "SVY21",
    "code": 4757,
    "projection": "+proj=longlat +ellps=WGS84 +no_defs "
  },
  {
    "name": "JAD2001",
    "code": 4758,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD83(NSRS2007)",
    "code": 4759,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "WGS 66",
    "code": 4760,
    "projection": "+proj=longlat +ellps=WGS66 +no_defs "
  },
  {
    "name": "HTRS96",
    "code": 4761,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "BDA2000",
    "code": 4762,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Pitcairn 2006",
    "code": 4763,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "RSRGD2000",
    "code": 4764,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Slovenia 1996",
    "code": 4765,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Bern 1898 (Bern)",
    "code": 4801,
    "projection": "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +pm=bern +no_defs "
  },
  {
    "name": "Bogota 1975 (Bogota)",
    "code": 4802,
    "projection": "+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +pm=bogota +no_defs "
  },
  {
    "name": "Lisbon (Lisbon)",
    "code": 4803,
    "projection": "+proj=longlat +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +no_defs "
  },
  {
    "name": "Makassar (Jakarta)",
    "code": 4804,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +no_defs "
  },
  {
    "name": "MGI (Ferro)",
    "code": 4805,
    "projection": "+proj=longlat +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +no_defs "
  },
  {
    "name": "Monte Mario (Rome)",
    "code": 4806,
    "projection": "+proj=longlat +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +no_defs "
  },
  {
    "name": "NTF (Paris)",
    "code": 4807,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +no_defs "
  },
  {
    "name": "Padang (Jakarta)",
    "code": 4808,
    "projection": "+proj=longlat +ellps=bessel +pm=jakarta +no_defs "
  },
  {
    "name": "Belge 1950 (Brussels)",
    "code": 4809,
    "projection": "+proj=longlat +ellps=intl +pm=brussels +no_defs "
  },
  {
    "name": "Tananarive (Paris)",
    "code": 4810,
    "projection": "+proj=longlat +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +no_defs "
  },
  {
    "name": "Voirol 1875 (Paris)",
    "code": 4811,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +pm=paris +no_defs "
  },
  {
    "name": "Batavia (Jakarta)",
    "code": 4813,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +no_defs "
  },
  {
    "name": "RT38 (Stockholm)",
    "code": 4814,
    "projection": "+proj=longlat +ellps=bessel +pm=stockholm +no_defs "
  },
  {
    "name": "Greek (Athens)",
    "code": 4815,
    "projection": "+proj=longlat +ellps=bessel +pm=athens +no_defs "
  },
  {
    "name": "Carthage (Paris)",
    "code": 4816,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-263,6,431,0,0,0,0 +pm=paris +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo)",
    "code": 4817,
    "projection": "+proj=longlat +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +no_defs "
  },
  {
    "name": "S-JTSK (Ferro)",
    "code": 4818,
    "projection": "+proj=longlat +ellps=bessel +towgs84=589,76,480,0,0,0,0 +pm=ferro +no_defs "
  },
  {
    "name": "Nord Sahara 1959 (Paris)",
    "code": 4819,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +pm=paris +no_defs "
  },
  {
    "name": "Segara (Jakarta)",
    "code": 4820,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +no_defs "
  },
  {
    "name": "Voirol 1879 (Paris)",
    "code": 4821,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +pm=paris +no_defs "
  },
  {
    "name": "Sao Tome",
    "code": 4823,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "Principe",
    "code": 4824,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "ATF (Paris)",
    "code": 4901,
    "projection": "+proj=longlat +a=6376523 +b=6355862.933255573 +pm=2.337208333333333 +no_defs "
  },
  {
    "name": "NDG (Paris)",
    "code": 4902,
    "projection": "+proj=longlat +a=6376523 +b=6355862.933255573 +pm=paris +no_defs "
  },
  {
    "name": "Madrid 1870 (Madrid)",
    "code": 4903,
    "projection": "+proj=longlat +a=6378298.3 +b=6356657.142669561 +pm=madrid +no_defs "
  },
  {
    "name": "Lisbon 1890 (Lisbon)",
    "code": 4904,
    "projection": "+proj=longlat +ellps=bessel +towgs84=508.088,-191.042,565.223,0,0,0,0 +pm=lisbon +no_defs "
  },
  {
    "name": "PTRA08",
    "code": 5013,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Tokyo 1892",
    "code": 5132,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "S-JTSK/05",
    "code": 5228,
    "projection": "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs "
  },
  {
    "name": "S-JTSK/05 (Ferro)",
    "code": 5229,
    "projection": "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +pm=ferro +no_defs "
  },
  {
    "name": "SLD99",
    "code": 5233,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +no_defs "
  },
  {
    "name": "GDBD2009",
    "code": 5246,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "TUREF",
    "code": 5252,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "DRUKREF 03",
    "code": 5264,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "ISN2004",
    "code": 5324,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "POSGAR 2007",
    "code": 5340,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "MARGEN",
    "code": 5354,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "SIRGAS-Chile",
    "code": 5360,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "CR05",
    "code": 5365,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "MACARIO SOLIS",
    "code": 5371,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Peru96",
    "code": 5373,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "SIRGAS-ROU98",
    "code": 5381,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "SIRGAS_ES2007.8",
    "code": 5393,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Ocotepeque 1935",
    "code": 5451,
    "projection": "+proj=longlat +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +no_defs "
  },
  {
    "name": "Sibun Gorge 1922",
    "code": 5464,
    "projection": "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs "
  },
  {
    "name": "Panama-Colon 1911",
    "code": 5467,
    "projection": "+proj=longlat +ellps=clrk66 +no_defs "
  },
  {
    "name": "RGAF09",
    "code": 5489,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Corrego Alegre 1961",
    "code": 5524,
    "projection": "+proj=longlat +ellps=intl +no_defs "
  },
  {
    "name": "SAD69(96)",
    "code": 5527,
    "projection": "+proj=longlat +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +no_defs "
  },
  {
    "name": "PNG94",
    "code": 5546,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "UCS-2000",
    "code": 5561,
    "projection": "+proj=longlat +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +no_defs "
  },
  {
    "name": "FEH2010",
    "code": 5593,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "DB_REF",
    "code": 5681,
    "projection": "+proj=longlat +ellps=bessel +no_defs "
  },
  {
    "name": "TGD2005",
    "code": 5886,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "CIGD11",
    "code": 6135,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Nepal 1981",
    "code": 6207,
    "projection": "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=293.17,726.18,245.36,0,0,0,0 +no_defs "
  },
  {
    "name": "CGRS93",
    "code": 6311,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +no_defs "
  },
  {
    "name": "NAD83(2011)",
    "code": 6318,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "NAD83(PA11)",
    "code": 6322,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "NAD83(MA11)",
    "code": 6325,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "Mexico ITRF2008",
    "code": 6365,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "JGD2011",
    "code": 6668,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RDN2008",
    "code": 6706,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "NAD83(CORS96)",
    "code": 6783,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "Aden 1925",
    "code": 6881,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-24,-203,268,0,0,0,0 +no_defs "
  },
  {
    "name": "Bekaa Valley 1920",
    "code": 6882,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-183,-15,273,0,0,0,0 +no_defs "
  },
  {
    "name": "Bioko",
    "code": 6883,
    "projection": "+proj=longlat +ellps=intl +towgs84=-235,-110,393,0,0,0,0 +no_defs "
  },
  {
    "name": "South East Island 1943",
    "code": 6892,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-43.685,-179.785,-267.721,0,0,0,0 +no_defs "
  },
  {
    "name": "Gambia",
    "code": 6894,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-63,176,185,0,0,0,0 +no_defs "
  },
  {
    "name": "IGD05",
    "code": 6980,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "IG05 Intermediate CRS",
    "code": 6983,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "IGD05/12",
    "code": 6987,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "IG05/12 Intermediate CRS",
    "code": 6990,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGSPM06 (lon-lat)",
    "code": 7035,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGR92 (lon-lat)",
    "code": 7037,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGM04 (lon-lat)",
    "code": 7039,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGFG95 (lon-lat)",
    "code": 7041,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGTAAF07",
    "code": 7073,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGF93 (lon-lat)",
    "code": 7084,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGAF09 (lon-lat)",
    "code": 7086,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGTAAF07 (lon-lat)",
    "code": 7088,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "RGTAAF07 (lon-lat)",
    "code": 7133,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "IGD05",
    "code": 7136,
    "projection": "+proj=longlat +ellps=WGS84 +no_defs "
  },
  {
    "name": "IGD05/12",
    "code": 7139,
    "projection": "+proj=longlat +ellps=WGS84 +no_defs "
  },
  {
    "name": "ONGD14",
    "code": 7373,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "GSK-2011",
    "code": 7683,
    "projection": "+proj=longlat +a=6378136.5 +b=6356751.757955603 +no_defs "
  },
  {
    "name": "Kyrg-06",
    "code": 7686,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "BGS2005",
    "code": 7798,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "GDA2020",
    "code": 7844,
    "projection": "+proj=longlat +ellps=GRS80 +no_defs "
  },
  {
    "name": "St. Helena Tritan",
    "code": 7881,
    "projection": "+proj=longlat +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +no_defs "
  },
  {
    "name": "SHGD2015",
    "code": 7886,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs "
  },
  {
    "name": "Anguilla 1957 / British West Indies Grid",
    "code": 2000,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Antigua 1943 / British West Indies Grid",
    "code": 2001,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=-255,-15,71,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Dominica 1945 / British West Indies Grid",
    "code": 2002,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=725,685,536,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Grenada 1953 / British West Indies Grid",
    "code": 2003,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=72,213.7,93,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Montserrat 1958 / British West Indies Grid",
    "code": 2004,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=174,359,365,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "St. Kitts 1955 / British West Indies Grid",
    "code": 2005,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=9,183,236,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "St. Lucia 1955 / British West Indies Grid",
    "code": 2006,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=-149,128,296,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "St. Vincent 45 / British West Indies Grid",
    "code": 2007,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=195.671,332.517,274.607,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 2 (deprecated)",
    "code": 2008,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 3",
    "code": 2009,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 4",
    "code": 2010,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 5",
    "code": 2011,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 6",
    "code": 2012,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 7",
    "code": 2013,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 8",
    "code": 2014,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 9",
    "code": 2015,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / SCoPQ zone 10",
    "code": 2016,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 8",
    "code": 2017,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 9",
    "code": 2018,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 10",
    "code": 2019,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 11",
    "code": 2020,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 12",
    "code": 2021,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 13",
    "code": 2022,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 14",
    "code": 2023,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 15",
    "code": 2024,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 16",
    "code": 2025,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / MTM zone 17",
    "code": 2026,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / UTM zone 15N",
    "code": 2027,
    "projection": "+proj=utm +zone=15 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / UTM zone 16N",
    "code": 2028,
    "projection": "+proj=utm +zone=16 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / UTM zone 17N",
    "code": 2029,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(76) / UTM zone 18N",
    "code": 2030,
    "projection": "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / UTM zone 17N",
    "code": 2031,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / UTM zone 18N",
    "code": 2032,
    "projection": "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / UTM zone 19N",
    "code": 2033,
    "projection": "+proj=utm +zone=19 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / UTM zone 20N",
    "code": 2034,
    "projection": "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / UTM zone 21N",
    "code": 2035,
    "projection": "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / New Brunswick Stereo (deprecated)",
    "code": 2036,
    "projection": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 19N (deprecated)",
    "code": 2037,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 20N (deprecated)",
    "code": 2038,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Israel 1993 / Israeli TM Grid",
    "code": 2039,
    "projection": "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +towgs84=-48,55,52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Locodjo 1965 / UTM zone 30N",
    "code": 2040,
    "projection": "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Abidjan 1987 / UTM zone 30N",
    "code": 2041,
    "projection": "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Locodjo 1965 / UTM zone 29N",
    "code": 2042,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Abidjan 1987 / UTM zone 29N",
    "code": 2043,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hanoi 1972 / Gauss-Kruger zone 18",
    "code": 2044,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hanoi 1972 / Gauss-Kruger zone 19",
    "code": 2045,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo15",
    "code": 2046,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo17",
    "code": 2047,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo19",
    "code": 2048,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo21",
    "code": 2049,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo23",
    "code": 2050,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo25",
    "code": 2051,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo27",
    "code": 2052,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo29",
    "code": 2053,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo31",
    "code": 2054,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 / Lo33",
    "code": 2055,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CH1903+ / LV95",
    "code": 2056,
    "projection": "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Rassadiran / Nakhl e Taqi",
    "code": 2057,
    "projection": "+proj=omerc +lat_0=27.51882880555555 +lonc=52.60353916666667 +alpha=0.5716611944444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +gamma=0.5716611944444444 +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50(ED77) / UTM zone 38N",
    "code": 2058,
    "projection": "+proj=utm +zone=38 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50(ED77) / UTM zone 39N",
    "code": 2059,
    "projection": "+proj=utm +zone=39 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50(ED77) / UTM zone 40N",
    "code": 2060,
    "projection": "+proj=utm +zone=40 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50(ED77) / UTM zone 41N",
    "code": 2061,
    "projection": "+proj=utm +zone=41 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Madrid 1870 (Madrid) / Spain",
    "code": 2062,
    "projection": "+proj=lcc +lat_1=40 +lat_0=40 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000 +a=6378298.3 +b=6356657.142669561 +pm=madrid +units=m +no_defs "
  },
  {
    "name": "Dabola 1981 / UTM zone 28N (deprecated)",
    "code": 2063,
    "projection": "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Dabola 1981 / UTM zone 29N (deprecated)",
    "code": 2064,
    "projection": "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "S-JTSK (Ferro) / Krovak",
    "code": 2065,
    "projection": "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "Mount Dillon / Tobago Grid",
    "code": 2066,
    "projection": "+proj=cass +lat_0=11.25217861111111 +lon_0=-60.68600888888889 +x_0=37718.66159325 +y_0=36209.91512952 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.201166195164 +no_defs "
  },
  {
    "name": "Naparima 1955 / UTM zone 20N",
    "code": 2067,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=-0.465,372.095,171.736,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 5",
    "code": 2068,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 6",
    "code": 2069,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 7",
    "code": 2070,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 8",
    "code": 2071,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 9",
    "code": 2072,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 10",
    "code": 2073,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 11",
    "code": 2074,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 12",
    "code": 2075,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / Libya zone 13",
    "code": 2076,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / UTM zone 32N",
    "code": 2077,
    "projection": "+proj=utm +zone=32 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / UTM zone 33N",
    "code": 2078,
    "projection": "+proj=utm +zone=33 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / UTM zone 34N",
    "code": 2079,
    "projection": "+proj=utm +zone=34 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ELD79 / UTM zone 35N",
    "code": 2080,
    "projection": "+proj=utm +zone=35 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Chos Malal 1914 / Argentina 2",
    "code": 2081,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Pampa del Castillo / Argentina 2",
    "code": 2082,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=27.5,14,186.4,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hito XVIII 1963 / Argentina 2",
    "code": 2083,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=16,196,93,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hito XVIII 1963 / UTM zone 19S",
    "code": 2084,
    "projection": "+proj=utm +zone=19 +south +ellps=intl +towgs84=16,196,93,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Cuba Norte (deprecated)",
    "code": 2085,
    "projection": "+proj=lcc +lat_1=22.35 +lat_0=22.35 +lon_0=-81 +k_0=0.99993602 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Cuba Sur (deprecated)",
    "code": 2086,
    "projection": "+proj=lcc +lat_1=20.71666666666667 +lat_0=20.71666666666667 +lon_0=-76.83333333333333 +k_0=0.99994848 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "ELD79 / TM 12 NE",
    "code": 2087,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Carthage / TM 11 NE",
    "code": 2088,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9996 +x_0=500000 +y_0=0 +datum=carthage +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96 / UTM zone 38N",
    "code": 2089,
    "projection": "+proj=utm +zone=38 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96 / UTM zone 39N",
    "code": 2090,
    "projection": "+proj=utm +zone=39 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "South Yemen / Gauss Kruger zone 8 (deprecated)",
    "code": 2091,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "South Yemen / Gauss Kruger zone 9 (deprecated)",
    "code": 2092,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hanoi 1972 / GK 106 NE",
    "code": 2093,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=106 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / TM 106 NE",
    "code": 2094,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "Bissau / UTM zone 28N",
    "code": 2095,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-173,253,27,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / East Belt",
    "code": 2096,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Central Belt",
    "code": 2097,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / West Belt",
    "code": 2098,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Qatar 1948 / Qatar Grid",
    "code": 2099,
    "projection": "+proj=cass +lat_0=25.38236111111111 +lon_0=50.76138888888889 +x_0=100000 +y_0=100000 +ellps=helmert +units=m +no_defs "
  },
  {
    "name": "GGRS87 / Greek Grid",
    "code": 2100,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +datum=GGRS87 +units=m +no_defs "
  },
  {
    "name": "Lake / Maracaibo Grid M1",
    "code": 2101,
    "projection": "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=0 +y_0=-52684.972 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Lake / Maracaibo Grid",
    "code": 2102,
    "projection": "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=200000 +y_0=147315.028 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Lake / Maracaibo Grid M3",
    "code": 2103,
    "projection": "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=500000 +y_0=447315.028 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Lake / Maracaibo La Rosa Grid",
    "code": 2104,
    "projection": "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=-17044 +y_0=-23139.97 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Mount Eden 2000",
    "code": 2105,
    "projection": "+proj=tmerc +lat_0=-36.87972222222222 +lon_0=174.7641666666667 +k=0.9999 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Bay of Plenty 2000",
    "code": 2106,
    "projection": "+proj=tmerc +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Poverty Bay 2000",
    "code": 2107,
    "projection": "+proj=tmerc +lat_0=-38.62444444444444 +lon_0=177.8855555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Hawkes Bay 2000",
    "code": 2108,
    "projection": "+proj=tmerc +lat_0=-39.65083333333333 +lon_0=176.6736111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Taranaki 2000",
    "code": 2109,
    "projection": "+proj=tmerc +lat_0=-39.13555555555556 +lon_0=174.2277777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Tuhirangi 2000",
    "code": 2110,
    "projection": "+proj=tmerc +lat_0=-39.51222222222222 +lon_0=175.64 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Wanganui 2000",
    "code": 2111,
    "projection": "+proj=tmerc +lat_0=-40.24194444444444 +lon_0=175.4880555555555 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Wairarapa 2000",
    "code": 2112,
    "projection": "+proj=tmerc +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Wellington 2000",
    "code": 2113,
    "projection": "+proj=tmerc +lat_0=-41.3011111111111 +lon_0=174.7763888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Collingwood 2000",
    "code": 2114,
    "projection": "+proj=tmerc +lat_0=-40.71472222222223 +lon_0=172.6719444444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Nelson 2000",
    "code": 2115,
    "projection": "+proj=tmerc +lat_0=-41.27444444444444 +lon_0=173.2991666666667 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Karamea 2000",
    "code": 2116,
    "projection": "+proj=tmerc +lat_0=-41.28972222222222 +lon_0=172.1088888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Buller 2000",
    "code": 2117,
    "projection": "+proj=tmerc +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Grey 2000",
    "code": 2118,
    "projection": "+proj=tmerc +lat_0=-42.33361111111111 +lon_0=171.5497222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Amuri 2000",
    "code": 2119,
    "projection": "+proj=tmerc +lat_0=-42.68888888888888 +lon_0=173.01 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Marlborough 2000",
    "code": 2120,
    "projection": "+proj=tmerc +lat_0=-41.54444444444444 +lon_0=173.8019444444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Hokitika 2000",
    "code": 2121,
    "projection": "+proj=tmerc +lat_0=-42.88611111111111 +lon_0=170.9797222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Okarito 2000",
    "code": 2122,
    "projection": "+proj=tmerc +lat_0=-43.11 +lon_0=170.2608333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Jacksons Bay 2000",
    "code": 2123,
    "projection": "+proj=tmerc +lat_0=-43.97777777777778 +lon_0=168.6061111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Mount Pleasant 2000",
    "code": 2124,
    "projection": "+proj=tmerc +lat_0=-43.59055555555556 +lon_0=172.7269444444445 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Gawler 2000",
    "code": 2125,
    "projection": "+proj=tmerc +lat_0=-43.74861111111111 +lon_0=171.3605555555555 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Timaru 2000",
    "code": 2126,
    "projection": "+proj=tmerc +lat_0=-44.40194444444445 +lon_0=171.0572222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Lindis Peak 2000",
    "code": 2127,
    "projection": "+proj=tmerc +lat_0=-44.735 +lon_0=169.4675 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Mount Nicholas 2000",
    "code": 2128,
    "projection": "+proj=tmerc +lat_0=-45.13277777777778 +lon_0=168.3986111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Mount York 2000",
    "code": 2129,
    "projection": "+proj=tmerc +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Observation Point 2000",
    "code": 2130,
    "projection": "+proj=tmerc +lat_0=-45.81611111111111 +lon_0=170.6283333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / North Taieri 2000",
    "code": 2131,
    "projection": "+proj=tmerc +lat_0=-45.86138888888889 +lon_0=170.2825 +k=0.99996 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Bluff 2000",
    "code": 2132,
    "projection": "+proj=tmerc +lat_0=-46.6 +lon_0=168.3427777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / UTM zone 58S",
    "code": 2133,
    "projection": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / UTM zone 59S",
    "code": 2134,
    "projection": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / UTM zone 60S",
    "code": 2135,
    "projection": "+proj=utm +zone=60 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Accra / Ghana National Grid",
    "code": 2136,
    "projection": "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.7391633579 +y_0=0 +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +to_meter=0.3047997101815088 +no_defs "
  },
  {
    "name": "Accra / TM 1 NW",
    "code": 2137,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-1 +k=0.9996 +x_0=500000 +y_0=0 +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27(CGQ77) / Quebec Lambert",
    "code": 2138,
    "projection": "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / SCoPQ zone 2 (deprecated)",
    "code": 2139,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 3 (deprecated)",
    "code": 2140,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 4 (deprecated)",
    "code": 2141,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 5 (deprecated)",
    "code": 2142,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 6 (deprecated)",
    "code": 2143,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 7 (deprecated)",
    "code": 2144,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 8 (deprecated)",
    "code": 2145,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 9 (deprecated)",
    "code": 2146,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / MTM zone 10 (deprecated)",
    "code": 2147,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 21N (deprecated)",
    "code": 2148,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 18N (deprecated)",
    "code": 2149,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 17N (deprecated)",
    "code": 2150,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 13N (deprecated)",
    "code": 2151,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 12N (deprecated)",
    "code": 2152,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / UTM zone 11N (deprecated)",
    "code": 2153,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / Lambert-93",
    "code": 2154,
    "projection": "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "American Samoa 1962 / American Samoa Lambert (deprecated)",
    "code": 2155,
    "projection": "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=170 +k_0=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 59S (deprecated)",
    "code": 2156,
    "projection": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IRENET95 / Irish Transverse Mercator",
    "code": 2157,
    "projection": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IRENET95 / UTM zone 29N",
    "code": 2158,
    "projection": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Sierra Leone 1924 / New Colony Grid",
    "code": 2159,
    "projection": "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k=1 +x_0=152399.8550907544 +y_0=0 +a=6378300 +b=6356751.689189189 +to_meter=0.3047997101815088 +no_defs "
  },
  {
    "name": "Sierra Leone 1924 / New War Office Grid",
    "code": 2160,
    "projection": "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k=1 +x_0=243839.7681452071 +y_0=182879.8261089053 +a=6378300 +b=6356751.689189189 +to_meter=0.3047997101815088 +no_defs "
  },
  {
    "name": "Sierra Leone 1968 / UTM zone 28N",
    "code": 2161,
    "projection": "+proj=utm +zone=28 +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Sierra Leone 1968 / UTM zone 29N",
    "code": 2162,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "US National Atlas Equal Area",
    "code": 2163,
    "projection": "+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 +a=6370997 +b=6370997 +units=m +no_defs "
  },
  {
    "name": "Locodjo 1965 / TM 5 NW",
    "code": 2164,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Abidjan 1987 / TM 5 NW",
    "code": 2165,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss Kruger zone 3 (deprecated)",
    "code": 2166,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss Kruger zone 4 (deprecated)",
    "code": 2167,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss Kruger zone 5 (deprecated)",
    "code": 2168,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Luxembourg 1930 / Gauss",
    "code": 2169,
    "projection": "+proj=tmerc +lat_0=49.83333333333334 +lon_0=6.166666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +units=m +no_defs "
  },
  {
    "name": "MGI / Slovenia Grid (deprecated)",
    "code": 2170,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone I (deprecated)",
    "code": 2171,
    "projection": "+proj=sterea +lat_0=50.625 +lon_0=21.08333333333333 +k=0.9998 +x_0=4637000 +y_0=5647000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone II",
    "code": 2172,
    "projection": "+proj=sterea +lat_0=53.00194444444445 +lon_0=21.50277777777778 +k=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone III",
    "code": 2173,
    "projection": "+proj=sterea +lat_0=53.58333333333334 +lon_0=17.00833333333333 +k=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone IV",
    "code": 2174,
    "projection": "+proj=sterea +lat_0=51.67083333333333 +lon_0=16.67222222222222 +k=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone V",
    "code": 2175,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Poland CS2000 zone 5",
    "code": 2176,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Poland CS2000 zone 6",
    "code": 2177,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Poland CS2000 zone 7",
    "code": 2178,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Poland CS2000 zone 8",
    "code": 2179,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Poland CS92",
    "code": 2180,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Azores Occidental 1939 / UTM zone 25N",
    "code": 2188,
    "projection": "+proj=utm +zone=25 +ellps=intl +towgs84=-425,-169,81,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Azores Central 1948 / UTM zone 26N",
    "code": 2189,
    "projection": "+proj=utm +zone=26 +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Azores Oriental 1940 / UTM zone 26N",
    "code": 2190,
    "projection": "+proj=utm +zone=26 +ellps=intl +towgs84=-203,141,53,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Madeira 1936 / UTM zone 28N (deprecated)",
    "code": 2191,
    "projection": "+proj=utm +zone=28 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "ED50 / France EuroLambert (deprecated)",
    "code": 2192,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / New Zealand Transverse Mercator 2000",
    "code": 2193,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "American Samoa 1962 / American Samoa Lambert (deprecated)",
    "code": 2194,
    "projection": "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=-170 +k_0=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 2S",
    "code": 2195,
    "projection": "+proj=utm +zone=2 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Jutland",
    "code": 2196,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Zealand",
    "code": 2197,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Bornholm",
    "code": 2198,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Albanian 1987 / Gauss Kruger zone 4 (deprecated)",
    "code": 2199,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703 +units=m +no_defs "
  },
  {
    "name": "ATS77 / New Brunswick Stereographic (ATS77)",
    "code": 2200,
    "projection": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=300000 +y_0=800000 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "REGVEN / UTM zone 18N",
    "code": 2201,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGVEN / UTM zone 19N",
    "code": 2202,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGVEN / UTM zone 20N",
    "code": 2203,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Tennessee",
    "code": 2204,
    "projection": "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666 +lon_0=-86 +x_0=609601.2192024384 +y_0=30480.06096012192 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Kentucky North",
    "code": 2205,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 9",
    "code": 2206,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 10",
    "code": 2207,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 11",
    "code": 2208,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 12",
    "code": 2209,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 13",
    "code": 2210,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 14",
    "code": 2211,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / 3-degree Gauss-Kruger zone 15",
    "code": 2212,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM 30 NE",
    "code": 2213,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Douala 1948 / AOF west (deprecated)",
    "code": 2214,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Manoca 1962 / UTM zone 32N",
    "code": 2215,
    "projection": "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Qornoq 1927 / UTM zone 22N",
    "code": 2216,
    "projection": "+proj=utm +zone=22 +ellps=intl +towgs84=164,138,-189,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Qornoq 1927 / UTM zone 23N",
    "code": 2217,
    "projection": "+proj=utm +zone=23 +ellps=intl +towgs84=164,138,-189,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ATS77 / UTM zone 19N",
    "code": 2219,
    "projection": "+proj=utm +zone=19 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "ATS77 / UTM zone 20N",
    "code": 2220,
    "projection": "+proj=utm +zone=20 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arizona East (ft)",
    "code": 2222,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Arizona Central (ft)",
    "code": 2223,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Arizona West (ft)",
    "code": 2224,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 1 (ftUS)",
    "code": 2225,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 2 (ftUS)",
    "code": 2226,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 3 (ftUS)",
    "code": 2227,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 4 (ftUS)",
    "code": 2228,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 5 (ftUS)",
    "code": 2229,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / California zone 6 (ftUS)",
    "code": 2230,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Colorado North (ftUS)",
    "code": 2231,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Colorado Central (ftUS)",
    "code": 2232,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Colorado South (ftUS)",
    "code": 2233,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Connecticut (ftUS)",
    "code": 2234,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Delaware (ftUS)",
    "code": 2235,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Florida East (ftUS)",
    "code": 2236,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Florida West (ftUS)",
    "code": 2237,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Florida North (ftUS)",
    "code": 2238,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Georgia East (ftUS)",
    "code": 2239,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Georgia West (ftUS)",
    "code": 2240,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Idaho East (ftUS)",
    "code": 2241,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Idaho Central (ftUS)",
    "code": 2242,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Idaho West (ftUS)",
    "code": 2243,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Indiana East (ftUS) (deprecated)",
    "code": 2244,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249364.9987299975 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Indiana West (ftUS) (deprecated)",
    "code": 2245,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249364.9987299975 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Kentucky North (ftUS)",
    "code": 2246,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Kentucky South (ftUS)",
    "code": 2247,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Maryland (ftUS)",
    "code": 2248,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Massachusetts Mainland (ftUS)",
    "code": 2249,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Massachusetts Island (ftUS)",
    "code": 2250,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Michigan North (ft)",
    "code": 2251,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Michigan Central (ft)",
    "code": 2252,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Michigan South (ft)",
    "code": 2253,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Mississippi East (ftUS)",
    "code": 2254,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Mississippi West (ftUS)",
    "code": 2255,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Montana (ft)",
    "code": 2256,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / New Mexico East (ftUS)",
    "code": 2257,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New Mexico Central (ftUS)",
    "code": 2258,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New Mexico West (ftUS)",
    "code": 2259,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New York East (ftUS)",
    "code": 2260,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New York Central (ftUS)",
    "code": 2261,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New York West (ftUS)",
    "code": 2262,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New York Long Island (ftUS)",
    "code": 2263,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / North Carolina (ftUS)",
    "code": 2264,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / North Dakota North (ft)",
    "code": 2265,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / North Dakota South (ft)",
    "code": 2266,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Oklahoma North (ftUS)",
    "code": 2267,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Oklahoma South (ftUS)",
    "code": 2268,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Oregon North (ft)",
    "code": 2269,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Oregon South (ft)",
    "code": 2270,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Pennsylvania North (ftUS)",
    "code": 2271,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Pennsylvania South (ftUS)",
    "code": 2272,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / South Carolina (ft)",
    "code": 2273,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Tennessee (ftUS)",
    "code": 2274,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Texas North (ftUS)",
    "code": 2275,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Texas North Central (ftUS)",
    "code": 2276,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Texas Central (ftUS)",
    "code": 2277,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Texas South Central (ftUS)",
    "code": 2278,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Texas South (ftUS)",
    "code": 2279,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Utah North (ft)",
    "code": 2280,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Utah Central (ft)",
    "code": 2281,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Utah South (ft)",
    "code": 2282,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Virginia North (ftUS)",
    "code": 2283,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Virginia South (ftUS)",
    "code": 2284,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Washington North (ftUS)",
    "code": 2285,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Washington South (ftUS)",
    "code": 2286,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin North (ftUS)",
    "code": 2287,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin Central (ftUS)",
    "code": 2288,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin South (ftUS)",
    "code": 2289,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "ATS77 / Prince Edward Isl. Stereographic (ATS77)",
    "code": 2290,
    "projection": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=700000 +y_0=400000 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / Prince Edward Isl. Stereographic (NAD83) (deprecated)",
    "code": 2291,
    "projection": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS98) / Prince Edward Isl. Stereographic (NAD83) (deprecated)",
    "code": 2292,
    "projection": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ATS77 / MTM Nova Scotia zone 4",
    "code": 2294,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=4500000 +y_0=0 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "ATS77 / MTM Nova Scotia zone 5",
    "code": 2295,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=5500000 +y_0=0 +a=6378135 +b=6356750.304921594 +units=m +no_defs "
  },
  {
    "name": "Batavia / TM 109 SE",
    "code": 2308,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=109 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 116 SE",
    "code": 2309,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=116 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 132 SE",
    "code": 2310,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 6 NE",
    "code": 2311,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "Garoua / UTM zone 33N",
    "code": 2312,
    "projection": "+proj=utm +zone=33 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Kousseri / UTM zone 33N",
    "code": 2313,
    "projection": "+proj=utm +zone=33 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Trinidad 1903 / Trinidad Grid (ftCla)",
    "code": 2314,
    "projection": "+proj=cass +lat_0=10.44166666666667 +lon_0=-61.33333333333334 +x_0=86501.46392052001 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +to_meter=0.3047972654 +no_defs "
  },
  {
    "name": "Campo Inchauspe / UTM zone 19S",
    "code": 2315,
    "projection": "+proj=utm +zone=19 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / UTM zone 20S",
    "code": 2316,
    "projection": "+proj=utm +zone=20 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / ICN Regional",
    "code": 2317,
    "projection": "+proj=lcc +lat_1=9 +lat_2=3 +lat_0=6 +lon_0=-66 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / Aramco Lambert",
    "code": 2318,
    "projection": "+proj=lcc +lat_1=17 +lat_2=33 +lat_0=25.08951 +lon_0=48 +x_0=0 +y_0=0 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM27",
    "code": 2319,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM30",
    "code": 2320,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM33",
    "code": 2321,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM36",
    "code": 2322,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM39",
    "code": 2323,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM42",
    "code": 2324,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM45",
    "code": 2325,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hong Kong 1980 Grid System",
    "code": 2326,
    "projection": "+proj=tmerc +lat_0=22.31213333333334 +lon_0=114.1785555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 13",
    "code": 2327,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 14",
    "code": 2328,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 15",
    "code": 2329,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 16",
    "code": 2330,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 17",
    "code": 2331,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 18",
    "code": 2332,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 19",
    "code": 2333,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 20",
    "code": 2334,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 21",
    "code": 2335,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 22",
    "code": 2336,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger zone 23",
    "code": 2337,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 75E",
    "code": 2338,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 81E",
    "code": 2339,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 87E",
    "code": 2340,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 93E",
    "code": 2341,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 99E",
    "code": 2342,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 105E",
    "code": 2343,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 111E",
    "code": 2344,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 117E",
    "code": 2345,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 123E",
    "code": 2346,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 129E",
    "code": 2347,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / Gauss-Kruger CM 135E",
    "code": 2348,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 25",
    "code": 2349,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 26",
    "code": 2350,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 27",
    "code": 2351,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 28",
    "code": 2352,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 29",
    "code": 2353,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 30",
    "code": 2354,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 31",
    "code": 2355,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 32",
    "code": 2356,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 33",
    "code": 2357,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 34",
    "code": 2358,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 35",
    "code": 2359,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 36",
    "code": 2360,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 37",
    "code": 2361,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 38",
    "code": 2362,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 39",
    "code": 2363,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 40",
    "code": 2364,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 41",
    "code": 2365,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 42",
    "code": 2366,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 43",
    "code": 2367,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 44",
    "code": 2368,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger zone 45",
    "code": 2369,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 75E",
    "code": 2370,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 78E",
    "code": 2371,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 81E",
    "code": 2372,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 84E",
    "code": 2373,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 87E",
    "code": 2374,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 90E",
    "code": 2375,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 93E",
    "code": 2376,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 96E",
    "code": 2377,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 99E",
    "code": 2378,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 102E",
    "code": 2379,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 105E",
    "code": 2380,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 108E",
    "code": 2381,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 111E",
    "code": 2382,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 114E",
    "code": 2383,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 117E",
    "code": 2384,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 120E",
    "code": 2385,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 123E",
    "code": 2386,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 126E",
    "code": 2387,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 129E",
    "code": 2388,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 132E",
    "code": 2389,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "Xian 1980 / 3-degree Gauss-Kruger CM 135E",
    "code": 2390,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland zone 1",
    "code": 2391,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland zone 2",
    "code": 2392,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland Uniform Coordinate System",
    "code": 2393,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland zone 4",
    "code": 2394,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "South Yemen / Gauss-Kruger zone 8",
    "code": 2395,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "South Yemen / Gauss-Kruger zone 9",
    "code": 2396,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3",
    "code": 2397,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4",
    "code": 2398,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5",
    "code": 2399,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01 +units=m +no_defs "
  },
  {
    "name": "RT90 2.5 gon W (deprecated)",
    "code": 2400,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 25",
    "code": 2401,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 26",
    "code": 2402,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 27",
    "code": 2403,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 28",
    "code": 2404,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 29",
    "code": 2405,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 30",
    "code": 2406,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 31",
    "code": 2407,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 32",
    "code": 2408,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 33",
    "code": 2409,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 34",
    "code": 2410,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 35",
    "code": 2411,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 36",
    "code": 2412,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 37",
    "code": 2413,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 38",
    "code": 2414,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 39",
    "code": 2415,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 40",
    "code": 2416,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 41",
    "code": 2417,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 42",
    "code": 2418,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 43",
    "code": 2419,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 44",
    "code": 2420,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger zone 45",
    "code": 2421,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 75E",
    "code": 2422,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 78E",
    "code": 2423,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 81E",
    "code": 2424,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 84E",
    "code": 2425,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 87E",
    "code": 2426,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 90E",
    "code": 2427,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 93E",
    "code": 2428,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 96E",
    "code": 2429,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 99E",
    "code": 2430,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 102E",
    "code": 2431,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 105E",
    "code": 2432,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 108E",
    "code": 2433,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 111E",
    "code": 2434,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 114E",
    "code": 2435,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 117E",
    "code": 2436,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 120E",
    "code": 2437,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 123E",
    "code": 2438,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 126E",
    "code": 2439,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 129E",
    "code": 2440,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 132E",
    "code": 2441,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / 3-degree Gauss-Kruger CM 135E",
    "code": 2442,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS I",
    "code": 2443,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS II",
    "code": 2444,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS III",
    "code": 2445,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS IV",
    "code": 2446,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS V",
    "code": 2447,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS VI",
    "code": 2448,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS VII",
    "code": 2449,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS VIII",
    "code": 2450,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS IX",
    "code": 2451,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS X",
    "code": 2452,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XI",
    "code": 2453,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XII",
    "code": 2454,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XIII",
    "code": 2455,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XIV",
    "code": 2456,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XV",
    "code": 2457,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XVI",
    "code": 2458,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XVII",
    "code": 2459,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XVIII",
    "code": 2460,
    "projection": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / Japan Plane Rectangular CS XIX",
    "code": 2461,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Albanian 1987 / Gauss-Kruger zone 4",
    "code": 2462,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 21E",
    "code": 2463,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 27E",
    "code": 2464,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 33E",
    "code": 2465,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 39E",
    "code": 2466,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 45E",
    "code": 2467,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 51E",
    "code": 2468,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 57E",
    "code": 2469,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 63E",
    "code": 2470,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 69E",
    "code": 2471,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 75E",
    "code": 2472,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 81E",
    "code": 2473,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 87E",
    "code": 2474,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 93E",
    "code": 2475,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 99E",
    "code": 2476,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 105E",
    "code": 2477,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 111E",
    "code": 2478,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 117E",
    "code": 2479,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 123E",
    "code": 2480,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 129E",
    "code": 2481,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 135E",
    "code": 2482,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 141E",
    "code": 2483,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 147E",
    "code": 2484,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 153E",
    "code": 2485,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 159E",
    "code": 2486,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 165E",
    "code": 2487,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 171E",
    "code": 2488,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 177E",
    "code": 2489,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 177W",
    "code": 2490,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger CM 171W",
    "code": 2491,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 9E (deprecated)",
    "code": 2492,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 15E (deprecated)",
    "code": 2493,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 21E",
    "code": 2494,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 27E",
    "code": 2495,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 33E",
    "code": 2496,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 39E",
    "code": 2497,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 45E",
    "code": 2498,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 51E",
    "code": 2499,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 57E",
    "code": 2500,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 63E",
    "code": 2501,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 69E",
    "code": 2502,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 75E",
    "code": 2503,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 81E",
    "code": 2504,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 87E",
    "code": 2505,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 93E",
    "code": 2506,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 99E",
    "code": 2507,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 105E",
    "code": 2508,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 111E",
    "code": 2509,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 117E",
    "code": 2510,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 123E",
    "code": 2511,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 129E",
    "code": 2512,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 135E",
    "code": 2513,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 141E",
    "code": 2514,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 147E",
    "code": 2515,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 153E",
    "code": 2516,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 159E",
    "code": 2517,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 165E",
    "code": 2518,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 171E",
    "code": 2519,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 177E",
    "code": 2520,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 177W",
    "code": 2521,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger CM 171W",
    "code": 2522,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 7",
    "code": 2523,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 8",
    "code": 2524,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 9",
    "code": 2525,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 10",
    "code": 2526,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 11",
    "code": 2527,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 12",
    "code": 2528,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 13",
    "code": 2529,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 14",
    "code": 2530,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 15",
    "code": 2531,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 16",
    "code": 2532,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 17",
    "code": 2533,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 18",
    "code": 2534,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 19",
    "code": 2535,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 20",
    "code": 2536,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 21",
    "code": 2537,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 22",
    "code": 2538,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 23",
    "code": 2539,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 24",
    "code": 2540,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 25",
    "code": 2541,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 26",
    "code": 2542,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 27",
    "code": 2543,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 28",
    "code": 2544,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 29",
    "code": 2545,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 30",
    "code": 2546,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 31",
    "code": 2547,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 32",
    "code": 2548,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 33",
    "code": 2549,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Samboja / UTM zone 50S (deprecated)",
    "code": 2550,
    "projection": "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-404.78,685.68,45.47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 34",
    "code": 2551,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 35",
    "code": 2552,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 36",
    "code": 2553,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 37",
    "code": 2554,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 38",
    "code": 2555,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 39",
    "code": 2556,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 40",
    "code": 2557,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 41",
    "code": 2558,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 42",
    "code": 2559,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 43",
    "code": 2560,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 44",
    "code": 2561,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 45",
    "code": 2562,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 46",
    "code": 2563,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 47",
    "code": 2564,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 48",
    "code": 2565,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 49",
    "code": 2566,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 50",
    "code": 2567,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 51",
    "code": 2568,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 52",
    "code": 2569,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 53",
    "code": 2570,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 54",
    "code": 2571,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 55",
    "code": 2572,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 56",
    "code": 2573,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 57",
    "code": 2574,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 58",
    "code": 2575,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 59",
    "code": 2576,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 60 (deprecated)",
    "code": 2577,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60000000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 61",
    "code": 2578,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 62",
    "code": 2579,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 63",
    "code": 2580,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 64",
    "code": 2581,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 21E",
    "code": 2582,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 24E",
    "code": 2583,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 27E",
    "code": 2584,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 30E",
    "code": 2585,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 33E",
    "code": 2586,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 36E",
    "code": 2587,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 39E",
    "code": 2588,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 42E",
    "code": 2589,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 45E",
    "code": 2590,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 48E",
    "code": 2591,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 51E",
    "code": 2592,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 54E",
    "code": 2593,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 57E",
    "code": 2594,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 60E",
    "code": 2595,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 63E",
    "code": 2596,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 66E",
    "code": 2597,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 69E",
    "code": 2598,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 72E",
    "code": 2599,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Lietuvos Koordinoei Sistema 1994 (deprecated)",
    "code": 2600,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 75E",
    "code": 2601,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 78E",
    "code": 2602,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 81E",
    "code": 2603,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 84E",
    "code": 2604,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 87E",
    "code": 2605,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 90E",
    "code": 2606,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 93E",
    "code": 2607,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 96E",
    "code": 2608,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 99E",
    "code": 2609,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 102E",
    "code": 2610,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 105E",
    "code": 2611,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 108E",
    "code": 2612,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 111E",
    "code": 2613,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 114E",
    "code": 2614,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 117E",
    "code": 2615,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 120E",
    "code": 2616,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 123E",
    "code": 2617,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 126E",
    "code": 2618,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 129E",
    "code": 2619,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 132E",
    "code": 2620,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 135E",
    "code": 2621,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 138E",
    "code": 2622,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 141E",
    "code": 2623,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 144E",
    "code": 2624,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 147E",
    "code": 2625,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 150E",
    "code": 2626,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 153E",
    "code": 2627,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 156E",
    "code": 2628,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 159E",
    "code": 2629,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 162E",
    "code": 2630,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 165E",
    "code": 2631,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 168E",
    "code": 2632,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 171E",
    "code": 2633,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 174E",
    "code": 2634,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 177E",
    "code": 2635,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 180E",
    "code": 2636,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 177W",
    "code": 2637,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 174W",
    "code": 2638,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 171W",
    "code": 2639,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 168W",
    "code": 2640,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 7",
    "code": 2641,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 8",
    "code": 2642,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 9",
    "code": 2643,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 10",
    "code": 2644,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 11",
    "code": 2645,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 12",
    "code": 2646,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 13",
    "code": 2647,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 14",
    "code": 2648,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 15",
    "code": 2649,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 16",
    "code": 2650,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 17",
    "code": 2651,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 18",
    "code": 2652,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 19",
    "code": 2653,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 20",
    "code": 2654,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 21",
    "code": 2655,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 22",
    "code": 2656,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 23",
    "code": 2657,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 24",
    "code": 2658,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 25",
    "code": 2659,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 26",
    "code": 2660,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 27",
    "code": 2661,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 28",
    "code": 2662,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 29",
    "code": 2663,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 30",
    "code": 2664,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 31",
    "code": 2665,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 32",
    "code": 2666,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 33",
    "code": 2667,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 34",
    "code": 2668,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 35",
    "code": 2669,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 36",
    "code": 2670,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 37",
    "code": 2671,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 38",
    "code": 2672,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 39",
    "code": 2673,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 40",
    "code": 2674,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 41",
    "code": 2675,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 42",
    "code": 2676,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 43",
    "code": 2677,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 44",
    "code": 2678,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 45",
    "code": 2679,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 46",
    "code": 2680,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 47",
    "code": 2681,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 48",
    "code": 2682,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 49",
    "code": 2683,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 50",
    "code": 2684,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 51",
    "code": 2685,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 52",
    "code": 2686,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 53",
    "code": 2687,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 54",
    "code": 2688,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 55",
    "code": 2689,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 56",
    "code": 2690,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 57",
    "code": 2691,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 58",
    "code": 2692,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 59",
    "code": 2693,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 60 (deprecated)",
    "code": 2694,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60000000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 61",
    "code": 2695,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 62",
    "code": 2696,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 63",
    "code": 2697,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 64",
    "code": 2698,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 21E",
    "code": 2699,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 24E",
    "code": 2700,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 27E",
    "code": 2701,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 30E",
    "code": 2702,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 33E",
    "code": 2703,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 36E",
    "code": 2704,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 39E",
    "code": 2705,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 42E",
    "code": 2706,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 45E",
    "code": 2707,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 48E",
    "code": 2708,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 51E",
    "code": 2709,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 54E",
    "code": 2710,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 57E",
    "code": 2711,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 60E",
    "code": 2712,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 63E",
    "code": 2713,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 66E",
    "code": 2714,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 69E",
    "code": 2715,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 72E",
    "code": 2716,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 75E",
    "code": 2717,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 78E",
    "code": 2718,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 81E",
    "code": 2719,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 84E",
    "code": 2720,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 87E",
    "code": 2721,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 90E",
    "code": 2722,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 93E",
    "code": 2723,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 96E",
    "code": 2724,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 99E",
    "code": 2725,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 102E",
    "code": 2726,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 105E",
    "code": 2727,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 108E",
    "code": 2728,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 111E",
    "code": 2729,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 114E",
    "code": 2730,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 117E",
    "code": 2731,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 120E",
    "code": 2732,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 123E",
    "code": 2733,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 126E",
    "code": 2734,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 129E",
    "code": 2735,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Tete / UTM zone 36S",
    "code": 2736,
    "projection": "+proj=utm +zone=36 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tete / UTM zone 37S",
    "code": 2737,
    "projection": "+proj=utm +zone=37 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 132E",
    "code": 2738,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 135E",
    "code": 2739,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 138E",
    "code": 2740,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 141E",
    "code": 2741,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 144E",
    "code": 2742,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 147E",
    "code": 2743,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 150E",
    "code": 2744,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 153E",
    "code": 2745,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 156E",
    "code": 2746,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 159E",
    "code": 2747,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 162E",
    "code": 2748,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 165E",
    "code": 2749,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 168E",
    "code": 2750,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 171E",
    "code": 2751,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 174E",
    "code": 2752,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 177E",
    "code": 2753,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 180E",
    "code": 2754,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 177W",
    "code": 2755,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 174W",
    "code": 2756,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 171W",
    "code": 2757,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 168W",
    "code": 2758,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Alabama East",
    "code": 2759,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Alabama West",
    "code": 2760,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona East",
    "code": 2761,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona Central",
    "code": 2762,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona West",
    "code": 2763,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arkansas North",
    "code": 2764,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arkansas South",
    "code": 2765,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 1",
    "code": 2766,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 2",
    "code": 2767,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 3",
    "code": 2768,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 4",
    "code": 2769,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 5",
    "code": 2770,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 6",
    "code": 2771,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado North",
    "code": 2772,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado Central",
    "code": 2773,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado South",
    "code": 2774,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Connecticut",
    "code": 2775,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Delaware",
    "code": 2776,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida East",
    "code": 2777,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida West",
    "code": 2778,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida North",
    "code": 2779,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Georgia East",
    "code": 2780,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Georgia West",
    "code": 2781,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 1",
    "code": 2782,
    "projection": "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 2",
    "code": 2783,
    "projection": "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 3",
    "code": 2784,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 4",
    "code": 2785,
    "projection": "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 5",
    "code": 2786,
    "projection": "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho East",
    "code": 2787,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho Central",
    "code": 2788,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho West",
    "code": 2789,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Illinois East",
    "code": 2790,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Illinois West",
    "code": 2791,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana East",
    "code": 2792,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana West",
    "code": 2793,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Iowa North",
    "code": 2794,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Iowa South",
    "code": 2795,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kansas North",
    "code": 2796,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kansas South",
    "code": 2797,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky North",
    "code": 2798,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky South",
    "code": 2799,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Louisiana North",
    "code": 2800,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Louisiana South",
    "code": 2801,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine East",
    "code": 2802,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine West",
    "code": 2803,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maryland",
    "code": 2804,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Massachusetts Mainland",
    "code": 2805,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Massachusetts Island",
    "code": 2806,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan North",
    "code": 2807,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan Central",
    "code": 2808,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan South",
    "code": 2809,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota North",
    "code": 2810,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota Central",
    "code": 2811,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota South",
    "code": 2812,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Mississippi East",
    "code": 2813,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Mississippi West",
    "code": 2814,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Missouri East",
    "code": 2815,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Missouri Central",
    "code": 2816,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Missouri West",
    "code": 2817,
    "projection": "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Montana",
    "code": 2818,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nebraska",
    "code": 2819,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada East",
    "code": 2820,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada Central",
    "code": 2821,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada West",
    "code": 2822,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Hampshire",
    "code": 2823,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Jersey",
    "code": 2824,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico East",
    "code": 2825,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico Central",
    "code": 2826,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico West",
    "code": 2827,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York East",
    "code": 2828,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York Central",
    "code": 2829,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York West",
    "code": 2830,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York Long Island",
    "code": 2831,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Dakota North",
    "code": 2832,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Dakota South",
    "code": 2833,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Ohio North",
    "code": 2834,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Ohio South",
    "code": 2835,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oklahoma North",
    "code": 2836,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oklahoma South",
    "code": 2837,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon North",
    "code": 2838,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon South",
    "code": 2839,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Rhode Island",
    "code": 2840,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Dakota North",
    "code": 2841,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Dakota South",
    "code": 2842,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Tennessee",
    "code": 2843,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas North",
    "code": 2844,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas North Central",
    "code": 2845,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas Central",
    "code": 2846,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas South Central",
    "code": 2847,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas South",
    "code": 2848,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah North",
    "code": 2849,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah Central",
    "code": 2850,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah South",
    "code": 2851,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Vermont",
    "code": 2852,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Virginia North",
    "code": 2853,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Virginia South",
    "code": 2854,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Washington North",
    "code": 2855,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Washington South",
    "code": 2856,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia North",
    "code": 2857,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia South",
    "code": 2858,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin North",
    "code": 2859,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin Central",
    "code": 2860,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin South",
    "code": 2861,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming East",
    "code": 2862,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming East Central",
    "code": 2863,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming West Central",
    "code": 2864,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming West",
    "code": 2865,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Puerto Rico and Virgin Is.",
    "code": 2866,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona East (ft)",
    "code": 2867,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona Central (ft)",
    "code": 2868,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arizona West (ft)",
    "code": 2869,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 1 (ftUS)",
    "code": 2870,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 2 (ftUS)",
    "code": 2871,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 3 (ftUS)",
    "code": 2872,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 4 (ftUS)",
    "code": 2873,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 5 (ftUS)",
    "code": 2874,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / California zone 6 (ftUS)",
    "code": 2875,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado North (ftUS)",
    "code": 2876,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado Central (ftUS)",
    "code": 2877,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Colorado South (ftUS)",
    "code": 2878,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Connecticut (ftUS)",
    "code": 2879,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Delaware (ftUS)",
    "code": 2880,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida East (ftUS)",
    "code": 2881,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida West (ftUS)",
    "code": 2882,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida North (ftUS)",
    "code": 2883,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Georgia East (ftUS)",
    "code": 2884,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Georgia West (ftUS)",
    "code": 2885,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho East (ftUS)",
    "code": 2886,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho Central (ftUS)",
    "code": 2887,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Idaho West (ftUS)",
    "code": 2888,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana East (ftUS) (deprecated)",
    "code": 2889,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249364.9987299975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana West (ftUS) (deprecated)",
    "code": 2890,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249364.9987299975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky North (ftUS)",
    "code": 2891,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky South (ftUS)",
    "code": 2892,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maryland (ftUS)",
    "code": 2893,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Massachusetts Mainland (ftUS)",
    "code": 2894,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Massachusetts Island (ftUS)",
    "code": 2895,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan North (ft)",
    "code": 2896,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan Central (ft)",
    "code": 2897,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan South (ft)",
    "code": 2898,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Mississippi East (ftUS)",
    "code": 2899,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Mississippi West (ftUS)",
    "code": 2900,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Montana (ft)",
    "code": 2901,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico East (ftUS)",
    "code": 2902,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico Central (ftUS)",
    "code": 2903,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Mexico West (ftUS)",
    "code": 2904,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York East (ftUS)",
    "code": 2905,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York Central (ftUS)",
    "code": 2906,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York West (ftUS)",
    "code": 2907,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New York Long Island (ftUS)",
    "code": 2908,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Dakota North (ft)",
    "code": 2909,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Dakota South (ft)",
    "code": 2910,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oklahoma North (ftUS)",
    "code": 2911,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oklahoma South (ftUS)",
    "code": 2912,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon North (ft)",
    "code": 2913,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon South (ft)",
    "code": 2914,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Tennessee (ftUS)",
    "code": 2915,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas North (ftUS)",
    "code": 2916,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas North Central (ftUS)",
    "code": 2917,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas Central (ftUS)",
    "code": 2918,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas South Central (ftUS)",
    "code": 2919,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas South (ftUS)",
    "code": 2920,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah North (ft)",
    "code": 2921,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah Central (ft)",
    "code": 2922,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah South (ft)",
    "code": 2923,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Virginia North (ftUS)",
    "code": 2924,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Virginia South (ftUS)",
    "code": 2925,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Washington North (ftUS)",
    "code": 2926,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Washington South (ftUS)",
    "code": 2927,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin North (ftUS)",
    "code": 2928,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin Central (ftUS)",
    "code": 2929,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin South (ftUS)",
    "code": 2930,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Beduaram / TM 13 NE",
    "code": 2931,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.2 +b=6356515 +towgs84=-106,-87,188,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "QND95 / Qatar National Grid",
    "code": 2932,
    "projection": "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +units=m +no_defs "
  },
  {
    "name": "Segara / UTM zone 50S",
    "code": 2933,
    "projection": "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Segara (Jakarta) / NEIEZ (deprecated)",
    "code": 2934,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone A1",
    "code": 2935,
    "projection": "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=41.53333333333333 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone A2",
    "code": 2936,
    "projection": "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=44.53333333333333 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone A3",
    "code": 2937,
    "projection": "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=47.53333333333333 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone A4",
    "code": 2938,
    "projection": "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=50.53333333333333 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone K2",
    "code": 2939,
    "projection": "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=50.76666666666667 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone K3",
    "code": 2940,
    "projection": "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=53.76666666666667 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone K4",
    "code": 2941,
    "projection": "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=56.76666666666667 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Porto Santo / UTM zone 28N",
    "code": 2942,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Selvagem Grande / UTM zone 28N",
    "code": 2943,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / SCoPQ zone 2 (deprecated)",
    "code": 2944,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 3",
    "code": 2945,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 4",
    "code": 2946,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 5",
    "code": 2947,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 6",
    "code": 2948,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 7",
    "code": 2949,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 8",
    "code": 2950,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 9",
    "code": 2951,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 10",
    "code": 2952,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / New Brunswick Stereographic",
    "code": 2953,
    "projection": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Prince Edward Isl. Stereographic (NAD83)",
    "code": 2954,
    "projection": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 11N",
    "code": 2955,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 12N",
    "code": 2956,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 13N",
    "code": 2957,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 17N",
    "code": 2958,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 18N",
    "code": 2959,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 19N",
    "code": 2960,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 20N",
    "code": 2961,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 21N",
    "code": 2962,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alaska Albers",
    "code": 2964,
    "projection": "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Indiana East (ftUS)",
    "code": 2965,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Indiana West (ftUS)",
    "code": 2966,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana East (ftUS)",
    "code": 2967,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Indiana West (ftUS)",
    "code": 2968,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Fort Marigot / UTM zone 20N",
    "code": 2969,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=137,248,-430,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Guadeloupe 1948 / UTM zone 20N",
    "code": 2970,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=-467,-16,-300,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CSG67 / UTM zone 22N",
    "code": 2971,
    "projection": "+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGFG95 / UTM zone 22N",
    "code": 2972,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Martinique 1938 / UTM zone 20N",
    "code": 2973,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=186,482,151,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGR92 / UTM zone 40S",
    "code": 2975,
    "projection": "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tahiti 52 / UTM zone 6S",
    "code": 2976,
    "projection": "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tahaa 54 / UTM zone 5S",
    "code": 2977,
    "projection": "+proj=utm +zone=5 +south +ellps=intl +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746 +units=m +no_defs "
  },
  {
    "name": "IGN72 Nuku Hiva / UTM zone 7S",
    "code": 2978,
    "projection": "+proj=utm +zone=7 +south +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "K0 1949 / UTM zone 42S (deprecated)",
    "code": 2979,
    "projection": "+proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Combani 1950 / UTM zone 38S",
    "code": 2980,
    "projection": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGN56 Lifou / UTM zone 58S",
    "code": 2981,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGN72 Grand Terre / UTM zone 58S (deprecated)",
    "code": 2982,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ST87 Ouvea / UTM zone 58S (deprecated)",
    "code": 2983,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-122.383,-188.696,103.344,3.5107,-4.9668,-5.7047,4.4798 +units=m +no_defs "
  },
  {
    "name": "RGNC 1991 / Lambert New Caledonia (deprecated)",
    "code": 2984,
    "projection": "+proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Saint Pierre et Miquelon 1950 / UTM zone 21N",
    "code": 2987,
    "projection": "+proj=utm +zone=21 +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MOP78 / UTM zone 1S",
    "code": 2988,
    "projection": "+proj=utm +zone=1 +south +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RRAF 1991 / UTM zone 20N (deprecated)",
    "code": 2989,
    "projection": "+proj=utm +zone=20 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Reunion 1947 / TM Reunion (deprecated)",
    "code": 2990,
    "projection": "+proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=50000 +y_0=160000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oregon LCC (m)",
    "code": 2991,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oregon GIC Lambert (ft)",
    "code": 2992,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +datum=NAD83 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon LCC (m)",
    "code": 2993,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Oregon GIC Lambert (ft)",
    "code": 2994,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "IGN53 Mare / UTM zone 58S",
    "code": 2995,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ST84 Ile des Pins / UTM zone 58S",
    "code": 2996,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ST71 Belep / UTM zone 58S",
    "code": 2997,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +units=m +no_defs "
  },
  {
    "name": "NEA74 Noumea / UTM zone 58S",
    "code": 2998,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Grand Comoros / UTM zone 38S",
    "code": 2999,
    "projection": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Segara / NEIEZ",
    "code": 3000,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Batavia / NEIEZ",
    "code": 3001,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Makassar / NEIEZ",
    "code": 3002,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Monte Mario / Italy zone 1",
    "code": 3003,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs "
  },
  {
    "name": "Monte Mario / Italy zone 2",
    "code": 3004,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs "
  },
  {
    "name": "NAD83 / BC Albers",
    "code": 3005,
    "projection": "+proj=aea +lat_1=50 +lat_2=58.5 +lat_0=45 +lon_0=-126 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 TM",
    "code": 3006,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 12 00",
    "code": 3007,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 13 30",
    "code": 3008,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 15 00",
    "code": 3009,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 16 30",
    "code": 3010,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 18 00",
    "code": 3011,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 14 15",
    "code": 3012,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 15 45",
    "code": 3013,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 17 15",
    "code": 3014,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 18 45",
    "code": 3015,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 20 15",
    "code": 3016,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 21 45",
    "code": 3017,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 23 15",
    "code": 3018,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RT90 7.5 gon V",
    "code": 3019,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT90 5 gon V",
    "code": 3020,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT90 2.5 gon V",
    "code": 3021,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT90 0 gon",
    "code": 3022,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT90 2.5 gon O",
    "code": 3023,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT90 5 gon O",
    "code": 3024,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs "
  },
  {
    "name": "RT38 7.5 gon V",
    "code": 3025,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RT38 5 gon V",
    "code": 3026,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RT38 2.5 gon V",
    "code": 3027,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RT38 0 gon",
    "code": 3028,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RT38 2.5 gon O",
    "code": 3029,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RT38 5 gon O",
    "code": 3030,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Antarctic Polar Stereographic",
    "code": 3031,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Australian Antarctic Polar Stereographic",
    "code": 3032,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=70 +k=1 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Australian Antarctic Lambert",
    "code": 3033,
    "projection": "+proj=lcc +lat_1=-68.5 +lat_2=-74.5 +lat_0=-50 +lon_0=70 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / LCC Europe",
    "code": 3034,
    "projection": "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / LAEA Europe",
    "code": 3035,
    "projection": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Moznet / UTM zone 36S",
    "code": 3036,
    "projection": "+proj=utm +zone=36 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Moznet / UTM zone 37S",
    "code": 3037,
    "projection": "+proj=utm +zone=37 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM26 (deprecated)",
    "code": 3038,
    "projection": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM27 (deprecated)",
    "code": 3039,
    "projection": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 28N (N-E)",
    "code": 3040,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 29N (N-E)",
    "code": 3041,
    "projection": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 30N (N-E)",
    "code": 3042,
    "projection": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31N (N-E)",
    "code": 3043,
    "projection": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N (N-E)",
    "code": 3044,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N (N-E)",
    "code": 3045,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 34N (N-E)",
    "code": 3046,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 35N (N-E)",
    "code": 3047,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 36N (N-E)",
    "code": 3048,
    "projection": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 37N (N-E)",
    "code": 3049,
    "projection": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM38 (deprecated)",
    "code": 3050,
    "projection": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM39 (deprecated)",
    "code": 3051,
    "projection": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hjorsey 1955 / UTM zone 26N",
    "code": 3054,
    "projection": "+proj=utm +zone=26 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hjorsey 1955 / UTM zone 27N",
    "code": 3055,
    "projection": "+proj=utm +zone=27 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Hjorsey 1955 / UTM zone 28N",
    "code": 3056,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ISN93 / Lambert 1993",
    "code": 3057,
    "projection": "+proj=lcc +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Helle 1954 / Jan Mayen Grid",
    "code": 3058,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-8.5 +k=1 +x_0=50000 +y_0=-7800000 +ellps=intl +towgs84=982.6087,552.753,-540.873,6.6816266,-31.6114924,-19.84816,16.805 +units=m +no_defs "
  },
  {
    "name": "LKS92 / Latvia TM",
    "code": 3059,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGN72 Grande Terre / UTM zone 58S",
    "code": 3060,
    "projection": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Porto Santo 1995 / UTM zone 28N",
    "code": 3061,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-502.862,-247.438,312.724,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Azores Oriental 1995 / UTM zone 26N",
    "code": 3062,
    "projection": "+proj=utm +zone=26 +ellps=intl +towgs84=-204.619,140.176,55.226,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Azores Central 1995 / UTM zone 26N",
    "code": 3063,
    "projection": "+proj=utm +zone=26 +ellps=intl +towgs84=-106.226,166.366,-37.893,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGM95 / UTM zone 32N",
    "code": 3064,
    "projection": "+proj=utm +zone=32 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGM95 / UTM zone 33N",
    "code": 3065,
    "projection": "+proj=utm +zone=33 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / Jordan TM",
    "code": 3066,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM35FIN(E,N)",
    "code": 3067,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DHDN / Soldner Berlin",
    "code": 3068,
    "projection": "+proj=cass +lat_0=52.41864827777778 +lon_0=13.62720366666667 +x_0=40000 +y_0=10000 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "NAD27 / Wisconsin Transverse Mercator",
    "code": 3069,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=500000 +y_0=-4500000 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin Transverse Mercator",
    "code": 3070,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wisconsin Transverse Mercator",
    "code": 3071,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine CS2000 East",
    "code": 3072,
    "projection": "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine CS2000 Central (deprecated)",
    "code": 3073,
    "projection": "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine CS2000 West",
    "code": 3074,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine CS2000 East",
    "code": 3075,
    "projection": "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine CS2000 Central (deprecated)",
    "code": 3076,
    "projection": "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine CS2000 West",
    "code": 3077,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Michigan Oblique Mercator",
    "code": 3078,
    "projection": "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Michigan Oblique Mercator",
    "code": 3079,
    "projection": "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Shackleford",
    "code": 3080,
    "projection": "+proj=lcc +lat_1=27.41666666666667 +lat_2=34.91666666666666 +lat_0=31.16666666666667 +lon_0=-100 +x_0=914400 +y_0=914400 +datum=NAD27 +units=ft +no_defs "
  },
  {
    "name": "NAD83 / Texas State Mapping System",
    "code": 3081,
    "projection": "+proj=lcc +lat_1=27.41666666666667 +lat_2=34.91666666666666 +lat_0=31.16666666666667 +lon_0=-100 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas Centric Lambert Conformal",
    "code": 3082,
    "projection": "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas Centric Albers Equal Area",
    "code": 3083,
    "projection": "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas Centric Lambert Conformal",
    "code": 3084,
    "projection": "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Texas Centric Albers Equal Area",
    "code": 3085,
    "projection": "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Florida GDL Albers",
    "code": 3086,
    "projection": "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Florida GDL Albers",
    "code": 3087,
    "projection": "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kentucky Single Zone",
    "code": 3088,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kentucky Single Zone (ftUS)",
    "code": 3089,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky Single Zone",
    "code": 3090,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kentucky Single Zone (ftUS)",
    "code": 3091,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Tokyo / UTM zone 51N",
    "code": 3092,
    "projection": "+proj=utm +zone=51 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / UTM zone 52N",
    "code": 3093,
    "projection": "+proj=utm +zone=52 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / UTM zone 53N",
    "code": 3094,
    "projection": "+proj=utm +zone=53 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / UTM zone 54N",
    "code": 3095,
    "projection": "+proj=utm +zone=54 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / UTM zone 55N",
    "code": 3096,
    "projection": "+proj=utm +zone=55 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / UTM zone 51N",
    "code": 3097,
    "projection": "+proj=utm +zone=51 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / UTM zone 52N",
    "code": 3098,
    "projection": "+proj=utm +zone=52 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / UTM zone 53N",
    "code": 3099,
    "projection": "+proj=utm +zone=53 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / UTM zone 54N",
    "code": 3100,
    "projection": "+proj=utm +zone=54 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2000 / UTM zone 55N",
    "code": 3101,
    "projection": "+proj=utm +zone=55 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "American Samoa 1962 / American Samoa Lambert",
    "code": 3102,
    "projection": "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=-170 +k_0=1 +x_0=152400.3048006096 +y_0=95169.31165862332 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 28N (deprecated)",
    "code": 3103,
    "projection": "+proj=utm +zone=28 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 29N (deprecated)",
    "code": 3104,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 30N (deprecated)",
    "code": 3105,
    "projection": "+proj=utm +zone=30 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Gulshan 303 / Bangladesh Transverse Mercator",
    "code": 3106,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +a=6377276.345 +b=6356075.41314024 +towgs84=283.7,735.9,261.1,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / SA Lambert",
    "code": 3107,
    "projection": "+proj=lcc +lat_1=-28 +lat_2=-36 +lat_0=-32 +lon_0=135 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Guernsey Grid",
    "code": 3108,
    "projection": "+proj=tmerc +lat_0=49.5 +lon_0=-2.416666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Jersey Transverse Mercator",
    "code": 3109,
    "projection": "+proj=tmerc +lat_0=49.225 +lon_0=-2.135 +k=0.9999999000000001 +x_0=40000 +y_0=70000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD66 / Vicgrid66",
    "code": 3110,
    "projection": "+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=4500000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "GDA94 / Vicgrid",
    "code": 3111,
    "projection": "+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / Geoscience Australia Lambert",
    "code": 3112,
    "projection": "+proj=lcc +lat_1=-18 +lat_2=-36 +lat_0=0 +lon_0=134 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / BCSG02",
    "code": 3113,
    "projection": "+proj=tmerc +lat_0=-28 +lon_0=153 +k=0.99999 +x_0=50000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS / Colombia Far West zone",
    "code": 3114,
    "projection": "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-80.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS / Colombia West zone",
    "code": 3115,
    "projection": "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-77.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS / Colombia Bogota zone",
    "code": 3116,
    "projection": "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-74.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS / Colombia East Central zone",
    "code": 3117,
    "projection": "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-71.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS / Colombia East zone",
    "code": 3118,
    "projection": "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-68.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Douala 1948 / AEF west",
    "code": 3119,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Poland zone I",
    "code": 3120,
    "projection": "+proj=sterea +lat_0=50.625 +lon_0=21.08333333333333 +k=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "PRS92 / Philippines zone 1",
    "code": 3121,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs "
  },
  {
    "name": "PRS92 / Philippines zone 2",
    "code": 3122,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs "
  },
  {
    "name": "PRS92 / Philippines zone 3",
    "code": 3123,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs "
  },
  {
    "name": "PRS92 / Philippines zone 4",
    "code": 3124,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs "
  },
  {
    "name": "PRS92 / Philippines zone 5",
    "code": 3125,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK19FIN",
    "code": 3126,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK20FIN",
    "code": 3127,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK21FIN",
    "code": 3128,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK22FIN",
    "code": 3129,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK23FIN",
    "code": 3130,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK24FIN",
    "code": 3131,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK25FIN",
    "code": 3132,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK26FIN",
    "code": 3133,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK27FIN",
    "code": 3134,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK28FIN",
    "code": 3135,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK29FIN",
    "code": 3136,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK30FIN",
    "code": 3137,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / ETRS-GK31FIN",
    "code": 3138,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Viti Levu 1912 / Viti Levu Grid",
    "code": 3140,
    "projection": "+proj=cass +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272 +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +units=link +no_defs "
  },
  {
    "name": "Fiji 1956 / UTM zone 60S",
    "code": 3141,
    "projection": "+proj=utm +zone=60 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Fiji 1956 / UTM zone 1S",
    "code": 3142,
    "projection": "+proj=utm +zone=1 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Fiji 1986 / Fiji Map Grid (deprecated)",
    "code": 3143,
    "projection": "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 6 (deprecated)",
    "code": 3146,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 18E (deprecated)",
    "code": 3147,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Indian 1960 / UTM zone 48N",
    "code": 3148,
    "projection": "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1960 / UTM zone 49N",
    "code": 3149,
    "projection": "+proj=utm +zone=49 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 6 (deprecated)",
    "code": 3150,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 18E (deprecated)",
    "code": 3151,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "ST74",
    "code": 3152,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / BC Albers",
    "code": 3153,
    "projection": "+proj=aea +lat_1=50 +lat_2=58.5 +lat_0=45 +lon_0=-126 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 7N",
    "code": 3154,
    "projection": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 8N",
    "code": 3155,
    "projection": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 9N",
    "code": 3156,
    "projection": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 10N",
    "code": 3157,
    "projection": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 14N",
    "code": 3158,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 15N",
    "code": 3159,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 16N",
    "code": 3160,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Ontario MNR Lambert",
    "code": 3161,
    "projection": "+proj=lcc +lat_1=44.5 +lat_2=53.5 +lat_0=0 +lon_0=-85 +x_0=930000 +y_0=6430000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Ontario MNR Lambert",
    "code": 3162,
    "projection": "+proj=lcc +lat_1=44.5 +lat_2=53.5 +lat_0=0 +lon_0=-85 +x_0=930000 +y_0=6430000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGNC91-93 / Lambert New Caledonia",
    "code": 3163,
    "projection": "+proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ST87 Ouvea / UTM zone 58S",
    "code": 3164,
    "projection": "+proj=utm +zone=58 +south +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NEA74 Noumea / Noumea Lambert",
    "code": 3165,
    "projection": "+proj=lcc +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NEA74 Noumea / Noumea Lambert 2",
    "code": 3166,
    "projection": "+proj=lcc +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau (RSO) / RSO Malaya (ch)",
    "code": 3167,
    "projection": "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=40000 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377295.664 +b=6356094.667915204 +to_meter=20.116756 +no_defs "
  },
  {
    "name": "Kertau (RSO) / RSO Malaya (m)",
    "code": 3168,
    "projection": "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=804670.24 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377295.664 +b=6356094.667915204 +units=m +no_defs "
  },
  {
    "name": "RGNC91-93 / UTM zone 57S",
    "code": 3169,
    "projection": "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGNC91-93 / UTM zone 58S",
    "code": 3170,
    "projection": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGNC91-93 / UTM zone 59S",
    "code": 3171,
    "projection": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGN53 Mare / UTM zone 59S",
    "code": 3172,
    "projection": "+proj=utm +zone=59 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Great Lakes Albers",
    "code": 3174,
    "projection": "+proj=aea +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-84.455955 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Great Lakes and St Lawrence Albers",
    "code": 3175,
    "projection": "+proj=aea +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-83.248627 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "Indian 1960 / TM 106 NE",
    "code": 3176,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM",
    "code": 3177,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9965000000000001 +x_0=1000000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 18N",
    "code": 3178,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 19N",
    "code": 3179,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 20N",
    "code": 3180,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 21N",
    "code": 3181,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 22N",
    "code": 3182,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 23N",
    "code": 3183,
    "projection": "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 24N",
    "code": 3184,
    "projection": "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 25N",
    "code": 3185,
    "projection": "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 26N",
    "code": 3186,
    "projection": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 27N",
    "code": 3187,
    "projection": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 28N",
    "code": 3188,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / UTM zone 29N",
    "code": 3189,
    "projection": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 5",
    "code": 3190,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 6",
    "code": 3191,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 7",
    "code": 3192,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 8",
    "code": 3193,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 9",
    "code": 3194,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 10",
    "code": 3195,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 11",
    "code": 3196,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 12",
    "code": 3197,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / Libya TM zone 13",
    "code": 3198,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / UTM zone 32N",
    "code": 3199,
    "projection": "+proj=utm +zone=32 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "FD58 / Iraq zone",
    "code": 3200,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-241.54,-163.64,396.06,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / UTM zone 33N",
    "code": 3201,
    "projection": "+proj=utm +zone=33 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / UTM zone 34N",
    "code": 3202,
    "projection": "+proj=utm +zone=34 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LGD2006 / UTM zone 35N",
    "code": 3203,
    "projection": "+proj=utm +zone=35 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SP19-20",
    "code": 3204,
    "projection": "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SP21-22",
    "code": 3205,
    "projection": "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SP23-24",
    "code": 3206,
    "projection": "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ01-02",
    "code": 3207,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-174 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ19-20",
    "code": 3208,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ21-22",
    "code": 3209,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ37-38",
    "code": 3210,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ39-40",
    "code": 3211,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ41-42",
    "code": 3212,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ43-44",
    "code": 3213,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ45-46",
    "code": 3214,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ47-48",
    "code": 3215,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ49-50",
    "code": 3216,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=114 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ51-52",
    "code": 3217,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=126 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ53-54",
    "code": 3218,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=138 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ55-56",
    "code": 3219,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SQ57-58",
    "code": 3220,
    "projection": "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR13-14",
    "code": 3221,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR15-16",
    "code": 3222,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR17-18",
    "code": 3223,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR19-20",
    "code": 3224,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR27-28",
    "code": 3225,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-18 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR29-30",
    "code": 3226,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-6 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR31-32",
    "code": 3227,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=6 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR33-34",
    "code": 3228,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=18 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR35-36",
    "code": 3229,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR37-38",
    "code": 3230,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR39-40",
    "code": 3231,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR41-42",
    "code": 3232,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR43-44",
    "code": 3233,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR45-46",
    "code": 3234,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR47-48",
    "code": 3235,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR49-50",
    "code": 3236,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=114 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR51-52",
    "code": 3237,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=126 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR53-54",
    "code": 3238,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=138 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR55-56",
    "code": 3239,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR57-58",
    "code": 3240,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SR59-60",
    "code": 3241,
    "projection": "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=174 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS04-06",
    "code": 3242,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-153 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS07-09",
    "code": 3243,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS10-12",
    "code": 3244,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-117 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS13-15",
    "code": 3245,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-99 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS16-18",
    "code": 3246,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-81 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS19-21",
    "code": 3247,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-63 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS25-27",
    "code": 3248,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-27 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS28-30",
    "code": 3249,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-9 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS31-33",
    "code": 3250,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=9 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS34-36",
    "code": 3251,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=27 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS37-39",
    "code": 3252,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS40-42",
    "code": 3253,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=63 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS43-45",
    "code": 3254,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=81 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS46-48",
    "code": 3255,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=99 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS49-51",
    "code": 3256,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=117 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS52-54",
    "code": 3257,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS55-57",
    "code": 3258,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=153 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SS58-60",
    "code": 3259,
    "projection": "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=171 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST01-04",
    "code": 3260,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-168 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST05-08",
    "code": 3261,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-144 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST09-12",
    "code": 3262,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-120 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST13-16",
    "code": 3263,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-96 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST17-20",
    "code": 3264,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-72 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST21-24",
    "code": 3265,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-48 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST25-28",
    "code": 3266,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-24 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST29-32",
    "code": 3267,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST33-36",
    "code": 3268,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=24 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST37-40",
    "code": 3269,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=48 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST41-44",
    "code": 3270,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=72 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST45-48",
    "code": 3271,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=96 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST49-52",
    "code": 3272,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=120 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST53-56",
    "code": 3273,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=144 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW ST57-60",
    "code": 3274,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=168 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU01-05",
    "code": 3275,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-165 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU06-10",
    "code": 3276,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-135 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU11-15",
    "code": 3277,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-105 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU16-20",
    "code": 3278,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-75 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU21-25",
    "code": 3279,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU26-30",
    "code": 3280,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-15 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU31-35",
    "code": 3281,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=15 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU36-40",
    "code": 3282,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU41-45",
    "code": 3283,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=75 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU46-50",
    "code": 3284,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=105 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU51-55",
    "code": 3285,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=135 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SU56-60",
    "code": 3286,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=165 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV01-10",
    "code": 3287,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV11-20",
    "code": 3288,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-90 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV21-30",
    "code": 3289,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-30 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV31-40",
    "code": 3290,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=30 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV41-50",
    "code": 3291,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=90 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SV51-60",
    "code": 3292,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / SCAR IMW SW01-60",
    "code": 3293,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / USGS Transantarctic Mountains",
    "code": 3294,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-78 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RGPF / UTM zone 5S",
    "code": 3296,
    "projection": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs "
  },
  {
    "name": "RGPF / UTM zone 6S",
    "code": 3297,
    "projection": "+proj=utm +zone=6 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs "
  },
  {
    "name": "RGPF / UTM zone 7S",
    "code": 3298,
    "projection": "+proj=utm +zone=7 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs "
  },
  {
    "name": "RGPF / UTM zone 8S",
    "code": 3299,
    "projection": "+proj=utm +zone=8 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs "
  },
  {
    "name": "Estonian Coordinate System of 1992",
    "code": 3300,
    "projection": "+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +units=m +no_defs "
  },
  {
    "name": "Estonian Coordinate System of 1997",
    "code": 3301,
    "projection": "+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGN63 Hiva Oa / UTM zone 7S",
    "code": 3302,
    "projection": "+proj=utm +zone=7 +south +ellps=intl +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311 +units=m +no_defs "
  },
  {
    "name": "Fatu Iva 72 / UTM zone 7S",
    "code": 3303,
    "projection": "+proj=utm +zone=7 +south +ellps=intl +towgs84=347.103,1078.125,2623.922,-33.8875,70.6773,-9.3943,186.074 +units=m +no_defs "
  },
  {
    "name": "Tahiti 79 / UTM zone 6S",
    "code": 3304,
    "projection": "+proj=utm +zone=6 +south +ellps=intl +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741 +units=m +no_defs "
  },
  {
    "name": "Moorea 87 / UTM zone 6S",
    "code": 3305,
    "projection": "+proj=utm +zone=6 +south +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +units=m +no_defs "
  },
  {
    "name": "Maupiti 83 / UTM zone 5S",
    "code": 3306,
    "projection": "+proj=utm +zone=5 +south +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nakhl-e Ghanem / UTM zone 39N",
    "code": 3307,
    "projection": "+proj=utm +zone=39 +ellps=WGS84 +towgs84=0,-0.15,0.68,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / NSW Lambert",
    "code": 3308,
    "projection": "+proj=lcc +lat_1=-30.75 +lat_2=-35.75 +lat_0=-33.25 +lon_0=147 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / California Albers",
    "code": 3309,
    "projection": "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California Albers",
    "code": 3310,
    "projection": "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / California Albers",
    "code": 3311,
    "projection": "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CSG67 / UTM zone 21N",
    "code": 3312,
    "projection": "+proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGFG95 / UTM zone 21N",
    "code": 3313,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Lambert (deprecated)",
    "code": 3314,
    "projection": "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=0 +lon_0=26 +x_0=0 +y_0=0 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga TM (deprecated)",
    "code": 3315,
    "projection": "+proj=tmerc +lat_0=-9 +lon_0=26 +k=0.9998 +x_0=0 +y_0=0 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kasai 1953 / Congo TM zone 22",
    "code": 3316,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Kasai 1953 / Congo TM zone 24",
    "code": 3317,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 12",
    "code": 3318,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 14",
    "code": 3319,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 16",
    "code": 3320,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 18",
    "code": 3321,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 20",
    "code": 3322,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 22",
    "code": 3323,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 24",
    "code": 3324,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 26",
    "code": 3325,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 28",
    "code": 3326,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGC 1962 / Congo TM zone 30",
    "code": 3327,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / GUGiK-80",
    "code": 3328,
    "projection": "+proj=sterea +lat_0=52.16666666666666 +lon_0=19.16666666666667 +k=0.999714 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5",
    "code": 3329,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 6",
    "code": 3330,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 7",
    "code": 3331,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 8",
    "code": 3332,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 3",
    "code": 3333,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 4",
    "code": 3334,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 5",
    "code": 3335,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "IGN 1962 Kerguelen / UTM zone 42S",
    "code": 3336,
    "projection": "+proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Le Pouce 1934 / Mauritius Grid",
    "code": 3337,
    "projection": "+proj=lcc +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=clrk80 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska Albers",
    "code": 3338,
    "projection": "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "IGCB 1955 / Congo TM zone 12",
    "code": 3339,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGCB 1955 / Congo TM zone 14",
    "code": 3340,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGCB 1955 / Congo TM zone 16",
    "code": 3341,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGCB 1955 / UTM zone 33S",
    "code": 3342,
    "projection": "+proj=utm +zone=33 +south +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 28N",
    "code": 3343,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 29N",
    "code": 3344,
    "projection": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999 / UTM zone 30N",
    "code": 3345,
    "projection": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "LKS94 / Lithuania TM",
    "code": 3346,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Statistics Canada Lambert",
    "code": 3347,
    "projection": "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=63.390675 +lon_0=-91.86666666666666 +x_0=6200000 +y_0=3000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Statistics Canada Lambert",
    "code": 3348,
    "projection": "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=63.390675 +lon_0=-91.86666666666666 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / PDC Mercator (deprecated)",
    "code": 3349,
    "projection": "+proj=merc +lon_0=-150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone C0",
    "code": 3350,
    "projection": "+proj=tmerc +lat_0=0.1 +lon_0=21.95 +k=1 +x_0=250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone C1",
    "code": 3351,
    "projection": "+proj=tmerc +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone C2",
    "code": 3352,
    "projection": "+proj=tmerc +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Mhast (onshore) / UTM zone 32S",
    "code": 3353,
    "projection": "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Mhast (offshore) / UTM zone 32S",
    "code": 3354,
    "projection": "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Egypt Gulf of Suez S-650 TL / Red Belt",
    "code": 3355,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Grand Cayman 1959 / UTM zone 17N (deprecated)",
    "code": 3356,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +units=m +no_defs "
  },
  {
    "name": "Little Cayman 1961 / UTM zone 17N (deprecated)",
    "code": 3357,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Carolina",
    "code": 3358,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Carolina (ftUS) (deprecated)",
    "code": 3359,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Carolina",
    "code": 3360,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Carolina (ft)",
    "code": 3361,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Pennsylvania North",
    "code": 3362,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Pennsylvania North (ftUS)",
    "code": 3363,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Pennsylvania South",
    "code": 3364,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Pennsylvania South (ftUS)",
    "code": 3365,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Hong Kong 1963 Grid System (deprecated)",
    "code": 3366,
    "projection": "+proj=cass +lat_0=22.31213333333334 +lon_0=114.1785555555556 +x_0=40243.57775604237 +y_0=19069.93351512578 +a=6378293.645208759 +b=6356617.987679838 +units=m +no_defs "
  },
  {
    "name": "IGN Astro 1960 / UTM zone 28N",
    "code": 3367,
    "projection": "+proj=utm +zone=28 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGN Astro 1960 / UTM zone 29N",
    "code": 3368,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "IGN Astro 1960 / UTM zone 30N",
    "code": 3369,
    "projection": "+proj=utm +zone=30 +ellps=clrk80 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 59N",
    "code": 3370,
    "projection": "+proj=utm +zone=59 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 60N",
    "code": 3371,
    "projection": "+proj=utm +zone=60 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 59N",
    "code": 3372,
    "projection": "+proj=utm +zone=59 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 60N",
    "code": 3373,
    "projection": "+proj=utm +zone=60 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "FD54 / UTM zone 29N",
    "code": 3374,
    "projection": "+proj=utm +zone=29 +ellps=intl +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Peninsula RSO",
    "code": 3375,
    "projection": "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257964666666 +k=0.99984 +x_0=804671 +y_0=0 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / East Malaysia BRSO",
    "code": 3376,
    "projection": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31580995 +k=0.99984 +x_0=0 +y_0=0 +no_uoff +gamma=53.13010236111111 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Johor Grid",
    "code": 3377,
    "projection": "+proj=cass +lat_0=2.121679744444445 +lon_0=103.4279362361111 +x_0=-14810.562 +y_0=8758.32 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Sembilan and Melaka Grid",
    "code": 3378,
    "projection": "+proj=cass +lat_0=2.682347636111111 +lon_0=101.9749050416667 +x_0=3673.785 +y_0=-4240.573 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Pahang Grid",
    "code": 3379,
    "projection": "+proj=cass +lat_0=3.769388088888889 +lon_0=102.3682989833333 +x_0=-7368.228 +y_0=6485.858 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Selangor Grid",
    "code": 3380,
    "projection": "+proj=cass +lat_0=3.68464905 +lon_0=101.3891079138889 +x_0=-34836.161 +y_0=56464.049 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Terengganu Grid",
    "code": 3381,
    "projection": "+proj=cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Pinang Grid",
    "code": 3382,
    "projection": "+proj=cass +lat_0=5.421517541666667 +lon_0=100.3443769638889 +x_0=-23.414 +y_0=62.283 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Kedah and Perlis Grid",
    "code": 3383,
    "projection": "+proj=cass +lat_0=5.964672713888889 +lon_0=100.6363711111111 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Perak Grid",
    "code": 3384,
    "projection": "+proj=cass +lat_0=4.859063022222222 +lon_0=100.8154105861111 +x_0=-1.769 +y_0=133454.779 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000 / Kelantan Grid",
    "code": 3385,
    "projection": "+proj=cass +lat_0=5.972543658333334 +lon_0=102.2952416694444 +x_0=13227.851 +y_0=8739.894 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland zone 0",
    "code": 3386,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland zone 5",
    "code": 3387,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Caspian Sea Mercator",
    "code": 3388,
    "projection": "+proj=merc +lon_0=51 +lat_ts=42 +x_0=0 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 60",
    "code": 3389,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 60",
    "code": 3390,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Karbala 1979 / UTM zone 37N",
    "code": 3391,
    "projection": "+proj=utm +zone=37 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Karbala 1979 / UTM zone 38N",
    "code": 3392,
    "projection": "+proj=utm +zone=38 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Karbala 1979 / UTM zone 39N",
    "code": 3393,
    "projection": "+proj=utm +zone=39 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1934 / Iraq zone",
    "code": 3394,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / World Mercator",
    "code": 3395,
    "projection": "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "PD/83 / 3-degree Gauss-Kruger zone 3",
    "code": 3396,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "PD/83 / 3-degree Gauss-Kruger zone 4",
    "code": 3397,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RD/83 / 3-degree Gauss-Kruger zone 4",
    "code": 3398,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RD/83 / 3-degree Gauss-Kruger zone 5",
    "code": 3399,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 10-TM (Forest)",
    "code": 3400,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 10-TM (Resource)",
    "code": 3401,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 10-TM (Forest)",
    "code": 3402,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 10-TM (Resource)",
    "code": 3403,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / North Carolina (ftUS)",
    "code": 3404,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "VN-2000 / UTM zone 48N",
    "code": 3405,
    "projection": "+proj=utm +zone=48 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "VN-2000 / UTM zone 49N",
    "code": 3406,
    "projection": "+proj=utm +zone=49 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "Hong Kong 1963 Grid System",
    "code": 3407,
    "projection": "+proj=cass +lat_0=22.31213333333334 +lon_0=114.1785555555556 +x_0=40243.57775604237 +y_0=19069.93351512578 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.3047972654 +no_defs "
  },
  {
    "name": "NSIDC EASE-Grid North",
    "code": 3408,
    "projection": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs "
  },
  {
    "name": "NSIDC EASE-Grid South",
    "code": 3409,
    "projection": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs "
  },
  {
    "name": "NSIDC EASE-Grid Global",
    "code": 3410,
    "projection": "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs "
  },
  {
    "name": "NSIDC Sea Ice Polar Stereographic North",
    "code": 3411,
    "projection": "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs "
  },
  {
    "name": "NSIDC Sea Ice Polar Stereographic South",
    "code": 3412,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC Sea Ice Polar Stereographic North",
    "code": 3413,
    "projection": "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "SVY21 / Singapore TM",
    "code": 3414,
    "projection": "+proj=tmerc +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / South China Sea Lambert",
    "code": 3415,
    "projection": "+proj=lcc +lat_1=18 +lat_2=24 +lat_0=21 +lon_0=114 +x_0=500000 +y_0=500000 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Austria Lambert",
    "code": 3416,
    "projection": "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Iowa North (ftUS)",
    "code": 3417,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Iowa South (ftUS)",
    "code": 3418,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Kansas North (ftUS)",
    "code": 3419,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Kansas South (ftUS)",
    "code": 3420,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Nevada East (ftUS)",
    "code": 3421,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Nevada Central (ftUS)",
    "code": 3422,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Nevada West (ftUS)",
    "code": 3423,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New Jersey (ftUS)",
    "code": 3424,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Iowa North (ftUS)",
    "code": 3425,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Iowa South (ftUS)",
    "code": 3426,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kansas North (ftUS)",
    "code": 3427,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Kansas South (ftUS)",
    "code": 3428,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada East (ftUS)",
    "code": 3429,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada Central (ftUS)",
    "code": 3430,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nevada West (ftUS)",
    "code": 3431,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Jersey (ftUS)",
    "code": 3432,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Arkansas North (ftUS)",
    "code": 3433,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Arkansas South (ftUS)",
    "code": 3434,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Illinois East (ftUS)",
    "code": 3435,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Illinois West (ftUS)",
    "code": 3436,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / New Hampshire (ftUS)",
    "code": 3437,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Rhode Island (ftUS)",
    "code": 3438,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "PSD93 / UTM zone 39N",
    "code": 3439,
    "projection": "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs "
  },
  {
    "name": "PSD93 / UTM zone 40N",
    "code": 3440,
    "projection": "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arkansas North (ftUS)",
    "code": 3441,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Arkansas South (ftUS)",
    "code": 3442,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Illinois East (ftUS)",
    "code": 3443,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Illinois West (ftUS)",
    "code": 3444,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / New Hampshire (ftUS)",
    "code": 3445,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Rhode Island (ftUS)",
    "code": 3446,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "ETRS89 / Belgian Lambert 2005",
    "code": 3447,
    "projection": "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=150328 +y_0=166262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JAD2001 / Jamaica Metric Grid",
    "code": 3448,
    "projection": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=750000 +y_0=650000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JAD2001 / UTM zone 17N",
    "code": 3449,
    "projection": "+proj=utm +zone=17 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JAD2001 / UTM zone 18N",
    "code": 3450,
    "projection": "+proj=utm +zone=18 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Louisiana North (ftUS)",
    "code": 3451,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Louisiana South (ftUS)",
    "code": 3452,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Louisiana Offshore (ftUS)",
    "code": 3453,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / South Dakota North (ftUS) (deprecated)",
    "code": 3454,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / South Dakota South (ftUS)",
    "code": 3455,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Louisiana North (ftUS)",
    "code": 3456,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Louisiana South (ftUS)",
    "code": 3457,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Dakota North (ftUS)",
    "code": 3458,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / South Dakota South (ftUS)",
    "code": 3459,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Fiji 1986 / Fiji Map Grid",
    "code": 3460,
    "projection": "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "Dabola 1981 / UTM zone 28N",
    "code": 3461,
    "projection": "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Dabola 1981 / UTM zone 29N",
    "code": 3462,
    "projection": "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine CS2000 Central",
    "code": 3463,
    "projection": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine CS2000 Central",
    "code": 3464,
    "projection": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alabama East",
    "code": 3465,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alabama West",
    "code": 3466,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska Albers",
    "code": 3467,
    "projection": "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 1",
    "code": 3468,
    "projection": "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 2",
    "code": 3469,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 3",
    "code": 3470,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 4",
    "code": 3471,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 5",
    "code": 3472,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 6",
    "code": 3473,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 7",
    "code": 3474,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 8",
    "code": 3475,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 9",
    "code": 3476,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Alaska zone 10",
    "code": 3477,
    "projection": "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona Central",
    "code": 3478,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona Central (ft)",
    "code": 3479,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona East",
    "code": 3480,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona East (ft)",
    "code": 3481,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona West",
    "code": 3482,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arizona West (ft)",
    "code": 3483,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arkansas North",
    "code": 3484,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arkansas North (ftUS)",
    "code": 3485,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arkansas South",
    "code": 3486,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Arkansas South (ftUS)",
    "code": 3487,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California Albers",
    "code": 3488,
    "projection": "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 1",
    "code": 3489,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 1 (ftUS)",
    "code": 3490,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 2",
    "code": 3491,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 2 (ftUS)",
    "code": 3492,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 3",
    "code": 3493,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 3 (ftUS)",
    "code": 3494,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 4",
    "code": 3495,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 4 (ftUS)",
    "code": 3496,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 5",
    "code": 3497,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 5 (ftUS)",
    "code": 3498,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 6",
    "code": 3499,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / California zone 6 (ftUS)",
    "code": 3500,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado Central",
    "code": 3501,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado Central (ftUS)",
    "code": 3502,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado North",
    "code": 3503,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado North (ftUS)",
    "code": 3504,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado South",
    "code": 3505,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Colorado South (ftUS)",
    "code": 3506,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Connecticut",
    "code": 3507,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Connecticut (ftUS)",
    "code": 3508,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Delaware",
    "code": 3509,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Delaware (ftUS)",
    "code": 3510,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida East",
    "code": 3511,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida East (ftUS)",
    "code": 3512,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida GDL Albers",
    "code": 3513,
    "projection": "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida North",
    "code": 3514,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida North (ftUS)",
    "code": 3515,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida West",
    "code": 3516,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Florida West (ftUS)",
    "code": 3517,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Georgia East",
    "code": 3518,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Georgia East (ftUS)",
    "code": 3519,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Georgia West",
    "code": 3520,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Georgia West (ftUS)",
    "code": 3521,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho Central",
    "code": 3522,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho Central (ftUS)",
    "code": 3523,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho East",
    "code": 3524,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho East (ftUS)",
    "code": 3525,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho West",
    "code": 3526,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Idaho West (ftUS)",
    "code": 3527,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Illinois East",
    "code": 3528,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Illinois East (ftUS)",
    "code": 3529,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Illinois West",
    "code": 3530,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Illinois West (ftUS)",
    "code": 3531,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Indiana East",
    "code": 3532,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Indiana East (ftUS)",
    "code": 3533,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Indiana West",
    "code": 3534,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Indiana West (ftUS)",
    "code": 3535,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Iowa North",
    "code": 3536,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Iowa North (ftUS)",
    "code": 3537,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Iowa South",
    "code": 3538,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Iowa South (ftUS)",
    "code": 3539,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kansas North",
    "code": 3540,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kansas North (ftUS)",
    "code": 3541,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kansas South",
    "code": 3542,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kansas South (ftUS)",
    "code": 3543,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky North",
    "code": 3544,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky North (ftUS)",
    "code": 3545,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky Single Zone",
    "code": 3546,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky Single Zone (ftUS)",
    "code": 3547,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky South",
    "code": 3548,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Kentucky South (ftUS)",
    "code": 3549,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Louisiana North",
    "code": 3550,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Louisiana North (ftUS)",
    "code": 3551,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Louisiana South",
    "code": 3552,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Louisiana South (ftUS)",
    "code": 3553,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine CS2000 Central",
    "code": 3554,
    "projection": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine CS2000 East",
    "code": 3555,
    "projection": "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine CS2000 West",
    "code": 3556,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine East",
    "code": 3557,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine West",
    "code": 3558,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maryland",
    "code": 3559,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Utah North (ftUS)",
    "code": 3560,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "Old Hawaiian / Hawaii zone 1",
    "code": 3561,
    "projection": "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Old Hawaiian / Hawaii zone 2",
    "code": 3562,
    "projection": "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Old Hawaiian / Hawaii zone 3",
    "code": 3563,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Old Hawaiian / Hawaii zone 4",
    "code": 3564,
    "projection": "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Old Hawaiian / Hawaii zone 5",
    "code": 3565,
    "projection": "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Utah Central (ftUS)",
    "code": 3566,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Utah South (ftUS)",
    "code": 3567,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah North (ftUS)",
    "code": 3568,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah Central (ftUS)",
    "code": 3569,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Utah South (ftUS)",
    "code": 3570,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Bering Sea",
    "code": 3571,
    "projection": "+proj=laea +lat_0=90 +lon_0=180 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Alaska",
    "code": 3572,
    "projection": "+proj=laea +lat_0=90 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Canada",
    "code": 3573,
    "projection": "+proj=laea +lat_0=90 +lon_0=-100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Atlantic",
    "code": 3574,
    "projection": "+proj=laea +lat_0=90 +lon_0=-40 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Europe",
    "code": 3575,
    "projection": "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / North Pole LAEA Russia",
    "code": 3576,
    "projection": "+proj=laea +lat_0=90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "GDA94 / Australian Albers",
    "code": 3577,
    "projection": "+proj=aea +lat_1=-18 +lat_2=-36 +lat_0=0 +lon_0=132 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Yukon Albers",
    "code": 3578,
    "projection": "+proj=aea +lat_1=61.66666666666666 +lat_2=68 +lat_0=59 +lon_0=-132.5 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Yukon Albers",
    "code": 3579,
    "projection": "+proj=aea +lat_1=61.66666666666666 +lat_2=68 +lat_0=59 +lon_0=-132.5 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / NWT Lambert",
    "code": 3580,
    "projection": "+proj=lcc +lat_1=62 +lat_2=70 +lat_0=0 +lon_0=-112 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / NWT Lambert",
    "code": 3581,
    "projection": "+proj=lcc +lat_1=62 +lat_2=70 +lat_0=0 +lon_0=-112 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maryland (ftUS)",
    "code": 3582,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Massachusetts Island",
    "code": 3583,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Massachusetts Island (ftUS)",
    "code": 3584,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Massachusetts Mainland",
    "code": 3585,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Massachusetts Mainland (ftUS)",
    "code": 3586,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan Central",
    "code": 3587,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan Central (ft)",
    "code": 3588,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan North",
    "code": 3589,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan North (ft)",
    "code": 3590,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan Oblique Mercator",
    "code": 3591,
    "projection": "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan South",
    "code": 3592,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Michigan South (ft)",
    "code": 3593,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota Central",
    "code": 3594,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota North",
    "code": 3595,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota South",
    "code": 3596,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Mississippi East",
    "code": 3597,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Mississippi East (ftUS)",
    "code": 3598,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Mississippi West",
    "code": 3599,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Mississippi West (ftUS)",
    "code": 3600,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Missouri Central",
    "code": 3601,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Missouri East",
    "code": 3602,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Missouri West",
    "code": 3603,
    "projection": "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Montana",
    "code": 3604,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Montana (ft)",
    "code": 3605,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nebraska",
    "code": 3606,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada Central",
    "code": 3607,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada Central (ftUS)",
    "code": 3608,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada East",
    "code": 3609,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada East (ftUS)",
    "code": 3610,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada West",
    "code": 3611,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nevada West (ftUS)",
    "code": 3612,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Hampshire",
    "code": 3613,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Hampshire (ftUS)",
    "code": 3614,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Jersey",
    "code": 3615,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Jersey (ftUS)",
    "code": 3616,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico Central",
    "code": 3617,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico Central (ftUS)",
    "code": 3618,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico East",
    "code": 3619,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico East (ftUS)",
    "code": 3620,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico West",
    "code": 3621,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New Mexico West (ftUS)",
    "code": 3622,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York Central",
    "code": 3623,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York Central (ftUS)",
    "code": 3624,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York East",
    "code": 3625,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York East (ftUS)",
    "code": 3626,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York Long Island",
    "code": 3627,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York Long Island (ftUS)",
    "code": 3628,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York West",
    "code": 3629,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / New York West (ftUS)",
    "code": 3630,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Carolina",
    "code": 3631,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Carolina (ftUS)",
    "code": 3632,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Dakota North",
    "code": 3633,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Dakota North (ft)",
    "code": 3634,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Dakota South",
    "code": 3635,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / North Dakota South (ft)",
    "code": 3636,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Ohio North",
    "code": 3637,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Ohio South",
    "code": 3638,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oklahoma North",
    "code": 3639,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oklahoma North (ftUS)",
    "code": 3640,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oklahoma South",
    "code": 3641,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oklahoma South (ftUS)",
    "code": 3642,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon LCC (m)",
    "code": 3643,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon GIC Lambert (ft)",
    "code": 3644,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon North",
    "code": 3645,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon North (ft)",
    "code": 3646,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon South",
    "code": 3647,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Oregon South (ft)",
    "code": 3648,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Pennsylvania North",
    "code": 3649,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Pennsylvania North (ftUS)",
    "code": 3650,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Pennsylvania South",
    "code": 3651,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Pennsylvania South (ftUS)",
    "code": 3652,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Rhode Island",
    "code": 3653,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Rhode Island (ftUS)",
    "code": 3654,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Carolina",
    "code": 3655,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Carolina (ft)",
    "code": 3656,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Dakota North",
    "code": 3657,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Dakota North (ftUS)",
    "code": 3658,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Dakota South",
    "code": 3659,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / South Dakota South (ftUS)",
    "code": 3660,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Tennessee",
    "code": 3661,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Tennessee (ftUS)",
    "code": 3662,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas Central",
    "code": 3663,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas Central (ftUS)",
    "code": 3664,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas Centric Albers Equal Area",
    "code": 3665,
    "projection": "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas Centric Lambert Conformal",
    "code": 3666,
    "projection": "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas North",
    "code": 3667,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas North (ftUS)",
    "code": 3668,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas North Central",
    "code": 3669,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas North Central (ftUS)",
    "code": 3670,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas South",
    "code": 3671,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas South (ftUS)",
    "code": 3672,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas South Central",
    "code": 3673,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Texas South Central (ftUS)",
    "code": 3674,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah Central",
    "code": 3675,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah Central (ft)",
    "code": 3676,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah Central (ftUS)",
    "code": 3677,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah North",
    "code": 3678,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah North (ft)",
    "code": 3679,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah North (ftUS)",
    "code": 3680,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah South",
    "code": 3681,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah South (ft)",
    "code": 3682,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Utah South (ftUS)",
    "code": 3683,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Vermont",
    "code": 3684,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Virginia North",
    "code": 3685,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Virginia North (ftUS)",
    "code": 3686,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Virginia South",
    "code": 3687,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Virginia South (ftUS)",
    "code": 3688,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Washington North",
    "code": 3689,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Washington North (ftUS)",
    "code": 3690,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Washington South",
    "code": 3691,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Washington South (ftUS)",
    "code": 3692,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia North",
    "code": 3693,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia South",
    "code": 3694,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin Central",
    "code": 3695,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin Central (ftUS)",
    "code": 3696,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin North",
    "code": 3697,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin North (ftUS)",
    "code": 3698,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin South",
    "code": 3699,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin South (ftUS)",
    "code": 3700,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wisconsin Transverse Mercator",
    "code": 3701,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming East",
    "code": 3702,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming East Central",
    "code": 3703,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming West Central",
    "code": 3704,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming West",
    "code": 3705,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 59N",
    "code": 3706,
    "projection": "+proj=utm +zone=59 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 60N",
    "code": 3707,
    "projection": "+proj=utm +zone=60 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 1N",
    "code": 3708,
    "projection": "+proj=utm +zone=1 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 2N",
    "code": 3709,
    "projection": "+proj=utm +zone=2 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 3N",
    "code": 3710,
    "projection": "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 4N",
    "code": 3711,
    "projection": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 5N",
    "code": 3712,
    "projection": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 6N",
    "code": 3713,
    "projection": "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 7N",
    "code": 3714,
    "projection": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 8N",
    "code": 3715,
    "projection": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 9N",
    "code": 3716,
    "projection": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 10N",
    "code": 3717,
    "projection": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 11N",
    "code": 3718,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 12N",
    "code": 3719,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 13N",
    "code": 3720,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 14N",
    "code": 3721,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 15N",
    "code": 3722,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 16N",
    "code": 3723,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 17N",
    "code": 3724,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 18N",
    "code": 3725,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / UTM zone 19N",
    "code": 3726,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Reunion 1947 / TM Reunion",
    "code": 3727,
    "projection": "+proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Ohio North (ftUS)",
    "code": 3728,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Ohio South (ftUS)",
    "code": 3729,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming East (ftUS)",
    "code": 3730,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming East Central (ftUS)",
    "code": 3731,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming West Central (ftUS)",
    "code": 3732,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Wyoming West (ftUS)",
    "code": 3733,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Ohio North (ftUS)",
    "code": 3734,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Ohio South (ftUS)",
    "code": 3735,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wyoming East (ftUS)",
    "code": 3736,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wyoming East Central (ftUS)",
    "code": 3737,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wyoming West Central (ftUS)",
    "code": 3738,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Wyoming West (ftUS)",
    "code": 3739,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 10N",
    "code": 3740,
    "projection": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 11N",
    "code": 3741,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 12N",
    "code": 3742,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 13N",
    "code": 3743,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 14N",
    "code": 3744,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 15N",
    "code": 3745,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 16N",
    "code": 3746,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 17N",
    "code": 3747,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 18N",
    "code": 3748,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 19N",
    "code": 3749,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 4N",
    "code": 3750,
    "projection": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / UTM zone 5N",
    "code": 3751,
    "projection": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Mercator 41 (deprecated)",
    "code": 3752,
    "projection": "+proj=merc +lon_0=100 +lat_ts=-41 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Ohio North (ftUS)",
    "code": 3753,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Ohio South (ftUS)",
    "code": 3754,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming East (ftUS)",
    "code": 3755,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming East Central (ftUS)",
    "code": 3756,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming West Central (ftUS)",
    "code": 3757,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Wyoming West (ftUS)",
    "code": 3758,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 3 (ftUS)",
    "code": 3759,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Hawaii zone 3 (ftUS)",
    "code": 3760,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 22N",
    "code": 3761,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / South Georgia Lambert",
    "code": 3762,
    "projection": "+proj=lcc +lat_1=-54 +lat_2=-54.75 +lat_0=-55 +lon_0=-37 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Portugal TM06",
    "code": 3763,
    "projection": "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Chatham Island Circuit 2000",
    "code": 3764,
    "projection": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "HTRS96 / Croatia TM",
    "code": 3765,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "HTRS96 / Croatia LCC",
    "code": 3766,
    "projection": "+proj=lcc +lat_1=45.91666666666666 +lat_2=43.08333333333334 +lat_0=0 +lon_0=16.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "HTRS96 / UTM zone 33N",
    "code": 3767,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "HTRS96 / UTM zone 34N",
    "code": 3768,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bermuda 1957 / UTM zone 20N",
    "code": 3769,
    "projection": "+proj=utm +zone=20 +ellps=clrk66 +towgs84=-73,213,296,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "BDA2000 / Bermuda 2000 National Grid",
    "code": 3770,
    "projection": "+proj=tmerc +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000 +y_0=100000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alberta 3TM ref merid 111 W",
    "code": 3771,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alberta 3TM ref merid 114 W",
    "code": 3772,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alberta 3TM ref merid 117 W",
    "code": 3773,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alberta 3TM ref merid 120 W (deprecated)",
    "code": 3774,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 3TM ref merid 111 W",
    "code": 3775,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 3TM ref merid 114 W",
    "code": 3776,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 3TM ref merid 117 W",
    "code": 3777,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 3TM ref merid 120 W (deprecated)",
    "code": 3778,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 3TM ref merid 111 W",
    "code": 3779,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 3TM ref merid 114 W",
    "code": 3780,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 3TM ref merid 117 W",
    "code": 3781,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 3TM ref merid 120 W (deprecated)",
    "code": 3782,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pitcairn 2006 / Pitcairn TM 2006",
    "code": 3783,
    "projection": "+proj=tmerc +lat_0=-25.06855261111111 +lon_0=-130.1129671111111 +k=1 +x_0=14200 +y_0=15500 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pitcairn 1967 / UTM zone 9S",
    "code": 3784,
    "projection": "+proj=utm +zone=9 +south +ellps=intl +towgs84=185,165,42,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Popular Visualisation CRS / Mercator (deprecated)",
    "code": 3785,
    "projection": "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs"
  },
  {
    "name": "World Equidistant Cylindrical (Sphere) (deprecated)",
    "code": 3786,
    "projection": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371007 +b=6371007 +units=m +no_defs "
  },
  {
    "name": "MGI / Slovene National Grid (deprecated)",
    "code": 3787,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Auckland Islands TM 2000",
    "code": 3788,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=166 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Campbell Island TM 2000",
    "code": 3789,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=169 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Antipodes Islands TM 2000",
    "code": 3790,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=179 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Raoul Island TM 2000",
    "code": 3791,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-178 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / Chatham Islands TM 2000",
    "code": 3793,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-176.5 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Slovenia 1996 / Slovene National Grid",
    "code": 3794,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Cuba Norte",
    "code": 3795,
    "projection": "+proj=lcc +lat_1=23 +lat_2=21.7 +lat_0=22.35 +lon_0=-81 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Cuba Sur",
    "code": 3796,
    "projection": "+proj=lcc +lat_1=21.3 +lat_2=20.13333333333333 +lat_0=20.71666666666667 +lon_0=-76.83333333333333 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTQ Lambert",
    "code": 3797,
    "projection": "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTQ Lambert",
    "code": 3798,
    "projection": "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTQ Lambert",
    "code": 3799,
    "projection": "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alberta 3TM ref merid 120 W",
    "code": 3800,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alberta 3TM ref merid 120 W",
    "code": 3801,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Alberta 3TM ref merid 120 W",
    "code": 3802,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Belgian Lambert 2008",
    "code": 3812,
    "projection": "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Mississippi TM",
    "code": 3814,
    "projection": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Mississippi TM",
    "code": 3815,
    "projection": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Mississippi TM",
    "code": 3816,
    "projection": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TWD97 / TM2 zone 119",
    "code": 3825,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TWD97 / TM2 zone 121",
    "code": 3826,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TWD67 / TM2 zone 119",
    "code": 3827,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs "
  },
  {
    "name": "TWD67 / TM2 zone 121",
    "code": 3828,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs "
  },
  {
    "name": "Hu Tzu Shan 1950 / UTM zone 51N",
    "code": 3829,
    "projection": "+proj=utm +zone=51 +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / PDC Mercator",
    "code": 3832,
    "projection": "+proj=merc +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 2",
    "code": 3833,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss-Kruger zone 2",
    "code": 3834,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss-Kruger zone 3",
    "code": 3835,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss-Kruger zone 4",
    "code": 3836,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3",
    "code": 3837,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4",
    "code": 3838,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 9",
    "code": 3839,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 10",
    "code": 3840,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 6",
    "code": 3841,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 7 (deprecated)",
    "code": 3842,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 8 (deprecated)",
    "code": 3843,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Stereo70",
    "code": 3844,
    "projection": "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=2.329,-147.042,-92.08,0.309,-0.325,-0.497,5.69 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 7.5 gon V emulation",
    "code": 3845,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 5 gon V emulation",
    "code": 3846,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.55626666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 2.5 gon V emulation",
    "code": 3847,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.80628452944445 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 0 gon emulation",
    "code": 3848,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.8440000000001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 2.5 gon O emulation",
    "code": 3849,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.30631666666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 / RT90 5 gon O emulation",
    "code": 3850,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22.55633333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / NZCS2000",
    "code": 3851,
    "projection": "+proj=lcc +lat_1=-37.5 +lat_2=-44.5 +lat_0=-41 +lon_0=173 +x_0=3000000 +y_0=7000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RSRGD2000 / DGLC2000",
    "code": 3852,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=157 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "County ST74",
    "code": 3854,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Pseudo-Mercator",
    "code": 3857,
    "projection": "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs"
  },
  {
    "name": "ETRS89 / GK19FIN",
    "code": 3873,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK20FIN",
    "code": 3874,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK21FIN",
    "code": 3875,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK22FIN",
    "code": 3876,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK23FIN",
    "code": 3877,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK24FIN",
    "code": 3878,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=24500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK25FIN",
    "code": 3879,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK26FIN",
    "code": 3880,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK27FIN",
    "code": 3881,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK28FIN",
    "code": 3882,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK29FIN",
    "code": 3883,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK30FIN",
    "code": 3884,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / GK31FIN",
    "code": 3885,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGRS / UTM zone 37N",
    "code": 3890,
    "projection": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGRS / UTM zone 38N",
    "code": 3891,
    "projection": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "IGRS / UTM zone 39N",
    "code": 3892,
    "projection": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / Iraq National Grid",
    "code": 3893,
    "projection": "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Balkans zone 5",
    "code": 3907,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Balkans zone 6",
    "code": 3908,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Balkans zone 7",
    "code": 3909,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Balkans zone 8",
    "code": 3910,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Slovenia Grid",
    "code": 3911,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI 1901 / Slovene National Grid",
    "code": 3912,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Puerto Rico / UTM zone 20N",
    "code": 3920,
    "projection": "+proj=utm +zone=20 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC42",
    "code": 3942,
    "projection": "+proj=lcc +lat_1=41.25 +lat_2=42.75 +lat_0=42 +lon_0=3 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC43",
    "code": 3943,
    "projection": "+proj=lcc +lat_1=42.25 +lat_2=43.75 +lat_0=43 +lon_0=3 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC44",
    "code": 3944,
    "projection": "+proj=lcc +lat_1=43.25 +lat_2=44.75 +lat_0=44 +lon_0=3 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC45",
    "code": 3945,
    "projection": "+proj=lcc +lat_1=44.25 +lat_2=45.75 +lat_0=45 +lon_0=3 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC46",
    "code": 3946,
    "projection": "+proj=lcc +lat_1=45.25 +lat_2=46.75 +lat_0=46 +lon_0=3 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC47",
    "code": 3947,
    "projection": "+proj=lcc +lat_1=46.25 +lat_2=47.75 +lat_0=47 +lon_0=3 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC48",
    "code": 3948,
    "projection": "+proj=lcc +lat_1=47.25 +lat_2=48.75 +lat_0=48 +lon_0=3 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC49",
    "code": 3949,
    "projection": "+proj=lcc +lat_1=48.25 +lat_2=49.75 +lat_0=49 +lon_0=3 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGF93 / CC50",
    "code": 3950,
    "projection": "+proj=lcc +lat_1=49.25 +lat_2=50.75 +lat_0=50 +lon_0=3 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Virginia Lambert",
    "code": 3968,
    "projection": "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Virginia Lambert",
    "code": 3969,
    "projection": "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Virginia Lambert",
    "code": 3970,
    "projection": "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid North (deprecated)",
    "code": 3973,
    "projection": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid South (deprecated)",
    "code": 3974,
    "projection": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid Global (deprecated)",
    "code": 3975,
    "projection": "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC Sea Ice Polar Stereographic South",
    "code": 3976,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Canada Atlas Lambert",
    "code": 3978,
    "projection": "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Canada Atlas Lambert",
    "code": 3979,
    "projection": "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Lambert (deprecated)",
    "code": 3985,
    "projection": "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=9 +lon_0=26 +x_0=500000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Gauss zone A",
    "code": 3986,
    "projection": "+proj=tmerc +lat_0=-9 +lon_0=30 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Gauss zone B",
    "code": 3987,
    "projection": "+proj=tmerc +lat_0=-9 +lon_0=28 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Gauss zone C",
    "code": 3988,
    "projection": "+proj=tmerc +lat_0=-9 +lon_0=26 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Gauss zone D",
    "code": 3989,
    "projection": "+proj=tmerc +lat_0=-9 +lon_0=24 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Puerto Rico State Plane CS of 1927",
    "code": 3991,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Puerto Rico / St. Croix",
    "code": 3992,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=30480.06096012192 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / Mercator 41",
    "code": 3994,
    "projection": "+proj=merc +lon_0=100 +lat_ts=-41 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Arctic Polar Stereographic",
    "code": 3995,
    "projection": "+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / IBCAO Polar Stereographic",
    "code": 3996,
    "projection": "+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Dubai Local TM",
    "code": 3997,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=55.33333333333334 +k=1 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "MOLDREF99 / Moldova TM",
    "code": 4026,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28.4 +k=0.9999400000000001 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TMzn35N",
    "code": 4037,
    "projection": "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TMzn36N",
    "code": 4038,
    "projection": "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 12",
    "code": 4048,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 14",
    "code": 4049,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 16",
    "code": 4050,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 18",
    "code": 4051,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 20",
    "code": 4056,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 22",
    "code": 4057,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 24",
    "code": 4058,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 26",
    "code": 4059,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 28",
    "code": 4060,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / UTM zone 33S",
    "code": 4061,
    "projection": "+proj=utm +zone=33 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / UTM zone 34S",
    "code": 4062,
    "projection": "+proj=utm +zone=34 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / UTM zone 35S",
    "code": 4063,
    "projection": "+proj=utm +zone=35 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Chua / UTM zone 23S",
    "code": 4071,
    "projection": "+proj=utm +zone=23 +south +ellps=intl +towgs84=-143.87,243.37,-33.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGCAN95 / UTM zone 27N",
    "code": 4082,
    "projection": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGCAN95 / UTM zone 28N",
    "code": 4083,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / World Equidistant Cylindrical",
    "code": 4087,
    "projection": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "World Equidistant Cylindrical (Sphere)",
    "code": 4088,
    "projection": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371007 +b=6371007 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM1",
    "code": 4093,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM2",
    "code": 4094,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM3",
    "code": 4095,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM4",
    "code": 4096,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / BLM 59N (ftUS)",
    "code": 4217,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "Kertau 1968 / Johor Grid",
    "code": 4390,
    "projection": "+proj=cass +lat_0=2.042583333333333 +lon_0=103.5627583333333 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Sembilan and Melaka Grid",
    "code": 4391,
    "projection": "+proj=cass +lat_0=2.712283333333334 +lon_0=101.9411666666667 +x_0=-242.005 +y_0=-948.547 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Pahang Grid",
    "code": 4392,
    "projection": "+proj=cass +lat_0=3.710972222222222 +lon_0=102.4361777777778 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Selangor Grid",
    "code": 4393,
    "projection": "+proj=cass +lat_0=3.680344444444444 +lon_0=101.5082444444444 +x_0=-21759.438 +y_0=55960.906 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Terengganu Grid",
    "code": 4394,
    "projection": "+proj=cass +lat_0=4.946141666666667 +lon_0=102.8952083333333 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Pinang Grid",
    "code": 4395,
    "projection": "+proj=cass +lat_0=5.421325 +lon_0=100.3458694444444 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Kedah and Perlis Grid",
    "code": 4396,
    "projection": "+proj=cass +lat_0=5.965147222222223 +lon_0=100.6375944444444 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Perak Revised Grid",
    "code": 4397,
    "projection": "+proj=cass +lat_0=4.859380555555555 +lon_0=100.8167666666667 +x_0=0 +y_0=133453.669 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Kelantan Grid",
    "code": 4398,
    "projection": "+proj=cass +lat_0=5.893922222222222 +lon_0=102.1772916666667 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / BLM 59N (ftUS)",
    "code": 4399,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 60N (ftUS)",
    "code": 4400,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 1N (ftUS)",
    "code": 4401,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 2N (ftUS)",
    "code": 4402,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 3N (ftUS)",
    "code": 4403,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 4N (ftUS)",
    "code": 4404,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 5N (ftUS)",
    "code": 4405,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 6N (ftUS)",
    "code": 4406,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 7N (ftUS)",
    "code": 4407,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 8N (ftUS)",
    "code": 4408,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 9N (ftUS)",
    "code": 4409,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 10N (ftUS)",
    "code": 4410,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 11N (ftUS)",
    "code": 4411,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 12N (ftUS)",
    "code": 4412,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 13N (ftUS)",
    "code": 4413,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Guam Map Grid",
    "code": 4414,
    "projection": "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Katanga 1955 / Katanga Lambert",
    "code": 4415,
    "projection": "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=-9 +lon_0=26 +x_0=500000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 7",
    "code": 4417,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / BLM 18N (ftUS)",
    "code": 4418,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 19N (ftUS)",
    "code": 4419,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 60N (ftUS)",
    "code": 4420,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 1N (ftUS)",
    "code": 4421,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 2N (ftUS)",
    "code": 4422,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 3N (ftUS)",
    "code": 4423,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 4N (ftUS)",
    "code": 4424,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 5N (ftUS)",
    "code": 4425,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 6N (ftUS)",
    "code": 4426,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 7N (ftUS)",
    "code": 4427,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 8N (ftUS)",
    "code": 4428,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 9N (ftUS)",
    "code": 4429,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 10N (ftUS)",
    "code": 4430,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 11N (ftUS)",
    "code": 4431,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 12N (ftUS)",
    "code": 4432,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 13N (ftUS)",
    "code": 4433,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 8",
    "code": 4434,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Puerto Rico and Virgin Is.",
    "code": 4437,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / BLM 18N (ftUS)",
    "code": 4438,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 19N (ftUS)",
    "code": 4439,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Pennsylvania South",
    "code": 4455,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New York Long Island",
    "code": 4456,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.5 +lon_0=-74 +x_0=609601.2192024384 +y_0=30480.06096012192 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / South Dakota North (ftUS)",
    "code": 4457,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / Australian Centre for Remote Sensing Lambert",
    "code": 4462,
    "projection": "+proj=lcc +lat_1=-18 +lat_2=-36 +lat_0=-27 +lon_0=132 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RGSPM06 / UTM zone 21N",
    "code": 4467,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGM04 / UTM zone 38S",
    "code": 4471,
    "projection": "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cadastre 1997 / UTM zone 38S (deprecated)",
    "code": 4474,
    "projection": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 11N",
    "code": 4484,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 12N",
    "code": 4485,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 13N",
    "code": 4486,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 14N",
    "code": 4487,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 15N",
    "code": 4488,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / UTM zone 16N",
    "code": 4489,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 13",
    "code": 4491,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 14",
    "code": 4492,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 15",
    "code": 4493,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 16",
    "code": 4494,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 17",
    "code": 4495,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 18",
    "code": 4496,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 19",
    "code": 4497,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 20",
    "code": 4498,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 21",
    "code": 4499,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 22",
    "code": 4500,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger zone 23",
    "code": 4501,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 75E",
    "code": 4502,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 81E",
    "code": 4503,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 87E",
    "code": 4504,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 93E",
    "code": 4505,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 99E",
    "code": 4506,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 105E",
    "code": 4507,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 111E",
    "code": 4508,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 117E",
    "code": 4509,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 123E",
    "code": 4510,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 129E",
    "code": 4511,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / Gauss-Kruger CM 135E",
    "code": 4512,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 25",
    "code": 4513,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 26",
    "code": 4514,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 27",
    "code": 4515,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 28",
    "code": 4516,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 29",
    "code": 4517,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 30",
    "code": 4518,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 31",
    "code": 4519,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 32",
    "code": 4520,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 33",
    "code": 4521,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 34",
    "code": 4522,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 35",
    "code": 4523,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 36",
    "code": 4524,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 37",
    "code": 4525,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 38",
    "code": 4526,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 39",
    "code": 4527,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 40",
    "code": 4528,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 41",
    "code": 4529,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 42",
    "code": 4530,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 43",
    "code": 4531,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 44",
    "code": 4532,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger zone 45",
    "code": 4533,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 75E",
    "code": 4534,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 78E",
    "code": 4535,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 81E",
    "code": 4536,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 84E",
    "code": 4537,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 87E",
    "code": 4538,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 90E",
    "code": 4539,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 93E",
    "code": 4540,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 96E",
    "code": 4541,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 99E",
    "code": 4542,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 102E",
    "code": 4543,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 105E",
    "code": 4544,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 108E",
    "code": 4545,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 111E",
    "code": 4546,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 114E",
    "code": 4547,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 117E",
    "code": 4548,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 120E",
    "code": 4549,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 123E",
    "code": 4550,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 126E",
    "code": 4551,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 129E",
    "code": 4552,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 132E",
    "code": 4553,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGCS2000 / 3-degree Gauss-Kruger CM 135E",
    "code": 4554,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RRAF 1991 / UTM zone 20N",
    "code": 4559,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 13",
    "code": 4568,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 14",
    "code": 4569,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 15",
    "code": 4570,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 16",
    "code": 4571,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 17",
    "code": 4572,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 18",
    "code": 4573,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 19",
    "code": 4574,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 20",
    "code": 4575,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 21",
    "code": 4576,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 22",
    "code": 4577,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger zone 23",
    "code": 4578,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 75E",
    "code": 4579,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 81E",
    "code": 4580,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 87E",
    "code": 4581,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 93E",
    "code": 4582,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 99E",
    "code": 4583,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 105E",
    "code": 4584,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 111E",
    "code": 4585,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 117E",
    "code": 4586,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 123E",
    "code": 4587,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 129E",
    "code": 4588,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / Gauss-Kruger CM 135E",
    "code": 4589,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N (zE-N)",
    "code": 4647,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 25",
    "code": 4652,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 26",
    "code": 4653,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 27",
    "code": 4654,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 28",
    "code": 4655,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 29",
    "code": 4656,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 30",
    "code": 4766,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 31",
    "code": 4767,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 32",
    "code": 4768,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 33",
    "code": 4769,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 34",
    "code": 4770,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 35",
    "code": 4771,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 36",
    "code": 4772,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 37",
    "code": 4773,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 38",
    "code": 4774,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 39",
    "code": 4775,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 40",
    "code": 4776,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 41",
    "code": 4777,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 42",
    "code": 4778,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 43",
    "code": 4779,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 44",
    "code": 4780,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger zone 45",
    "code": 4781,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 75E",
    "code": 4782,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 78E",
    "code": 4783,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 81E",
    "code": 4784,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 84E",
    "code": 4785,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 87E",
    "code": 4786,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 90E",
    "code": 4787,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 93E",
    "code": 4788,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 96E",
    "code": 4789,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 99E",
    "code": 4790,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 102E",
    "code": 4791,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 105E",
    "code": 4792,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 108E",
    "code": 4793,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 111E",
    "code": 4794,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 114E",
    "code": 4795,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 117E",
    "code": 4796,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 120E",
    "code": 4797,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 123E",
    "code": 4798,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 126E",
    "code": 4799,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 129E",
    "code": 4800,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 132E",
    "code": 4812,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "New Beijing / 3-degree Gauss-Kruger CM 135E",
    "code": 4822,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Cape Verde National",
    "code": 4826,
    "projection": "+proj=lcc +lat_1=15 +lat_2=16.66666666666667 +lat_0=15.83333333333333 +lon_0=-24 +x_0=161587.83 +y_0=128511.202 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / LCC Germany (N-E)",
    "code": 4839,
    "projection": "+proj=lcc +lat_1=48.66666666666666 +lat_2=53.66666666666666 +lat_0=51 +lon_0=10.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 5 (deprecated)",
    "code": 4855,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 6 (deprecated)",
    "code": 4856,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 7 (deprecated)",
    "code": 4857,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 8 (deprecated)",
    "code": 4858,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 9 (deprecated)",
    "code": 4859,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 10 (deprecated)",
    "code": 4860,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 11 (deprecated)",
    "code": 4861,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 12 (deprecated)",
    "code": 4862,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 13 (deprecated)",
    "code": 4863,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 14 (deprecated)",
    "code": 4864,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 15 (deprecated)",
    "code": 4865,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 16 (deprecated)",
    "code": 4866,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 17 (deprecated)",
    "code": 4867,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 18 (deprecated)",
    "code": 4868,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 19 (deprecated)",
    "code": 4869,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 20 (deprecated)",
    "code": 4870,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 21 (deprecated)",
    "code": 4871,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 22 (deprecated)",
    "code": 4872,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 23 (deprecated)",
    "code": 4873,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 24 (deprecated)",
    "code": 4874,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 25 (deprecated)",
    "code": 4875,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 26 (deprecated)",
    "code": 4876,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 27 (deprecated)",
    "code": 4877,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 28 (deprecated)",
    "code": 4878,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 29 (deprecated)",
    "code": 4879,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 30 (deprecated)",
    "code": 4880,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PTRA08 / UTM zone 25N",
    "code": 5014,
    "projection": "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PTRA08 / UTM zone 26N",
    "code": 5015,
    "projection": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PTRA08 / UTM zone 28N",
    "code": 5016,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Lisbon / Portuguese Grid New",
    "code": 5018,
    "projection": "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=0 +y_0=0 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UPS North (E,N)",
    "code": 5041,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UPS South (E,N)",
    "code": 5042,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM35FIN(N,E)",
    "code": 5048,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Conus Albers",
    "code": 5069,
    "projection": "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Conus Albers",
    "code": 5070,
    "projection": "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Conus Albers",
    "code": 5071,
    "projection": "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Conus Albers",
    "code": 5072,
    "projection": "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 5",
    "code": 5105,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 6",
    "code": 5106,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 7",
    "code": 5107,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 8",
    "code": 5108,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 9",
    "code": 5109,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 10",
    "code": 5110,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 11",
    "code": 5111,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 12",
    "code": 5112,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 13",
    "code": 5113,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 14",
    "code": 5114,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 15",
    "code": 5115,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 16",
    "code": 5116,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 17",
    "code": 5117,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 18",
    "code": 5118,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 19",
    "code": 5119,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 20",
    "code": 5120,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 21",
    "code": 5121,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 22",
    "code": 5122,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 23",
    "code": 5123,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 24",
    "code": 5124,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 25",
    "code": 5125,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 26",
    "code": 5126,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 27",
    "code": 5127,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 28",
    "code": 5128,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 29",
    "code": 5129,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 30",
    "code": 5130,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / East Sea Belt",
    "code": 5167,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Central Belt Jeju",
    "code": 5168,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Tokyo 1892 / Korea West Belt",
    "code": 5169,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Tokyo 1892 / Korea Central Belt",
    "code": 5170,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Tokyo 1892 / Korea East Belt",
    "code": 5171,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Tokyo 1892 / Korea East Sea Belt",
    "code": 5172,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Modified West Belt",
    "code": 5173,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=125.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Modified Central Belt",
    "code": 5174,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Modified Central Belt Jeju",
    "code": 5175,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Modified East Belt",
    "code": 5176,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=129.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Modified East Sea Belt",
    "code": 5177,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=131.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korean 1985 / Unified CS",
    "code": 5178,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / Unified CS",
    "code": 5179,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / West Belt",
    "code": 5180,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / Central Belt",
    "code": 5181,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / Central Belt Jeju",
    "code": 5182,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / East Belt",
    "code": 5183,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / East Sea Belt",
    "code": 5184,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / West Belt 2010",
    "code": 5185,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / Central Belt 2010",
    "code": 5186,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / East Belt 2010",
    "code": 5187,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Korea 2000 / East Sea Belt 2010",
    "code": 5188,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "S-JTSK (Ferro) / Krovak East North",
    "code": 5221,
    "projection": "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Gabon TM",
    "code": 5223,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "Kandawala / Sri Lanka Grid",
    "code": 5234,
    "projection": "+proj=tmerc +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k=0.9999238418 +x_0=200000 +y_0=200000 +a=6377276.345 +b=6356075.41314024 +towgs84=-97,787,86,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SLD99 / Sri Lanka Grid 1999",
    "code": 5235,
    "projection": "+proj=tmerc +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k=0.9999238418 +x_0=500000 +y_0=500000 +a=6377276.345 +b=6356075.41314024 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / LCC Germany (E-N)",
    "code": 5243,
    "projection": "+proj=lcc +lat_1=48.66666666666666 +lat_2=53.66666666666666 +lat_0=51 +lon_0=10.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDBD2009 / Brunei BRSO",
    "code": 5247,
    "projection": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31580995 +k=0.99984 +x_0=0 +y_0=0 +no_uoff +gamma=53.13010236111111 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM27",
    "code": 5253,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM30",
    "code": 5254,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM33",
    "code": 5255,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM36",
    "code": 5256,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM39",
    "code": 5257,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM42",
    "code": 5258,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / TM45",
    "code": 5259,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Bhutan National Grid",
    "code": 5266,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 9",
    "code": 5269,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 10",
    "code": 5270,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 11",
    "code": 5271,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 12",
    "code": 5272,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 13",
    "code": 5273,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 14",
    "code": 5274,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / 3-degree Gauss-Kruger zone 15",
    "code": 5275,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Bumthang TM",
    "code": 5292,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.73333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Chhukha TM",
    "code": 5293,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Dagana TM",
    "code": 5294,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.84999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Gasa TM",
    "code": 5295,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.03333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Ha TM",
    "code": 5296,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.15000000000001 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Lhuentse TM",
    "code": 5297,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.13333333333334 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Mongar TM",
    "code": 5298,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.23333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Paro TM",
    "code": 5299,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.34999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Pemagatshel TM",
    "code": 5300,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.34999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Punakha TM",
    "code": 5301,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.84999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Samdrup Jongkhar TM",
    "code": 5302,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Samtse TM",
    "code": 5303,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.06666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Sarpang TM",
    "code": 5304,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.26666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Thimphu TM",
    "code": 5305,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Trashigang TM",
    "code": 5306,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.75 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Trongsa TM",
    "code": 5307,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.5 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Tsirang TM",
    "code": 5308,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.16666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Wangdue Phodrang TM",
    "code": 5309,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.11666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Yangtse TM",
    "code": 5310,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03 / Zhemgang TM",
    "code": 5311,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=90.86666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Faroe TM",
    "code": 5316,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Teranet Ontario Lambert",
    "code": 5320,
    "projection": "+proj=lcc +lat_1=44.5 +lat_2=54.5 +lat_0=0 +lon_0=-84 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Teranet Ontario Lambert",
    "code": 5321,
    "projection": "+proj=lcc +lat_1=44.5 +lat_2=54.5 +lat_0=0 +lon_0=-84 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ISN2004 / Lambert 2004",
    "code": 5325,
    "projection": "+proj=lcc +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19 +x_0=1700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Segara (Jakarta) / NEIEZ",
    "code": 5329,
    "projection": "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "Batavia (Jakarta) / NEIEZ",
    "code": 5330,
    "projection": "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "Makassar (Jakarta) / NEIEZ",
    "code": 5331,
    "projection": "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "Aratu / UTM zone 25S",
    "code": 5337,
    "projection": "+proj=utm +zone=25 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 1",
    "code": 5343,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 2",
    "code": 5344,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 3",
    "code": 5345,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 4",
    "code": 5346,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 5",
    "code": 5347,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 6",
    "code": 5348,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007 / Argentina 7",
    "code": 5349,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MARGEN / UTM zone 20S",
    "code": 5355,
    "projection": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MARGEN / UTM zone 19S",
    "code": 5356,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MARGEN / UTM zone 21S",
    "code": 5357,
    "projection": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-Chile / UTM zone 19S",
    "code": 5361,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-Chile / UTM zone 18S",
    "code": 5362,
    "projection": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CR05 / CRTM05",
    "code": 5367,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-ROU98 / UTM zone 21S",
    "code": 5382,
    "projection": "+proj=utm +zone=21 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-ROU98 / UTM zone 22S",
    "code": 5383,
    "projection": "+proj=utm +zone=22 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Peru96 / UTM zone 18S",
    "code": 5387,
    "projection": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Peru96 / UTM zone 17S (deprecated)",
    "code": 5388,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Peru96 / UTM zone 19S",
    "code": 5389,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 26S",
    "code": 5396,
    "projection": "+proj=utm +zone=26 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Costa Rica Norte",
    "code": 5456,
    "projection": "+proj=lcc +lat_1=10.46666666666667 +lat_0=10.46666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Costa Rica Sur",
    "code": 5457,
    "projection": "+proj=lcc +lat_1=9 +lat_0=9 +lon_0=-83.66666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Guatemala Norte (deprecated)",
    "code": 5458,
    "projection": "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Guatemala Sur",
    "code": 5459,
    "projection": "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / El Salvador Lambert",
    "code": 5460,
    "projection": "+proj=lcc +lat_1=13.78333333333333 +lat_0=13.78333333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Nicaragua Norte",
    "code": 5461,
    "projection": "+proj=lcc +lat_1=13.86666666666667 +lat_0=13.86666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Nicaragua Sur",
    "code": 5462,
    "projection": "+proj=lcc +lat_1=11.73333333333333 +lat_0=11.73333333333333 +lon_0=-85.5 +k_0=0.9999222800000001 +x_0=500000 +y_0=288876.327 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 17N",
    "code": 5463,
    "projection": "+proj=utm +zone=17 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Sibun Gorge 1922 / Colony Grid (deprecated)",
    "code": 5466,
    "projection": "+proj=tmerc +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +units=m +no_defs "
  },
  {
    "name": "Panama-Colon 1911 / Panama Lambert",
    "code": 5469,
    "projection": "+proj=lcc +lat_1=8.416666666666666 +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303 +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "Panama-Colon 1911 / Panama Polyconic",
    "code": 5472,
    "projection": "+proj=poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.7217154861 +ellps=clrk66 +to_meter=0.9143917962 +no_defs "
  },
  {
    "name": "RSRGD2000 / MSLC2000",
    "code": 5479,
    "projection": "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-78 +lon_0=163 +x_0=7000000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RSRGD2000 / BCLC2000",
    "code": 5480,
    "projection": "+proj=lcc +lat_1=-73.66666666666667 +lat_2=-75.33333333333333 +lat_0=-74.5 +lon_0=165 +x_0=5000000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RSRGD2000 / PCLC2000",
    "code": 5481,
    "projection": "+proj=lcc +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +lat_0=-71.5 +lon_0=166 +x_0=3000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RSRGD2000 / RSPS2000",
    "code": 5482,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=180 +k=0.994 +x_0=5000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGAF09 / UTM zone 20N",
    "code": 5490,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "S-JTSK / Krovak",
    "code": 5513,
    "projection": "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "S-JTSK / Krovak East North",
    "code": 5514,
    "projection": "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CI1971 / Chatham Islands Map Grid",
    "code": 5518,
    "projection": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=175,-38,113,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CI1979 / Chatham Islands Map Grid",
    "code": 5519,
    "projection": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 1",
    "code": 5520,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Gabon TM 2011",
    "code": 5523,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=1500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / Brazil Polyconic",
    "code": 5530,
    "projection": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 21S",
    "code": 5531,
    "projection": "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 22S (deprecated)",
    "code": 5532,
    "projection": "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 23S",
    "code": 5533,
    "projection": "+proj=utm +zone=23 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 24S",
    "code": 5534,
    "projection": "+proj=utm +zone=24 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 25S",
    "code": 5535,
    "projection": "+proj=utm +zone=25 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1961 / UTM zone 21S",
    "code": 5536,
    "projection": "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1961 / UTM zone 22S",
    "code": 5537,
    "projection": "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1961 / UTM zone 23S",
    "code": 5538,
    "projection": "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1961 / UTM zone 24S",
    "code": 5539,
    "projection": "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs "
  },
  {
    "name": "PNG94 / PNGMG94 zone 54",
    "code": 5550,
    "projection": "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PNG94 / PNGMG94 zone 55",
    "code": 5551,
    "projection": "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PNG94 / PNGMG94 zone 56",
    "code": 5552,
    "projection": "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ocotepeque 1935 / Guatemala Norte",
    "code": 5559,
    "projection": "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger zone 4",
    "code": 5562,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger zone 5",
    "code": 5563,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger zone 6",
    "code": 5564,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger zone 7",
    "code": 5565,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger CM 21E",
    "code": 5566,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger CM 27E",
    "code": 5567,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger CM 33E",
    "code": 5568,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Gauss-Kruger CM 39E",
    "code": 5569,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 7 (deprecated)",
    "code": 5570,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 8 (deprecated)",
    "code": 5571,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 9 (deprecated)",
    "code": 5572,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 10 (deprecated)",
    "code": 5573,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 11 (deprecated)",
    "code": 5574,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 12 (deprecated)",
    "code": 5575,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger zone 13 (deprecated)",
    "code": 5576,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 21E (deprecated)",
    "code": 5577,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 24E (deprecated)",
    "code": 5578,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 27E (deprecated)",
    "code": 5579,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 30E (deprecated)",
    "code": 5580,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 33E (deprecated)",
    "code": 5581,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 36E (deprecated)",
    "code": 5582,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / 3-degree Gauss-Kruger CM 39E (deprecated)",
    "code": 5583,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / New Brunswick Stereographic (NAD27)",
    "code": 5588,
    "projection": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=304800 +y_0=304800 +datum=NAD27 +units=ft +no_defs "
  },
  {
    "name": "Sibun Gorge 1922 / Colony Grid",
    "code": 5589,
    "projection": "+proj=tmerc +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.3047972654 +no_defs "
  },
  {
    "name": "FEH2010 / Fehmarnbelt TM",
    "code": 5596,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.33333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Michigan East",
    "code": 5623,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k=0.999942857 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Michigan Old Central",
    "code": 5624,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Michigan West",
    "code": 5625,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "ED50 / TM 6 NE",
    "code": 5627,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Moznet / UTM zone 38S",
    "code": 5629,
    "projection": "+proj=utm +zone=38 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 2 (E-N)",
    "code": 5631,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "PTRA08 / LCC Europe",
    "code": 5632,
    "projection": "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PTRA08 / LAEA Europe",
    "code": 5633,
    "projection": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGCAN95 / LCC Europe",
    "code": 5634,
    "projection": "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "REGCAN95 / LAEA Europe",
    "code": 5635,
    "projection": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / LAEA Europe",
    "code": 5636,
    "projection": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TUREF / LCC Europe",
    "code": 5637,
    "projection": "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ISN2004 / LAEA Europe",
    "code": 5638,
    "projection": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ISN2004 / LCC Europe",
    "code": 5639,
    "projection": "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / Brazil Mercator",
    "code": 5641,
    "projection": "+proj=merc +lon_0=-43 +lat_ts=-2 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / SPBA LCC",
    "code": 5643,
    "projection": "+proj=lcc +lat_1=52.66666666666666 +lat_2=54.33333333333334 +lat_0=48 +lon_0=10 +x_0=815000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RGR92 / UTM zone 39S",
    "code": 5644,
    "projection": "+proj=utm +zone=39 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Vermont (ftUS)",
    "code": 5646,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31N (zE-N)",
    "code": 5649,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N (zE-N)",
    "code": 5650,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31N (N-zE)",
    "code": 5651,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N (N-zE)",
    "code": 5652,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N (N-zE)",
    "code": 5653,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Vermont (ftUS)",
    "code": 5654,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Vermont (ftUS)",
    "code": 5655,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "Monte Mario / TM Emilia-Romagna",
    "code": 5659,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=500053 +y_0=-3999820 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / Gauss-Kruger zone 3 (E-N)",
    "code": 5663,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss-Kruger zone 2 (E-N)",
    "code": 5664,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / Gauss-Kruger zone 3 (E-N)",
    "code": 5665,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PD/83 / 3-degree Gauss-Kruger zone 3 (E-N)",
    "code": 5666,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "PD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5667,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5668,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "RD/83 / 3-degree Gauss-Kruger zone 5 (E-N)",
    "code": 5669,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3 (E-N)",
    "code": 5670,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5671,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5 (E-N)",
    "code": 5672,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3 (E-N)",
    "code": 5673,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5674,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5 (E-N)",
    "code": 5675,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 2 (E-N)",
    "code": 5676,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 3 (E-N)",
    "code": 5677,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5678,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 5 (E-N)",
    "code": 5679,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 1 (E-N)",
    "code": 5680,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 2 (E-N)",
    "code": 5682,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 3 (E-N)",
    "code": 5683,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 4 (E-N)",
    "code": 5684,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 5 (E-N)",
    "code": 5685,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "NZGD2000 / UTM zone 1S",
    "code": 5700,
    "projection": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD66 / ACT Standard Grid",
    "code": 5825,
    "projection": "+proj=tmerc +lat_0=-35.31773627777778 +lon_0=149.0092948305555 +k=1.000086 +x_0=200000 +y_0=600000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96 / UTM zone 37N",
    "code": 5836,
    "projection": "+proj=utm +zone=37 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96 / UTM zone 40N",
    "code": 5837,
    "projection": "+proj=utm +zone=40 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Peru96 / UTM zone 17S",
    "code": 5839,
    "projection": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 12 SE",
    "code": 5842,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005 / Congo TM zone 30",
    "code": 5844,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 22S",
    "code": 5858,
    "projection": "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 18S",
    "code": 5875,
    "projection": "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 19S",
    "code": 5876,
    "projection": "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69(96) / UTM zone 20S",
    "code": 5877,
    "projection": "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cadastre 1997 / UTM zone 38S",
    "code": 5879,
    "projection": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / Brazil Polyconic",
    "code": 5880,
    "projection": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TGD2005 / Tonga Map Grid",
    "code": 5887,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JAXA Snow Depth Polar Stereographic North",
    "code": 5890,
    "projection": "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=90 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone A1",
    "code": 5921,
    "projection": "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone A2",
    "code": 5922,
    "projection": "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone A3",
    "code": 5923,
    "projection": "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone A4",
    "code": 5924,
    "projection": "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone A5",
    "code": 5925,
    "projection": "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone B1",
    "code": 5926,
    "projection": "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone B2",
    "code": 5927,
    "projection": "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone B3",
    "code": 5928,
    "projection": "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone B4",
    "code": 5929,
    "projection": "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone B5",
    "code": 5930,
    "projection": "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone C1",
    "code": 5931,
    "projection": "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone C2",
    "code": 5932,
    "projection": "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone C3",
    "code": 5933,
    "projection": "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone C4",
    "code": 5934,
    "projection": "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic Regional zone C5",
    "code": 5935,
    "projection": "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Alaska Polar Stereographic",
    "code": 5936,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Canada Polar Stereographic",
    "code": 5937,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-100 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Greenland Polar Stereographic",
    "code": 5938,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-33 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Norway Polar Stereographic",
    "code": 5939,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=18 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Russia Polar Stereographic",
    "code": 5940,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=105 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 1-25",
    "code": 6050,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-30 +x_0=25500000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 2-18",
    "code": 6051,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-52 +x_0=18500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 2-20",
    "code": 6052,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-12 +x_0=20500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 3-29",
    "code": 6053,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-69 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 3-31",
    "code": 6054,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-39 +x_0=31500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 3-33",
    "code": 6055,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-10 +x_0=33500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 4-20",
    "code": 6056,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-64 +x_0=20500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 4-22",
    "code": 6057,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-39 +x_0=22500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 4-24",
    "code": 6058,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-14 +x_0=24500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 5-41",
    "code": 6059,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-62 +x_0=41500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 5-43",
    "code": 6060,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-42 +x_0=43500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 5-45",
    "code": 6061,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-22 +x_0=45500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 6-26",
    "code": 6062,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-56 +x_0=26500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 6-28",
    "code": 6063,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-38 +x_0=28500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 6-30",
    "code": 6064,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-20 +x_0=30500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 7-11",
    "code": 6065,
    "projection": "+proj=lcc +lat_1=67 +lat_2=63.66666666666666 +lat_0=65.35103930555555 +lon_0=-51 +x_0=11500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 7-13",
    "code": 6066,
    "projection": "+proj=lcc +lat_1=67 +lat_2=63.66666666666666 +lat_0=65.35103930555555 +lon_0=-34 +x_0=13500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 8-20",
    "code": 6067,
    "projection": "+proj=lcc +lat_1=63.66666666666666 +lat_2=60.33333333333334 +lat_0=62.01530688888889 +lon_0=-52 +x_0=20500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GR96 / EPSG Arctic zone 8-22",
    "code": 6068,
    "projection": "+proj=lcc +lat_1=63.66666666666666 +lat_2=60.33333333333334 +lat_0=62.01530688888889 +lon_0=-37 +x_0=22500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 2-22",
    "code": 6069,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=16 +x_0=22500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 3-11",
    "code": 6070,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=21 +x_0=11500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 4-26",
    "code": 6071,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=10 +x_0=26500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 4-28",
    "code": 6072,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=34 +x_0=28500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 5-11",
    "code": 6073,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=14 +x_0=11500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 5-13",
    "code": 6074,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=34 +x_0=13500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 2-24",
    "code": 6075,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=53 +x_0=24500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 2-26",
    "code": 6076,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=93 +x_0=26500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-13",
    "code": 6077,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=52 +x_0=13500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-15",
    "code": 6078,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=83 +x_0=15500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-17",
    "code": 6079,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=114 +x_0=17500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-19",
    "code": 6080,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=145 +x_0=19500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-30",
    "code": 6081,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=58 +x_0=30500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-32",
    "code": 6082,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=82 +x_0=32500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-34",
    "code": 6083,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=106 +x_0=34500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-36",
    "code": 6084,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=130 +x_0=36500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-38",
    "code": 6085,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=154 +x_0=38500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-40",
    "code": 6086,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=179 +x_0=40500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-15",
    "code": 6087,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=54 +x_0=15500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-17",
    "code": 6088,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=74 +x_0=17500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-19",
    "code": 6089,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=95 +x_0=19500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-21",
    "code": 6090,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=116 +x_0=21500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-23",
    "code": 6091,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=137 +x_0=23500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-25",
    "code": 6092,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=158 +x_0=25500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 5-27",
    "code": 6093,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=179 +x_0=27500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / EPSG Arctic zone 5-29",
    "code": 6094,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-163 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / EPSG Arctic zone 5-31",
    "code": 6095,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-147 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / EPSG Arctic zone 6-14",
    "code": 6096,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-165 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / EPSG Arctic zone 6-16",
    "code": 6097,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-147 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 1-23",
    "code": 6098,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-90 +x_0=23500000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 2-14",
    "code": 6099,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-115 +x_0=14500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 2-16",
    "code": 6100,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-75 +x_0=16500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 3-25",
    "code": 6101,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-129 +x_0=25500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 3-27",
    "code": 6102,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-99 +x_0=27500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 3-29",
    "code": 6103,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-69 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 4-14",
    "code": 6104,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-129 +x_0=14500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 4-16",
    "code": 6105,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-104 +x_0=16500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 4-18",
    "code": 6106,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-79 +x_0=18500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 5-33",
    "code": 6107,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-131 +x_0=33500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 5-35",
    "code": 6108,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-111 +x_0=35500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 5-37",
    "code": 6109,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-91 +x_0=37500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 5-39",
    "code": 6110,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-71 +x_0=39500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 6-18",
    "code": 6111,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-132 +x_0=18500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 6-20",
    "code": 6112,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-113 +x_0=20500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 6-22",
    "code": 6113,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-94 +x_0=22500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / EPSG Arctic zone 6-24",
    "code": 6114,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-75 +x_0=24500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 1-27",
    "code": 6115,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=30 +x_0=27500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 1-29",
    "code": 6116,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=90 +x_0=29500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 1-31",
    "code": 6117,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=150 +x_0=31500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 1-21",
    "code": 6118,
    "projection": "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-150 +x_0=21500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 2-28",
    "code": 6119,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=133 +x_0=28500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 2-10",
    "code": 6120,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=166 +x_0=10500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 2-12",
    "code": 6121,
    "projection": "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-154 +x_0=12500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-21",
    "code": 6122,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=176 +x_0=21500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 3-23",
    "code": 6123,
    "projection": "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-153 +x_0=23500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / EPSG Arctic zone 4-12",
    "code": 6124,
    "projection": "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-155 +x_0=12500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / EPSG Arctic zone 5-47",
    "code": 6125,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-5 +x_0=47500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Grand Cayman National Grid 1959",
    "code": 6128,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +units=ft +no_defs "
  },
  {
    "name": "Sister Islands National Grid 1961",
    "code": 6129,
    "projection": "+proj=utm +zone=17 +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +units=ft +no_defs "
  },
  {
    "name": "Cayman Islands National Grid 2011 (deprecated)",
    "code": 6141,
    "projection": "+proj=lcc +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=80.56666666666666 +x_0=899160 +y_0=579120 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "Macedonia State Coordinate System",
    "code": 6204,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 23N",
    "code": 6210,
    "projection": "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 24N",
    "code": 6211,
    "projection": "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Puerto Rico and Virgin Is.",
    "code": 6307,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGRS93 / Cyprus Local Transverse Mercator",
    "code": 6312,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +units=m +no_defs "
  },
  {
    "name": "Macedonia State Coordinate System zone 7",
    "code": 6316,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 59N",
    "code": 6328,
    "projection": "+proj=utm +zone=59 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 60N",
    "code": 6329,
    "projection": "+proj=utm +zone=60 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 1N",
    "code": 6330,
    "projection": "+proj=utm +zone=1 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 2N",
    "code": 6331,
    "projection": "+proj=utm +zone=2 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 3N",
    "code": 6332,
    "projection": "+proj=utm +zone=3 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 4N",
    "code": 6333,
    "projection": "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 5N",
    "code": 6334,
    "projection": "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 6N",
    "code": 6335,
    "projection": "+proj=utm +zone=6 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 7N",
    "code": 6336,
    "projection": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 8N",
    "code": 6337,
    "projection": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 9N",
    "code": 6338,
    "projection": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 10N",
    "code": 6339,
    "projection": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 11N",
    "code": 6340,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 12N",
    "code": 6341,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 13N",
    "code": 6342,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 14N",
    "code": 6343,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 15N",
    "code": 6344,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 16N",
    "code": 6345,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 17N",
    "code": 6346,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 18N",
    "code": 6347,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / UTM zone 19N",
    "code": 6348,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Conus Albers",
    "code": 6350,
    "projection": "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / EPSG Arctic zone 5-29",
    "code": 6351,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-163 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / EPSG Arctic zone 5-31",
    "code": 6352,
    "projection": "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-147 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / EPSG Arctic zone 6-14",
    "code": 6353,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-165 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / EPSG Arctic zone 6-16",
    "code": 6354,
    "projection": "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-147 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alabama East",
    "code": 6355,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alabama West",
    "code": 6356,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92 / LCC",
    "code": 6362,
    "projection": "+proj=lcc +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 11N",
    "code": 6366,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 12N",
    "code": 6367,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 13N",
    "code": 6368,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 14N",
    "code": 6369,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 15N",
    "code": 6370,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / UTM zone 16N",
    "code": 6371,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008 / LCC",
    "code": 6372,
    "projection": "+proj=lcc +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 7",
    "code": 6381,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 8",
    "code": 6382,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 9",
    "code": 6383,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 10",
    "code": 6384,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 11",
    "code": 6385,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 12",
    "code": 6386,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "UCS-2000 / Ukraine TM zone 13",
    "code": 6387,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs "
  },
  {
    "name": "Cayman Islands National Grid 2011",
    "code": 6391,
    "projection": "+proj=lcc +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=-80.56666666666666 +x_0=899160 +y_0=579120 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska Albers",
    "code": 6393,
    "projection": "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 1",
    "code": 6394,
    "projection": "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 2",
    "code": 6395,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 3",
    "code": 6396,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 4",
    "code": 6397,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 5",
    "code": 6398,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 6",
    "code": 6399,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 7",
    "code": 6400,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 8",
    "code": 6401,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 9",
    "code": 6402,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Alaska zone 10",
    "code": 6403,
    "projection": "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona Central",
    "code": 6404,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona Central (ft)",
    "code": 6405,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona East",
    "code": 6406,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona East (ft)",
    "code": 6407,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona West",
    "code": 6408,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arizona West (ft)",
    "code": 6409,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Arkansas North",
    "code": 6410,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arkansas North (ftUS)",
    "code": 6411,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Arkansas South",
    "code": 6412,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Arkansas South (ftUS)",
    "code": 6413,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California Albers",
    "code": 6414,
    "projection": "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 1",
    "code": 6415,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 1 (ftUS)",
    "code": 6416,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 2",
    "code": 6417,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 2 (ftUS)",
    "code": 6418,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 3",
    "code": 6419,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 3 (ftUS)",
    "code": 6420,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 4",
    "code": 6421,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 4 (ftUS)",
    "code": 6422,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 5",
    "code": 6423,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 5 (ftUS)",
    "code": 6424,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 6",
    "code": 6425,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / California zone 6 (ftUS)",
    "code": 6426,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado Central",
    "code": 6427,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado Central (ftUS)",
    "code": 6428,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado North",
    "code": 6429,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado North (ftUS)",
    "code": 6430,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado South",
    "code": 6431,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Colorado South (ftUS)",
    "code": 6432,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Connecticut",
    "code": 6433,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Connecticut (ftUS)",
    "code": 6434,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Delaware",
    "code": 6435,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Delaware (ftUS)",
    "code": 6436,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida East",
    "code": 6437,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida East (ftUS)",
    "code": 6438,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida GDL Albers",
    "code": 6439,
    "projection": "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida North",
    "code": 6440,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida North (ftUS)",
    "code": 6441,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida West",
    "code": 6442,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Florida West (ftUS)",
    "code": 6443,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Georgia East",
    "code": 6444,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Georgia East (ftUS)",
    "code": 6445,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Georgia West",
    "code": 6446,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Georgia West (ftUS)",
    "code": 6447,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho Central",
    "code": 6448,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho Central (ftUS)",
    "code": 6449,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho East",
    "code": 6450,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho East (ftUS)",
    "code": 6451,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho West",
    "code": 6452,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Idaho West (ftUS)",
    "code": 6453,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Illinois East",
    "code": 6454,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Illinois East (ftUS)",
    "code": 6455,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Illinois West",
    "code": 6456,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Illinois West (ftUS)",
    "code": 6457,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Indiana East",
    "code": 6458,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Indiana East (ftUS)",
    "code": 6459,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Indiana West",
    "code": 6460,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Indiana West (ftUS)",
    "code": 6461,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Iowa North",
    "code": 6462,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Iowa North (ftUS)",
    "code": 6463,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Iowa South",
    "code": 6464,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Iowa South (ftUS)",
    "code": 6465,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas North",
    "code": 6466,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas North (ftUS)",
    "code": 6467,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas South",
    "code": 6468,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas South (ftUS)",
    "code": 6469,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky North",
    "code": 6470,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky North (ftUS)",
    "code": 6471,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky Single Zone",
    "code": 6472,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky Single Zone (ftUS)",
    "code": 6473,
    "projection": "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky South",
    "code": 6474,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kentucky South (ftUS)",
    "code": 6475,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Louisiana North",
    "code": 6476,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Louisiana North (ftUS)",
    "code": 6477,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Louisiana South",
    "code": 6478,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Louisiana South (ftUS)",
    "code": 6479,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine CS2000 Central",
    "code": 6480,
    "projection": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine CS2000 East",
    "code": 6481,
    "projection": "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine CS2000 West",
    "code": 6482,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine East",
    "code": 6483,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine East (ftUS)",
    "code": 6484,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine West",
    "code": 6485,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maine West (ftUS)",
    "code": 6486,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Maryland",
    "code": 6487,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Maryland (ftUS)",
    "code": 6488,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Massachusetts Island",
    "code": 6489,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Massachusetts Island (ftUS)",
    "code": 6490,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Massachusetts Mainland",
    "code": 6491,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Massachusetts Mainland (ftUS)",
    "code": 6492,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan Central",
    "code": 6493,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan Central (ft)",
    "code": 6494,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan North",
    "code": 6495,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan North (ft)",
    "code": 6496,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan Oblique Mercator",
    "code": 6497,
    "projection": "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan South",
    "code": 6498,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Michigan South (ft)",
    "code": 6499,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota Central",
    "code": 6500,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota Central (ftUS)",
    "code": 6501,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota North",
    "code": 6502,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota North (ftUS)",
    "code": 6503,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota South",
    "code": 6504,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Minnesota South (ftUS)",
    "code": 6505,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Mississippi East",
    "code": 6506,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Mississippi East (ftUS)",
    "code": 6507,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Mississippi TM",
    "code": 6508,
    "projection": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Mississippi West",
    "code": 6509,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Mississippi West (ftUS)",
    "code": 6510,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Missouri Central",
    "code": 6511,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Missouri East",
    "code": 6512,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Missouri West",
    "code": 6513,
    "projection": "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Montana",
    "code": 6514,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Montana (ft)",
    "code": 6515,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Nebraska",
    "code": 6516,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Nebraska (ftUS) (deprecated)",
    "code": 6517,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada Central",
    "code": 6518,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada Central (ftUS)",
    "code": 6519,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada East",
    "code": 6520,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada East (ftUS)",
    "code": 6521,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada West",
    "code": 6522,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Nevada West (ftUS)",
    "code": 6523,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New Hampshire",
    "code": 6524,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New Hampshire (ftUS)",
    "code": 6525,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New Jersey",
    "code": 6526,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New Jersey (ftUS)",
    "code": 6527,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico Central",
    "code": 6528,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico Central (ftUS)",
    "code": 6529,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico East",
    "code": 6530,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico East (ftUS)",
    "code": 6531,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico West",
    "code": 6532,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New Mexico West (ftUS)",
    "code": 6533,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New York Central",
    "code": 6534,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New York Central (ftUS)",
    "code": 6535,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New York East",
    "code": 6536,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New York East (ftUS)",
    "code": 6537,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New York Long Island",
    "code": 6538,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New York Long Island (ftUS)",
    "code": 6539,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / New York West",
    "code": 6540,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / New York West (ftUS)",
    "code": 6541,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / North Carolina",
    "code": 6542,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / North Carolina (ftUS)",
    "code": 6543,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / North Dakota North",
    "code": 6544,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / North Dakota North (ft)",
    "code": 6545,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / North Dakota South",
    "code": 6546,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / North Dakota South (ft)",
    "code": 6547,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Ohio North",
    "code": 6548,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Ohio North (ftUS)",
    "code": 6549,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Ohio South",
    "code": 6550,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Ohio South (ftUS)",
    "code": 6551,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oklahoma North",
    "code": 6552,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oklahoma North (ftUS)",
    "code": 6553,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oklahoma South",
    "code": 6554,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oklahoma South (ftUS)",
    "code": 6555,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon LCC (m)",
    "code": 6556,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon GIC Lambert (ft)",
    "code": 6557,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon North",
    "code": 6558,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon North (ft)",
    "code": 6559,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon South",
    "code": 6560,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon South (ft)",
    "code": 6561,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Pennsylvania North",
    "code": 6562,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Pennsylvania North (ftUS)",
    "code": 6563,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Pennsylvania South",
    "code": 6564,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Pennsylvania South (ftUS)",
    "code": 6565,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Puerto Rico and Virgin Is.",
    "code": 6566,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Rhode Island",
    "code": 6567,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Rhode Island (ftUS)",
    "code": 6568,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / South Carolina",
    "code": 6569,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / South Carolina (ft)",
    "code": 6570,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / South Dakota North",
    "code": 6571,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / South Dakota North (ftUS)",
    "code": 6572,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / South Dakota South",
    "code": 6573,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / South Dakota South (ftUS)",
    "code": 6574,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Tennessee",
    "code": 6575,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Tennessee (ftUS)",
    "code": 6576,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas Central",
    "code": 6577,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas Central (ftUS)",
    "code": 6578,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas Centric Albers Equal Area",
    "code": 6579,
    "projection": "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas Centric Lambert Conformal",
    "code": 6580,
    "projection": "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas North",
    "code": 6581,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas North (ftUS)",
    "code": 6582,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas North Central",
    "code": 6583,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas North Central (ftUS)",
    "code": 6584,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas South",
    "code": 6585,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas South (ftUS)",
    "code": 6586,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas South Central",
    "code": 6587,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Texas South Central (ftUS)",
    "code": 6588,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Vermont",
    "code": 6589,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Vermont (ftUS)",
    "code": 6590,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Virginia Lambert",
    "code": 6591,
    "projection": "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Virginia North",
    "code": 6592,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Virginia North (ftUS)",
    "code": 6593,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Virginia South",
    "code": 6594,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Virginia South (ftUS)",
    "code": 6595,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Washington North",
    "code": 6596,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Washington North (ftUS)",
    "code": 6597,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Washington South",
    "code": 6598,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Washington South (ftUS)",
    "code": 6599,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / West Virginia North",
    "code": 6600,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / West Virginia North (ftUS)",
    "code": 6601,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / West Virginia South",
    "code": 6602,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / West Virginia South (ftUS)",
    "code": 6603,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin Central (deprecated)",
    "code": 6604,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin Central (ftUS)",
    "code": 6605,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin North",
    "code": 6606,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin North (ftUS)",
    "code": 6607,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin South",
    "code": 6608,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin South (ftUS)",
    "code": 6609,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin Transverse Mercator",
    "code": 6610,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming East",
    "code": 6611,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming East (ftUS)",
    "code": 6612,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming East Central",
    "code": 6613,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming East Central (ftUS)",
    "code": 6614,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming West",
    "code": 6615,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming West (ftUS)",
    "code": 6616,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming West Central",
    "code": 6617,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wyoming West Central (ftUS)",
    "code": 6618,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah Central",
    "code": 6619,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah North",
    "code": 6620,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah South",
    "code": 6621,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Quebec Lambert",
    "code": 6622,
    "projection": "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Quebec Albers",
    "code": 6623,
    "projection": "+proj=aea +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / Quebec Albers",
    "code": 6624,
    "projection": "+proj=aea +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah Central (ftUS)",
    "code": 6625,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah North (ftUS)",
    "code": 6626,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Utah South (ftUS)",
    "code": 6627,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 1",
    "code": 6628,
    "projection": "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 2",
    "code": 6629,
    "projection": "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 3",
    "code": 6630,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 4",
    "code": 6631,
    "projection": "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 5",
    "code": 6632,
    "projection": "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / Hawaii zone 3 (ftUS)",
    "code": 6633,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(PA11) / UTM zone 4N",
    "code": 6634,
    "projection": "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / UTM zone 5N",
    "code": 6635,
    "projection": "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11) / UTM zone 2S",
    "code": 6636,
    "projection": "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(MA11) / Guam Map Grid",
    "code": 6637,
    "projection": "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Karbala 1979 / Iraq National Grid",
    "code": 6646,
    "projection": "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS I",
    "code": 6669,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS II",
    "code": 6670,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS III",
    "code": 6671,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS IV",
    "code": 6672,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS V",
    "code": 6673,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS VI",
    "code": 6674,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS VII",
    "code": 6675,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS VIII",
    "code": 6676,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS IX",
    "code": 6677,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS X",
    "code": 6678,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XI",
    "code": 6679,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XII",
    "code": 6680,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XIII",
    "code": 6681,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XIV",
    "code": 6682,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XV",
    "code": 6683,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XVI",
    "code": 6684,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XVII",
    "code": 6685,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XVIII",
    "code": 6686,
    "projection": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / Japan Plane Rectangular CS XIX",
    "code": 6687,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / UTM zone 51N",
    "code": 6688,
    "projection": "+proj=utm +zone=51 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / UTM zone 52N",
    "code": 6689,
    "projection": "+proj=utm +zone=52 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / UTM zone 53N",
    "code": 6690,
    "projection": "+proj=utm +zone=53 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / UTM zone 54N",
    "code": 6691,
    "projection": "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011 / UTM zone 55N",
    "code": 6692,
    "projection": "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 60 SW",
    "code": 6703,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-60 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 32N (N-E)",
    "code": 6707,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 33N (N-E)",
    "code": 6708,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 34N (N-E)",
    "code": 6709,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / CIG92",
    "code": 6720,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.000024 +x_0=50000 +y_0=1300000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "GDA94 / CIG94",
    "code": 6721,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / CKIG92",
    "code": 6722,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=1 +x_0=50000 +y_0=1400000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "GDA94 / CKIG94",
    "code": 6723,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 41 (deprecated)",
    "code": 6732,
    "projection": "+proj=utm +zone=41 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 42 (deprecated)",
    "code": 6733,
    "projection": "+proj=utm +zone=42 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 43 (deprecated)",
    "code": 6734,
    "projection": "+proj=utm +zone=43 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 44 (deprecated)",
    "code": 6735,
    "projection": "+proj=utm +zone=44 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 46",
    "code": 6736,
    "projection": "+proj=utm +zone=46 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 47",
    "code": 6737,
    "projection": "+proj=utm +zone=47 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 59",
    "code": 6738,
    "projection": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Baker zone (m)",
    "code": 6784,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Baker zone (ft)",
    "code": 6785,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Baker zone (m)",
    "code": 6786,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Baker zone (ft)",
    "code": 6787,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Klamath Falls zone (m)",
    "code": 6788,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Klamath Falls zone (ft)",
    "code": 6789,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Klamath Falls zone (m)",
    "code": 6790,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Klamath Falls zone (ft)",
    "code": 6791,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (m)",
    "code": 6792,
    "projection": "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (ft)",
    "code": 6793,
    "projection": "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Redmond-Prineville zone (m)",
    "code": 6794,
    "projection": "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Redmond-Prineville zone (ft)",
    "code": 6795,
    "projection": "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Burns zone (m)",
    "code": 6796,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Bend-Burns zone (ft)",
    "code": 6797,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Burns zone (m)",
    "code": 6798,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Bend-Burns zone (ft)",
    "code": 6799,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (m)",
    "code": 6800,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (ft)",
    "code": 6801,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Canyonville-Grants Pass zone (m)",
    "code": 6802,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Canyonville-Grants Pass zone (ft)",
    "code": 6803,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Columbia River East zone (m)",
    "code": 6804,
    "projection": "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Columbia River East zone (ft)",
    "code": 6805,
    "projection": "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Columbia River East zone (m)",
    "code": 6806,
    "projection": "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Columbia River East zone (ft)",
    "code": 6807,
    "projection": "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Columbia River West zone (m)",
    "code": 6808,
    "projection": "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000 +y_0=-3000000 +no_uoff +gamma=295 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Columbia River West zone (ft)",
    "code": 6809,
    "projection": "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +no_uoff +gamma=295 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Columbia River West zone (m)",
    "code": 6810,
    "projection": "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000 +y_0=-3000000 +no_uoff +gamma=295 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Columbia River West zone (ft)",
    "code": 6811,
    "projection": "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +no_uoff +gamma=295 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (m)",
    "code": 6812,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (ft)",
    "code": 6813,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Cottage Grove-Canyonville zone (m)",
    "code": 6814,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Cottage Grove-Canyonville zone (ft)",
    "code": 6815,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Dufur-Madras zone (m)",
    "code": 6816,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Dufur-Madras zone (ft)",
    "code": 6817,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Dufur-Madras zone (m)",
    "code": 6818,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Dufur-Madras zone (ft)",
    "code": 6819,
    "projection": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Eugene zone (m)",
    "code": 6820,
    "projection": "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Eugene zone (ft)",
    "code": 6821,
    "projection": "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Eugene zone (m)",
    "code": 6822,
    "projection": "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Eugene zone (ft)",
    "code": 6823,
    "projection": "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Grants Pass-Ashland zone (m)",
    "code": 6824,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Grants Pass-Ashland zone (ft)",
    "code": 6825,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Grants Pass-Ashland zone (m)",
    "code": 6826,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Grants Pass-Ashland zone (ft)",
    "code": 6827,
    "projection": "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Gresham-Warm Springs zone (m)",
    "code": 6828,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Gresham-Warm Springs zone (ft)",
    "code": 6829,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Gresham-Warm Springs zone (m)",
    "code": 6830,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Gresham-Warm Springs zone (ft)",
    "code": 6831,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon La Grande zone (m)",
    "code": 6832,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon La Grande zone (ft)",
    "code": 6833,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon La Grande zone (m)",
    "code": 6834,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon La Grande zone (ft)",
    "code": 6835,
    "projection": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Ontario zone (m)",
    "code": 6836,
    "projection": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Ontario zone (ft)",
    "code": 6837,
    "projection": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Ontario zone (m)",
    "code": 6838,
    "projection": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Ontario zone (ft)",
    "code": 6839,
    "projection": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Coast zone (m)",
    "code": 6840,
    "projection": "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000 +no_uoff +gamma=5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Coast zone (ft)",
    "code": 6841,
    "projection": "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +no_uoff +gamma=5 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Coast zone (m)",
    "code": 6842,
    "projection": "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000 +no_uoff +gamma=5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Coast zone (ft)",
    "code": 6843,
    "projection": "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +no_uoff +gamma=5 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Pendleton zone (m)",
    "code": 6844,
    "projection": "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Pendleton zone (ft)",
    "code": 6845,
    "projection": "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Pendleton zone (m)",
    "code": 6846,
    "projection": "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Pendleton zone (ft)",
    "code": 6847,
    "projection": "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Pendleton-La Grande zone (m)",
    "code": 6848,
    "projection": "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Pendleton-La Grande zone (ft)",
    "code": 6849,
    "projection": "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Pendleton-La Grande zone (m)",
    "code": 6850,
    "projection": "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Pendleton-La Grande zone (ft)",
    "code": 6851,
    "projection": "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Portland zone (m)",
    "code": 6852,
    "projection": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Portland zone (ft)",
    "code": 6853,
    "projection": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Portland zone (m)",
    "code": 6854,
    "projection": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Portland zone (ft)",
    "code": 6855,
    "projection": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Salem zone (m)",
    "code": 6856,
    "projection": "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Salem zone (ft)",
    "code": 6857,
    "projection": "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Salem zone (m)",
    "code": 6858,
    "projection": "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Salem zone (ft)",
    "code": 6859,
    "projection": "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Santiam Pass zone (m)",
    "code": 6860,
    "projection": "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon Santiam Pass zone (ft)",
    "code": 6861,
    "projection": "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Santiam Pass zone (m)",
    "code": 6862,
    "projection": "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Oregon Santiam Pass (ft)",
    "code": 6863,
    "projection": "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon LCC (m)",
    "code": 6867,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon GIC Lambert (ft)",
    "code": 6868,
    "projection": "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "ETRS89 / Albania TM 2010",
    "code": 6870,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / Italy zone (N-E)",
    "code": 6875,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985000000000001 +x_0=7000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / Zone 12 (N-E)",
    "code": 6876,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Wisconsin Central",
    "code": 6879,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Nebraska (ftUS)",
    "code": 6880,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon North",
    "code": 6884,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon North (ft)",
    "code": 6885,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon South",
    "code": 6886,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96) / Oregon South (ft)",
    "code": 6887,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "South East Island 1943 / UTM zone 40N",
    "code": 6915,
    "projection": "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-43.685,-179.785,-267.721,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kansas LCC",
    "code": 6922,
    "projection": "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kansas LCC (ftUS)",
    "code": 6923,
    "projection": "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas LCC",
    "code": 6924,
    "projection": "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / Kansas LCC (ftUS)",
    "code": 6925,
    "projection": "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid 2.0 North",
    "code": 6931,
    "projection": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid 2.0 South",
    "code": 6932,
    "projection": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / NSIDC EASE-Grid 2.0 Global",
    "code": 6933,
    "projection": "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "VN-2000 / TM-3 zone 481",
    "code": 6956,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=102 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "VN-2000 / TM-3 zone 482",
    "code": 6957,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "VN-2000 / TM-3 zone 491",
    "code": 6958,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "VN-2000 / TM-3 Da Nang zone",
    "code": 6959,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / Albania LCC 2010",
    "code": 6962,
    "projection": "+proj=lcc +lat_1=39 +lat_2=43 +lat_0=41 +lon_0=20 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Israeli Grid 05",
    "code": 6984,
    "projection": "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Israeli Grid 05/12",
    "code": 6991,
    "projection": "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / San Francisco CS13 (deprecated)",
    "code": 6996,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / San Francisco CS13 (ftUS) (deprecated)",
    "code": 6997,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "Nahrwan 1934 / UTM zone 37N",
    "code": 7005,
    "projection": "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1934 / UTM zone 38N",
    "code": 7006,
    "projection": "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1934 / UTM zone 39N",
    "code": 7007,
    "projection": "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 1",
    "code": 7057,
    "projection": "+proj=lcc +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.852171705 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 2",
    "code": 7058,
    "projection": "+proj=lcc +lat_1=43.16666666666666 +lat_0=43.16666666666666 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.974091948 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 3",
    "code": 7059,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-91.2 +k=1.000035 +x_0=4114808.229616459 +y_0=2529845.05969012 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 4",
    "code": 7060,
    "projection": "+proj=lcc +lat_1=42.53333333333333 +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.242570485 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 5",
    "code": 7061,
    "projection": "+proj=lcc +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 6",
    "code": 7062,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-95.73333333333333 +k=1.000039 +x_0=5029210.058420117 +y_0=2011684.023368047 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 7",
    "code": 7063,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-94.63333333333334 +k=1.000045 +x_0=5334010.668021336 +y_0=2072644.145288291 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 8",
    "code": 7064,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-93.71666666666667 +k=1.000033 +x_0=5638811.277622555 +y_0=2133604.267208535 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 9",
    "code": 7065,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-92.81666666666666 +k=1.000027 +x_0=5943611.887223775 +y_0=2194564.389128779 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 10",
    "code": 7066,
    "projection": "+proj=lcc +lat_1=41.83333333333334 +lat_0=41.83333333333334 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824994 +y_0=2438404.876809754 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 11",
    "code": 7067,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-90.53333333333333 +k=1.000027 +x_0=6553213.106426213 +y_0=2316484.632969266 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 12",
    "code": 7068,
    "projection": "+proj=lcc +lat_1=40.91666666666666 +lat_0=40.91666666666666 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027432 +y_0=1889763.779527559 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 13",
    "code": 7069,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-91.91666666666667 +k=1.00002 +x_0=7162814.325628651 +y_0=1950723.901447803 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / IaRCS zone 14",
    "code": 7070,
    "projection": "+proj=tmerc +lat_0=40.25 +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987 +y_0=1889763.779527559 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 37S",
    "code": 7074,
    "projection": "+proj=utm +zone=37 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 38S",
    "code": 7075,
    "projection": "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 39S",
    "code": 7076,
    "projection": "+proj=utm +zone=39 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 40S",
    "code": 7077,
    "projection": "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 41S",
    "code": 7078,
    "projection": "+proj=utm +zone=41 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 42S",
    "code": 7079,
    "projection": "+proj=utm +zone=42 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 43S",
    "code": 7080,
    "projection": "+proj=utm +zone=43 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07 / UTM zone 44S",
    "code": 7081,
    "projection": "+proj=utm +zone=44 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS St Mary (m)",
    "code": 7109,
    "projection": "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Blackfeet (m)",
    "code": 7110,
    "projection": "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Milk River (m)",
    "code": 7111,
    "projection": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Belknap (m)",
    "code": 7112,
    "projection": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Peck Assiniboine (m)",
    "code": 7113,
    "projection": "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Peck Sioux (m)",
    "code": 7114,
    "projection": "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Crow (m)",
    "code": 7115,
    "projection": "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Bobcat (m)",
    "code": 7116,
    "projection": "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Billings (m)",
    "code": 7117,
    "projection": "+proj=lcc +lat_1=45.78333333333333 +lat_0=45.78333333333333 +lon_0=-108.4166666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Wind River (m)",
    "code": 7118,
    "projection": "+proj=tmerc +lat_0=42.66666666666666 +lon_0=-108.3333333333333 +k=1.00024 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS St Mary (ft)",
    "code": 7119,
    "projection": "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000.00001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Blackfeet (ft)",
    "code": 7120,
    "projection": "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=99999.99999960001 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Milk River (ft)",
    "code": 7121,
    "projection": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.9999992 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Belknap (ft)",
    "code": 7122,
    "projection": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=150000.00001464 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Peck Assiniboine (ft)",
    "code": 7123,
    "projection": "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=99999.99999960001 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Fort Peck Sioux (ft)",
    "code": 7124,
    "projection": "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.99999960001 +y_0=49999.99971024 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Crow (ft)",
    "code": 7125,
    "projection": "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=199999.9999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Bobcat (ft)",
    "code": 7126,
    "projection": "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.99999960001 +y_0=99999.99999960001 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Billings (ft)",
    "code": 7127,
    "projection": "+proj=lcc +lat_1=45.78333333333333 +lat_0=45.78333333333333 +lon_0=-108.4166666666667 +k_0=1.0001515 +x_0=199999.9999992 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs "
  },
  {
    "name": "NAD83(2011) / RMTCRS Wind River (ftUS)",
    "code": 7128,
    "projection": "+proj=tmerc +lat_0=42.66666666666666 +lon_0=-108.3333333333333 +k=1.00024 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / San Francisco CS13",
    "code": 7131,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / San Francisco CS13 (ftUS)",
    "code": 7132,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "Palestine 1923 / Palestine Grid modified",
    "code": 7142,
    "projection": "+proj=tmerc +lat_0=31.73409694444445 +lon_0=35.21208055555556 +k=1 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Adams (m)",
    "code": 7257,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Adams (ftUS)",
    "code": 7258,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Allen (m)",
    "code": 7259,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Allen (ftUS)",
    "code": 7260,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Bartholomew (m)",
    "code": 7261,
    "projection": "+proj=tmerc +lat_0=39 +lon_0=-85.84999999999999 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Bartholomew (ftUS)",
    "code": 7262,
    "projection": "+proj=tmerc +lat_0=39 +lon_0=-85.84999999999999 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Benton (m)",
    "code": 7263,
    "projection": "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Benton (ftUS)",
    "code": 7264,
    "projection": "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Blackford-Delaware (m)",
    "code": 7265,
    "projection": "+proj=tmerc +lat_0=40.05 +lon_0=-85.40000000000001 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Blackford-Delaware (ftUS)",
    "code": 7266,
    "projection": "+proj=tmerc +lat_0=40.05 +lon_0=-85.40000000000001 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Boone-Hendricks (m)",
    "code": 7267,
    "projection": "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Boone-Hendricks (ftUS)",
    "code": 7268,
    "projection": "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Brown (m)",
    "code": 7269,
    "projection": "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Brown (ftUS)",
    "code": 7270,
    "projection": "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Carroll (m)",
    "code": 7271,
    "projection": "+proj=tmerc +lat_0=40.4 +lon_0=-86.65000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Carroll (ftUS)",
    "code": 7272,
    "projection": "+proj=tmerc +lat_0=40.4 +lon_0=-86.65000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Cass (m)",
    "code": 7273,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-86.40000000000001 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Cass (ftUS)",
    "code": 7274,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-86.40000000000001 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clark-Floyd-Scott (m)",
    "code": 7275,
    "projection": "+proj=tmerc +lat_0=38.15 +lon_0=-85.59999999999999 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clark-Floyd-Scott (ftUS)",
    "code": 7276,
    "projection": "+proj=tmerc +lat_0=38.15 +lon_0=-85.59999999999999 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clay (m)",
    "code": 7277,
    "projection": "+proj=tmerc +lat_0=39.15 +lon_0=-87.15000000000001 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clay (ftUS)",
    "code": 7278,
    "projection": "+proj=tmerc +lat_0=39.15 +lon_0=-87.15000000000001 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clinton (m)",
    "code": 7279,
    "projection": "+proj=tmerc +lat_0=40.15 +lon_0=-86.59999999999999 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Clinton (ftUS)",
    "code": 7280,
    "projection": "+proj=tmerc +lat_0=40.15 +lon_0=-86.59999999999999 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Crawford-Lawrence-Orange (m)",
    "code": 7281,
    "projection": "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Crawford-Lawrence-Orange (ftUS)",
    "code": 7282,
    "projection": "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Daviess-Greene (m)",
    "code": 7283,
    "projection": "+proj=tmerc +lat_0=38.45 +lon_0=-87.09999999999999 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Daviess-Greene (ftUS)",
    "code": 7284,
    "projection": "+proj=tmerc +lat_0=38.45 +lon_0=-87.09999999999999 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (m)",
    "code": 7285,
    "projection": "+proj=tmerc +lat_0=38.65 +lon_0=-84.90000000000001 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (ftUS)",
    "code": 7286,
    "projection": "+proj=tmerc +lat_0=38.65 +lon_0=-84.90000000000001 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Decatur-Rush (m)",
    "code": 7287,
    "projection": "+proj=tmerc +lat_0=39.1 +lon_0=-85.65000000000001 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Decatur-Rush (ftUS)",
    "code": 7288,
    "projection": "+proj=tmerc +lat_0=39.1 +lon_0=-85.65000000000001 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS DeKalb (m)",
    "code": 7289,
    "projection": "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS DeKalb (ftUS)",
    "code": 7290,
    "projection": "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Dubois-Martin (m)",
    "code": 7291,
    "projection": "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Dubois-Martin (ftUS)",
    "code": 7292,
    "projection": "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (m)",
    "code": 7293,
    "projection": "+proj=tmerc +lat_0=40.65 +lon_0=-85.84999999999999 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (ftUS)",
    "code": 7294,
    "projection": "+proj=tmerc +lat_0=40.65 +lon_0=-85.84999999999999 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fayette-Franklin-Union (m)",
    "code": 7295,
    "projection": "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fayette-Franklin-Union (ftUS)",
    "code": 7296,
    "projection": "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fountain-Warren (m)",
    "code": 7297,
    "projection": "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fountain-Warren (ftUS)",
    "code": 7298,
    "projection": "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (m)",
    "code": 7299,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (ftUS)",
    "code": 7300,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Gibson (m)",
    "code": 7301,
    "projection": "+proj=tmerc +lat_0=38.15 +lon_0=-87.65000000000001 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Gibson (ftUS)",
    "code": 7302,
    "projection": "+proj=tmerc +lat_0=38.15 +lon_0=-87.65000000000001 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Grant (m)",
    "code": 7303,
    "projection": "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Grant (ftUS)",
    "code": 7304,
    "projection": "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Hamilton-Tipton (m)",
    "code": 7305,
    "projection": "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Hamilton-Tipton (ftUS)",
    "code": 7306,
    "projection": "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Hancock-Madison (m)",
    "code": 7307,
    "projection": "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Hancock-Madison (ftUS)",
    "code": 7308,
    "projection": "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Harrison-Washington (m)",
    "code": 7309,
    "projection": "+proj=tmerc +lat_0=37.95 +lon_0=-86.15000000000001 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Harrison-Washington (ftUS)",
    "code": 7310,
    "projection": "+proj=tmerc +lat_0=37.95 +lon_0=-86.15000000000001 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Henry (m)",
    "code": 7311,
    "projection": "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Henry (ftUS)",
    "code": 7312,
    "projection": "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Howard-Miami (m)",
    "code": 7313,
    "projection": "+proj=tmerc +lat_0=40.35 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Howard-Miami (ftUS)",
    "code": 7314,
    "projection": "+proj=tmerc +lat_0=40.35 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Huntington-Whitley (m)",
    "code": 7315,
    "projection": "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Huntington-Whitley (ftUS)",
    "code": 7316,
    "projection": "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jackson (m)",
    "code": 7317,
    "projection": "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jackson (ftUS)",
    "code": 7318,
    "projection": "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jasper-Porter (m)",
    "code": 7319,
    "projection": "+proj=tmerc +lat_0=40.7 +lon_0=-87.09999999999999 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jasper-Porter (ftUS)",
    "code": 7320,
    "projection": "+proj=tmerc +lat_0=40.7 +lon_0=-87.09999999999999 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jay (m)",
    "code": 7321,
    "projection": "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jay (ftUS)",
    "code": 7322,
    "projection": "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jefferson (m)",
    "code": 7323,
    "projection": "+proj=tmerc +lat_0=38.55 +lon_0=-85.34999999999999 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jefferson (ftUS)",
    "code": 7324,
    "projection": "+proj=tmerc +lat_0=38.55 +lon_0=-85.34999999999999 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jennings (m)",
    "code": 7325,
    "projection": "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Jennings (ftUS)",
    "code": 7326,
    "projection": "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Johnson-Marion (m)",
    "code": 7327,
    "projection": "+proj=tmerc +lat_0=39.3 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Johnson-Marion (ftUS)",
    "code": 7328,
    "projection": "+proj=tmerc +lat_0=39.3 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Knox (m)",
    "code": 7329,
    "projection": "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Knox (ftUS)",
    "code": 7330,
    "projection": "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS LaGrange-Noble (m)",
    "code": 7331,
    "projection": "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS LaGrange-Noble (ftUS)",
    "code": 7332,
    "projection": "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Lake-Newton (m)",
    "code": 7333,
    "projection": "+proj=tmerc +lat_0=40.7 +lon_0=-87.40000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Lake-Newton (ftUS)",
    "code": 7334,
    "projection": "+proj=tmerc +lat_0=40.7 +lon_0=-87.40000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS LaPorte-Pulaski-Starke (m)",
    "code": 7335,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS LaPorte-Pulaski-Starke (ftUS)",
    "code": 7336,
    "projection": "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Monroe-Morgan (m)",
    "code": 7337,
    "projection": "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Monroe-Morgan (ftUS)",
    "code": 7338,
    "projection": "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Montgomery-Putnam (m)",
    "code": 7339,
    "projection": "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Montgomery-Putnam (ftUS)",
    "code": 7340,
    "projection": "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Owen (m)",
    "code": 7341,
    "projection": "+proj=tmerc +lat_0=39.15 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Owen (ftUS)",
    "code": 7342,
    "projection": "+proj=tmerc +lat_0=39.15 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Parke-Vermillion (m)",
    "code": 7343,
    "projection": "+proj=tmerc +lat_0=39.6 +lon_0=-87.34999999999999 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Parke-Vermillion (ftUS)",
    "code": 7344,
    "projection": "+proj=tmerc +lat_0=39.6 +lon_0=-87.34999999999999 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Perry (m)",
    "code": 7345,
    "projection": "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Perry (ftUS)",
    "code": 7346,
    "projection": "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Pike-Warrick (m)",
    "code": 7347,
    "projection": "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Pike-Warrick (ftUS)",
    "code": 7348,
    "projection": "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Posey (m)",
    "code": 7349,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Posey (ftUS)",
    "code": 7350,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Randolph-Wayne (m)",
    "code": 7351,
    "projection": "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Randolph-Wayne (ftUS)",
    "code": 7352,
    "projection": "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Ripley (m)",
    "code": 7353,
    "projection": "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Ripley (ftUS)",
    "code": 7354,
    "projection": "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Shelby (m)",
    "code": 7355,
    "projection": "+proj=tmerc +lat_0=39.3 +lon_0=-85.90000000000001 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Shelby (ftUS)",
    "code": 7356,
    "projection": "+proj=tmerc +lat_0=39.3 +lon_0=-85.90000000000001 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Spencer (m)",
    "code": 7357,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Spencer (ftUS)",
    "code": 7358,
    "projection": "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Steuben (m)",
    "code": 7359,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Steuben (ftUS)",
    "code": 7360,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Sullivan (m)",
    "code": 7361,
    "projection": "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Sullivan (ftUS)",
    "code": 7362,
    "projection": "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Tippecanoe-White (m)",
    "code": 7363,
    "projection": "+proj=tmerc +lat_0=40.2 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Tippecanoe-White (ftUS)",
    "code": 7364,
    "projection": "+proj=tmerc +lat_0=40.2 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Vanderburgh (m)",
    "code": 7365,
    "projection": "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Vanderburgh (ftUS)",
    "code": 7366,
    "projection": "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Vigo (m)",
    "code": 7367,
    "projection": "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Vigo (ftUS)",
    "code": 7368,
    "projection": "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Wells (m)",
    "code": 7369,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / InGCS Wells (ftUS)",
    "code": 7370,
    "projection": "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "ONGD14 / UTM zone 39N",
    "code": 7374,
    "projection": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ONGD14 / UTM zone 40N",
    "code": 7375,
    "projection": "+proj=utm +zone=40 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ONGD14 / UTM zone 41N",
    "code": 7376,
    "projection": "+proj=utm +zone=41 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Adams and Juneau (m)",
    "code": 7528,
    "projection": "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Ashland (m)",
    "code": 7529,
    "projection": "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Barron (m)",
    "code": 7530,
    "projection": "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.84999999999999 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Bayfield (m)",
    "code": 7531,
    "projection": "+proj=lcc +lat_1=46.66964837722222 +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Brown (m)",
    "code": 7532,
    "projection": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Buffalo (m)",
    "code": 7533,
    "projection": "+proj=tmerc +lat_0=43.48138888888889 +lon_0=-91.79722222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Burnett (m)",
    "code": 7534,
    "projection": "+proj=lcc +lat_1=45.89871486583333 +lat_0=45.89871486583333 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (m)",
    "code": 7535,
    "projection": "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Chippewa (m)",
    "code": 7536,
    "projection": "+proj=lcc +lat_1=44.97785689861112 +lat_0=44.97785689861112 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Clark (m)",
    "code": 7537,
    "projection": "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Columbia (m)",
    "code": 7538,
    "projection": "+proj=lcc +lat_1=43.46254664583333 +lat_0=43.46254664583333 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Crawford (m)",
    "code": 7539,
    "projection": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dane (m)",
    "code": 7540,
    "projection": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dodge and Jefferson (m)",
    "code": 7541,
    "projection": "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.77500000000001 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Door (m)",
    "code": 7542,
    "projection": "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Douglas (m)",
    "code": 7543,
    "projection": "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dunn (m)",
    "code": 7544,
    "projection": "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Eau Claire (m)",
    "code": 7545,
    "projection": "+proj=lcc +lat_1=44.87228112638889 +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.92389999999 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Florence (m)",
    "code": 7546,
    "projection": "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Forest (m)",
    "code": 7547,
    "projection": "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Grant (m)",
    "code": 7548,
    "projection": "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Green and Lafayette (m)",
    "code": 7549,
    "projection": "+proj=lcc +lat_1=42.63756227694444 +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Green Lake and Marquette (m)",
    "code": 7550,
    "projection": "+proj=lcc +lat_1=43.80700011777778 +lat_0=43.80700011777778 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Iowa (m)",
    "code": 7551,
    "projection": "+proj=tmerc +lat_0=42.53888888888888 +lon_0=-90.16111111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Iron (m)",
    "code": 7552,
    "projection": "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.008500000000000001 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Jackson (m)",
    "code": 7553,
    "projection": "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (m)",
    "code": 7554,
    "projection": "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (m)",
    "code": 7555,
    "projection": "+proj=tmerc +lat_0=43.26666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS La Crosse (m)",
    "code": 7556,
    "projection": "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Langlade (m)",
    "code": 7557,
    "projection": "+proj=lcc +lat_1=45.15423710527778 +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Lincoln (m)",
    "code": 7558,
    "projection": "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Marathon (m)",
    "code": 7559,
    "projection": "+proj=lcc +lat_1=44.90090442361111 +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Marinette (m)",
    "code": 7560,
    "projection": "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Menominee (m)",
    "code": 7561,
    "projection": "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Monroe (m)",
    "code": 7562,
    "projection": "+proj=lcc +lat_1=44.00007392861111 +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Oconto (m)",
    "code": 7563,
    "projection": "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Oneida (m)",
    "code": 7564,
    "projection": "+proj=lcc +lat_1=45.70422377027778 +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Pepin and Pierce (m)",
    "code": 7565,
    "projection": "+proj=lcc +lat_1=44.63614887194444 +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Polk (m)",
    "code": 7566,
    "projection": "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Portage (m)",
    "code": 7567,
    "projection": "+proj=lcc +lat_1=44.41682397527777 +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Price (m)",
    "code": 7568,
    "projection": "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.48888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Richland (m)",
    "code": 7569,
    "projection": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Rock (m)",
    "code": 7570,
    "projection": "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Rusk (m)",
    "code": 7571,
    "projection": "+proj=tmerc +lat_0=43.91944444444444 +lon_0=-91.06666666666666 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Sauk (m)",
    "code": 7572,
    "projection": "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.90000000000001 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Sawyer (m)",
    "code": 7573,
    "projection": "+proj=lcc +lat_1=45.90009913138888 +lat_0=45.90009913138888 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Shawano (m)",
    "code": 7574,
    "projection": "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k=1.000032144 +x_0=262433.3253 +y_0=0.009599999999999999 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS St. Croix (m)",
    "code": 7575,
    "projection": "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Taylor (m)",
    "code": 7576,
    "projection": "+proj=lcc +lat_1=45.17782208583333 +lat_0=45.17782208583333 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Trempealeau (m)",
    "code": 7577,
    "projection": "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Vernon (m)",
    "code": 7578,
    "projection": "+proj=lcc +lat_1=43.57503293972223 +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Vilas (m)",
    "code": 7579,
    "projection": "+proj=lcc +lat_1=46.07784409055556 +lat_0=46.07784409055556 +lon_0=-89.48888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Walworth (m)",
    "code": 7580,
    "projection": "+proj=lcc +lat_1=42.66946209694444 +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Washburn (m)",
    "code": 7581,
    "projection": "+proj=lcc +lat_1=45.96121983333334 +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Washington (m)",
    "code": 7582,
    "projection": "+proj=tmerc +lat_0=42.91805555555555 +lon_0=-88.06388888888888 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waukesha (m)",
    "code": 7583,
    "projection": "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22499999999999 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waupaca (m)",
    "code": 7584,
    "projection": "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waushara (m)",
    "code": 7585,
    "projection": "+proj=lcc +lat_1=44.11394404583334 +lat_0=44.11394404583334 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Wood (m)",
    "code": 7586,
    "projection": "+proj=lcc +lat_1=44.36259546944444 +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Adams and Juneau (ftUS)",
    "code": 7587,
    "projection": "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6941325883 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Ashland (ftUS)",
    "code": 7588,
    "projection": "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.001828803657607315 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Barron (ftUS)",
    "code": 7589,
    "projection": "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.84999999999999 +k=1.0000486665 +x_0=93150 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Bayfield (ftUS)",
    "code": 7590,
    "projection": "+proj=lcc +lat_1=46.66964837722222 +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575057151 +y_0=148551.4835661671 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Brown (ftUS)",
    "code": 7591,
    "projection": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.99989839979 +y_0=4599.999898399797 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Buffalo (ftUS)",
    "code": 7592,
    "projection": "+proj=tmerc +lat_0=43.48138888888889 +lon_0=-91.79722222222222 +k=1.0000382778 +x_0=175260.3502159004 +y_0=0.004876809753619507 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Burnett (ftUS)",
    "code": 7593,
    "projection": "+proj=lcc +lat_1=45.89871486583333 +lat_0=45.89871486583333 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100838 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (ftUS)",
    "code": 7594,
    "projection": "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8892049784 +y_0=0.004876809753619507 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Chippewa (ftUS)",
    "code": 7595,
    "projection": "+proj=lcc +lat_1=44.97785689861112 +lat_0=44.97785689861112 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72009144018 +y_0=44091.43449326898 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Clark (ftUS)",
    "code": 7596,
    "projection": "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.008534417068834137 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Columbia (ftUS)",
    "code": 7597,
    "projection": "+proj=lcc +lat_1=43.46254664583333 +lat_0=43.46254664583333 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Crawford (ftUS)",
    "code": 7598,
    "projection": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6273812548 +y_0=53703.12024384048 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dane (ftUS)",
    "code": 7599,
    "projection": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dodge and Jefferson (ftUS)",
    "code": 7600,
    "projection": "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.77500000000001 +k=1.0000346418 +x_0=263347.7263906528 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Door (ftUS)",
    "code": 7601,
    "projection": "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k=1.0000187521 +x_0=158801.1176022352 +y_0=0.002438404876809754 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Douglas (ftUS)",
    "code": 7602,
    "projection": "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k=1.0000385418 +x_0=59131.31826263652 +y_0=0.003962407924815849 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Dunn (ftUS)",
    "code": 7603,
    "projection": "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k=1.0000410324 +x_0=51816.10393700787 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Eau Claire (ftUS)",
    "code": 7604,
    "projection": "+proj=lcc +lat_1=44.87228112638889 +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4401828804 +y_0=91687.92390144781 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Florence (ftUS)",
    "code": 7605,
    "projection": "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k=1.0000552095 +x_0=133502.6682245364 +y_0=0.006400812801625603 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Forest (ftUS)",
    "code": 7606,
    "projection": "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k=1.0000673004 +x_0=275844.5532131065 +y_0=0.0158496316992634 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Grant (ftUS)",
    "code": 7607,
    "projection": "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.01005842011684023 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Green and Lafayette (ftUS)",
    "code": 7608,
    "projection": "+proj=lcc +lat_1=42.63756227694444 +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7401574803 +y_0=45830.29484378968 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Green Lake and Marquette (ftUS)",
    "code": 7609,
    "projection": "+proj=lcc +lat_1=43.80700011777778 +lat_0=43.80700011777778 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3017526035 +y_0=79170.77937515875 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Iowa (ftUS)",
    "code": 7610,
    "projection": "+proj=tmerc +lat_0=42.53888888888888 +lon_0=-90.16111111111111 +k=1.0000394961 +x_0=113081.0261620523 +y_0=0.004572009144018288 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Iron (ftUS)",
    "code": 7611,
    "projection": "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k=1.0000677153 +x_0=220980.4419608839 +y_0=0.008534417068834137 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Jackson (ftUS)",
    "code": 7612,
    "projection": "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k=1.0000353 +x_0=27000 +y_0=24999.99989839979 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (ftUS)",
    "code": 7613,
    "projection": "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k=1.0000260649 +x_0=185928.3727711455 +y_0=0.0009144018288036576 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (ftUS)",
    "code": 7614,
    "projection": "+proj=tmerc +lat_0=43.26666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.76154432308 +y_0=0.001219202438404877 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS La Crosse (ftUS)",
    "code": 7615,
    "projection": "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k=1.0000319985 +x_0=130454.6596901194 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Langlade (ftUS)",
    "code": 7616,
    "projection": "+proj=lcc +lat_1=45.15423710527778 +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.1968503937 +y_0=105279.7828803657 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Lincoln (ftUS)",
    "code": 7617,
    "projection": "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k=1.0000599003 +x_0=116129.0322580645 +y_0=0.005791211582423164 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Marathon (ftUS)",
    "code": 7618,
    "projection": "+proj=lcc +lat_1=44.90090442361111 +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.26695453391 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Marinette (ftUS)",
    "code": 7619,
    "projection": "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k=1.0000234982 +x_0=238658.8794513589 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Menominee (ftUS)",
    "code": 7620,
    "projection": "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k=1.0000362499 +x_0=105461.0121412243 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Monroe (ftUS)",
    "code": 7621,
    "projection": "+proj=lcc +lat_1=44.00007392861111 +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.9861823724 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Oconto (ftUS)",
    "code": 7622,
    "projection": "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k=1.0000236869 +x_0=182880.3675895352 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Oneida (ftUS)",
    "code": 7623,
    "projection": "+proj=lcc +lat_1=45.70422377027778 +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.14020828041 +y_0=57588.03474726949 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Pepin and Pierce (ftUS)",
    "code": 7624,
    "projection": "+proj=lcc +lat_1=44.63614887194444 +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3352806706 +y_0=86033.08773177546 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Polk (ftUS)",
    "code": 7625,
    "projection": "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k=1.0000433849 +x_0=141732.2822453645 +y_0=0.005791211582423164 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Portage (ftUS)",
    "code": 7626,
    "projection": "+proj=lcc +lat_1=44.41682397527777 +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622555 +y_0=50022.1874523749 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Price (ftUS)",
    "code": 7627,
    "projection": "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.48888888888889 +k=1.0000649554 +x_0=227990.8544577089 +y_0=0.01097282194564389 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Richland (ftUS)",
    "code": 7628,
    "projection": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6047752095 +y_0=134255.4254508509 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Rock (ftUS)",
    "code": 7629,
    "projection": "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k=1.0000337311 +x_0=146304.2926085852 +y_0=0.006705613411226822 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Rusk (ftUS)",
    "code": 7630,
    "projection": "+proj=tmerc +lat_0=43.91944444444444 +lon_0=-91.06666666666666 +k=1.0000495976 +x_0=250546.1013970028 +y_0=0.02346964693929388 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Sauk (ftUS)",
    "code": 7631,
    "projection": "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.90000000000001 +k=1.0000373868 +x_0=185623.5715519431 +y_0=0.005181610363220727 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Sawyer (ftUS)",
    "code": 7632,
    "projection": "+proj=lcc +lat_1=45.90009913138888 +lat_0=45.90009913138888 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.1631699263 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Shawano (ftUS)",
    "code": 7633,
    "projection": "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637795 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS St. Croix (ftUS)",
    "code": 7634,
    "projection": "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k=1.0000381803 +x_0=165506.7300990602 +y_0=0.01036322072644145 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Taylor (ftUS)",
    "code": 7635,
    "projection": "+proj=lcc +lat_1=45.17782208583333 +lat_0=45.17782208583333 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.7521463043 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Trempealeau (ftUS)",
    "code": 7636,
    "projection": "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k=1.0000361538 +x_0=256946.9138938278 +y_0=0.003962407924815849 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Vernon (ftUS)",
    "code": 7637,
    "projection": "+proj=lcc +lat_1=43.57503293972223 +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Vilas (ftUS)",
    "code": 7638,
    "projection": "+proj=lcc +lat_1=46.07784409055556 +lat_0=46.07784409055556 +lon_0=-89.48888888888889 +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101854 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Walworth (ftUS)",
    "code": 7639,
    "projection": "+proj=lcc +lat_1=42.66946209694444 +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651257302 +y_0=111088.2224028448 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Washburn (ftUS)",
    "code": 7640,
    "projection": "+proj=lcc +lat_1=45.96121983333334 +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8681737363 +y_0=188358.6059436119 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Washington (ftUS)",
    "code": 7641,
    "projection": "+proj=tmerc +lat_0=42.91805555555555 +lon_0=-88.06388888888888 +k=1.00003738 +x_0=120091.4414020828 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waukesha (ftUS)",
    "code": 7642,
    "projection": "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22499999999999 +k=1.0000346179 +x_0=208788.4178816358 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waupaca (ftUS)",
    "code": 7643,
    "projection": "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k=1.0000333645 +x_0=185013.9709423419 +y_0=0.007010414020828041 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Waushara (ftUS)",
    "code": 7644,
    "projection": "+proj=lcc +lat_1=44.11394404583334 +lat_0=44.11394404583334 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4401828804 +y_0=45069.7588011176 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(2011) / WISCRS Wood (ftUS)",
    "code": 7645,
    "projection": "+proj=lcc +lat_1=44.36259546944444 +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6172720346 +y_0=134589.7539243078 +ellps=GRS80 +units=us-ft +no_defs "
  },
  {
    "name": "Kyrg-06 / zone 1",
    "code": 7692,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=68.51666666666667 +k=1 +x_0=1300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Kyrg-06 / zone 2",
    "code": 7693,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=71.51666666666667 +k=1 +x_0=2300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Kyrg-06 / zone 3",
    "code": 7694,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=74.51666666666667 +k=1 +x_0=3300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Kyrg-06 / zone 4",
    "code": 7695,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=77.51666666666667 +k=1 +x_0=4300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Kyrg-06 / zone 5",
    "code": 7696,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=80.51666666666667 +k=1 +x_0=5300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / India NSF LCC",
    "code": 7755,
    "projection": "+proj=lcc +lat_1=12.472955 +lat_2=35.17280444444444 +lat_0=24 +lon_0=80 +x_0=4000000 +y_0=4000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Andhra Pradesh",
    "code": 7756,
    "projection": "+proj=lcc +lat_1=13.75 +lat_2=18.75 +lat_0=16.25543298 +lon_0=80.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Arunachal Pradesh",
    "code": 7757,
    "projection": "+proj=lcc +lat_1=27 +lat_2=29 +lat_0=28.00157897 +lon_0=94.5 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Assam",
    "code": 7758,
    "projection": "+proj=lcc +lat_1=24.66666666666667 +lat_2=27.33333333333333 +lat_0=26.00257703 +lon_0=92.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Bihar",
    "code": 7759,
    "projection": "+proj=lcc +lat_1=24.625 +lat_2=27.125 +lat_0=25.87725247 +lon_0=85.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Delhi",
    "code": 7760,
    "projection": "+proj=lcc +lat_1=28.375 +lat_2=28.875 +lat_0=28.62510126 +lon_0=77 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Gujarat",
    "code": 7761,
    "projection": "+proj=lcc +lat_1=20.79166666666667 +lat_2=23.95833333333333 +lat_0=22.37807121 +lon_0=71.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Haryana",
    "code": 7762,
    "projection": "+proj=lcc +lat_1=28.08333333333333 +lat_2=30.41666666666667 +lat_0=29.25226266 +lon_0=76 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Himachal Pradesh",
    "code": 7763,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=32.75 +lat_0=31.75183497 +lon_0=77.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Jammu and Kashmir",
    "code": 7764,
    "projection": "+proj=lcc +lat_1=33.08333333333334 +lat_2=36.41666666666666 +lat_0=34.75570874 +lon_0=76.5 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Jharkhand",
    "code": 7765,
    "projection": "+proj=lcc +lat_1=22.54166666666667 +lat_2=24.70833333333333 +lat_0=23.62652682 +lon_0=85.625 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Madhya Pradesh",
    "code": 7766,
    "projection": "+proj=lcc +lat_1=22 +lat_2=26 +lat_0=24.00529821 +lon_0=78.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Maharashtra",
    "code": 7767,
    "projection": "+proj=lcc +lat_1=16.625 +lat_2=21.125 +lat_0=18.88015774 +lon_0=76.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Manipur",
    "code": 7768,
    "projection": "+proj=lcc +lat_1=24.08333333333333 +lat_2=25.41666666666667 +lat_0=24.75060911 +lon_0=94 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Meghalaya",
    "code": 7769,
    "projection": "+proj=lcc +lat_1=25.20833333333333 +lat_2=26.04166666666667 +lat_0=25.62524747 +lon_0=91.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Nagaland",
    "code": 7770,
    "projection": "+proj=lcc +lat_1=25.375 +lat_2=26.875 +lat_0=26.12581974 +lon_0=94.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / India Northeast",
    "code": 7771,
    "projection": "+proj=lcc +lat_1=23.04166666666667 +lat_2=28.20833333333333 +lat_0=25.63452135 +lon_0=93.5 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Orissa",
    "code": 7772,
    "projection": "+proj=lcc +lat_1=18.58333333333333 +lat_2=21.91666666666667 +lat_0=20.25305174 +lon_0=84.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Punjab",
    "code": 7773,
    "projection": "+proj=lcc +lat_1=30 +lat_2=32 +lat_0=31.00178226 +lon_0=75.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Rajasthan",
    "code": 7774,
    "projection": "+proj=lcc +lat_1=24.29166666666667 +lat_2=29.45833333333333 +lat_0=26.88505546 +lon_0=73.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Uttar Pradesh",
    "code": 7775,
    "projection": "+proj=lcc +lat_1=24.875 +lat_2=29.375 +lat_0=27.13270823 +lon_0=80.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Uttaranchal",
    "code": 7776,
    "projection": "+proj=lcc +lat_1=29 +lat_2=31 +lat_0=30.0017132 +lon_0=79.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Andaman and Nicobar",
    "code": 7777,
    "projection": "+proj=tmerc +lat_0=10.25 +lon_0=93.25 +k=0.9999428 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Chhattisgarh",
    "code": 7778,
    "projection": "+proj=tmerc +lat_0=21 +lon_0=82.25 +k=0.9998332 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Goa",
    "code": 7779,
    "projection": "+proj=tmerc +lat_0=15.375 +lon_0=74 +k=0.9999913 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Karnataka",
    "code": 7780,
    "projection": "+proj=tmerc +lat_0=15.125 +lon_0=76.375 +k=0.9998011999999999 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Kerala",
    "code": 7781,
    "projection": "+proj=tmerc +lat_0=10.5 +lon_0=76 +k=0.9999177 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Lakshadweep",
    "code": 7782,
    "projection": "+proj=tmerc +lat_0=10 +lon_0=73.125 +k=0.9999536 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Mizoram",
    "code": 7783,
    "projection": "+proj=tmerc +lat_0=23.125 +lon_0=92.75 +k=0.9999821 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Sikkim",
    "code": 7784,
    "projection": "+proj=tmerc +lat_0=27.625 +lon_0=88.5 +k=0.9999926 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Tamil Nadu",
    "code": 7785,
    "projection": "+proj=tmerc +lat_0=10.875 +lon_0=78.375 +k=0.9997942 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Tripura",
    "code": 7786,
    "projection": "+proj=tmerc +lat_0=23.75 +lon_0=91.75 +k=0.9999822 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / West Bengal",
    "code": 7787,
    "projection": "+proj=tmerc +lat_0=24.375 +lon_0=87.875 +k=0.9998584 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 32N",
    "code": 7791,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 33N",
    "code": 7792,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / UTM zone 34N",
    "code": 7793,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / Italy zone (E-N)",
    "code": 7794,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985000000000001 +x_0=7000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "RDN2008 / Zone 12 (E-N)",
    "code": 7795,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / UTM zone 34N (N-E)",
    "code": 7799,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / UTM zone 35N (N-E)",
    "code": 7800,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / CCS2005",
    "code": 7801,
    "projection": "+proj=lcc +lat_1=42 +lat_2=43.33333333333334 +lat_0=42.66787568333333 +lon_0=25.5 +x_0=500000 +y_0=4725824.3591 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / UTM zone 34N",
    "code": 7803,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / UTM zone 35N",
    "code": 7804,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005 / UTM zone 36N",
    "code": 7805,
    "projection": "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X1",
    "code": 7825,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=23.5 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X2",
    "code": 7826,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=26.5 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X3",
    "code": 7827,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=29.5 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X4",
    "code": 7828,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=32.5 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X5",
    "code": 7829,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=35.5 +k=1 +x_0=5300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X6",
    "code": 7830,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=38.5 +k=1 +x_0=6300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / CS63 zone X7",
    "code": 7831,
    "projection": "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=41.5 +k=1 +x_0=7300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / GA LCC",
    "code": 7845,
    "projection": "+proj=lcc +lat_1=-18 +lat_2=-36 +lat_0=0 +lon_0=134 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 46",
    "code": 7846,
    "projection": "+proj=utm +zone=46 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 47",
    "code": 7847,
    "projection": "+proj=utm +zone=47 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 48",
    "code": 7848,
    "projection": "+proj=utm +zone=48 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 49",
    "code": 7849,
    "projection": "+proj=utm +zone=49 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 50",
    "code": 7850,
    "projection": "+proj=utm +zone=50 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 51",
    "code": 7851,
    "projection": "+proj=utm +zone=51 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 52",
    "code": 7852,
    "projection": "+proj=utm +zone=52 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 53",
    "code": 7853,
    "projection": "+proj=utm +zone=53 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 54",
    "code": 7854,
    "projection": "+proj=utm +zone=54 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 55",
    "code": 7855,
    "projection": "+proj=utm +zone=55 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 56",
    "code": 7856,
    "projection": "+proj=utm +zone=56 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 57",
    "code": 7857,
    "projection": "+proj=utm +zone=57 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 58",
    "code": 7858,
    "projection": "+proj=utm +zone=58 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / MGA zone 59",
    "code": 7859,
    "projection": "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Astro DOS 71 / SHLG71",
    "code": 7877,
    "projection": "+proj=tmerc +lat_0=-15.96666666666667 +lon_0=-5.716666666666667 +k=1 +x_0=300000 +y_0=2000000 +ellps=intl +towgs84=-320,550,-494,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Astro DOS 71 / UTM zone 30S",
    "code": 7878,
    "projection": "+proj=utm +zone=30 +south +ellps=intl +towgs84=-320,550,-494,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "St. Helena Tritan / SHLG(Tritan)",
    "code": 7882,
    "projection": "+proj=tmerc +lat_0=-15.96666666666667 +lon_0=-5.716666666666667 +k=1 +x_0=299483.737 +y_0=2000527.879 +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "St. Helena Tritan / UTM zone 30S",
    "code": 7883,
    "projection": "+proj=utm +zone=30 +south +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SHMG2015",
    "code": 7887,
    "projection": "+proj=utm +zone=30 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA2020 / Vicgrid",
    "code": 7899,
    "projection": "+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 4",
    "code": 20004,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 5",
    "code": 20005,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 6",
    "code": 20006,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 7",
    "code": 20007,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 8",
    "code": 20008,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 9",
    "code": 20009,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 10",
    "code": 20010,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 11",
    "code": 20011,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 12",
    "code": 20012,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 13",
    "code": 20013,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 14",
    "code": 20014,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 15",
    "code": 20015,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 16",
    "code": 20016,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 17",
    "code": 20017,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 18",
    "code": 20018,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 19",
    "code": 20019,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 20",
    "code": 20020,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 21",
    "code": 20021,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 22",
    "code": 20022,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 23",
    "code": 20023,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 24",
    "code": 20024,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 25",
    "code": 20025,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 26",
    "code": 20026,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 27",
    "code": 20027,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 28",
    "code": 20028,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 29",
    "code": 20029,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 30",
    "code": 20030,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 31",
    "code": 20031,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger zone 32",
    "code": 20032,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 4N (deprecated)",
    "code": 20064,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 5N (deprecated)",
    "code": 20065,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 6N (deprecated)",
    "code": 20066,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 7N (deprecated)",
    "code": 20067,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 8N (deprecated)",
    "code": 20068,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 9N (deprecated)",
    "code": 20069,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 10N (deprecated)",
    "code": 20070,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 11N (deprecated)",
    "code": 20071,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 12N (deprecated)",
    "code": 20072,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 13N (deprecated)",
    "code": 20073,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 14N (deprecated)",
    "code": 20074,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 15N (deprecated)",
    "code": 20075,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 16N (deprecated)",
    "code": 20076,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 17N (deprecated)",
    "code": 20077,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 18N (deprecated)",
    "code": 20078,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 19N (deprecated)",
    "code": 20079,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 20N (deprecated)",
    "code": 20080,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 21N (deprecated)",
    "code": 20081,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 22N (deprecated)",
    "code": 20082,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 23N (deprecated)",
    "code": 20083,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 24N (deprecated)",
    "code": 20084,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 25N (deprecated)",
    "code": 20085,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 26N (deprecated)",
    "code": 20086,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 27N (deprecated)",
    "code": 20087,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 28N (deprecated)",
    "code": 20088,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 29N (deprecated)",
    "code": 20089,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 30N (deprecated)",
    "code": 20090,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 31N (deprecated)",
    "code": 20091,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1995 / Gauss-Kruger 32N (deprecated)",
    "code": 20092,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs "
  },
  {
    "name": "Adindan / UTM zone 35N",
    "code": 20135,
    "projection": "+proj=utm +zone=35 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Adindan / UTM zone 36N",
    "code": 20136,
    "projection": "+proj=utm +zone=36 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Adindan / UTM zone 37N",
    "code": 20137,
    "projection": "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Adindan / UTM zone 38N",
    "code": 20138,
    "projection": "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 48 (deprecated)",
    "code": 20248,
    "projection": "+proj=utm +zone=48 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 49",
    "code": 20249,
    "projection": "+proj=utm +zone=49 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 50",
    "code": 20250,
    "projection": "+proj=utm +zone=50 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 51",
    "code": 20251,
    "projection": "+proj=utm +zone=51 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 52",
    "code": 20252,
    "projection": "+proj=utm +zone=52 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 53",
    "code": 20253,
    "projection": "+proj=utm +zone=53 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 54",
    "code": 20254,
    "projection": "+proj=utm +zone=54 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 55",
    "code": 20255,
    "projection": "+proj=utm +zone=55 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 56",
    "code": 20256,
    "projection": "+proj=utm +zone=56 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 57",
    "code": 20257,
    "projection": "+proj=utm +zone=57 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD66 / AMG zone 58",
    "code": 20258,
    "projection": "+proj=utm +zone=58 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 48 (deprecated)",
    "code": 20348,
    "projection": "+proj=utm +zone=48 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 49",
    "code": 20349,
    "projection": "+proj=utm +zone=49 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 50",
    "code": 20350,
    "projection": "+proj=utm +zone=50 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 51",
    "code": 20351,
    "projection": "+proj=utm +zone=51 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 52",
    "code": 20352,
    "projection": "+proj=utm +zone=52 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 53",
    "code": 20353,
    "projection": "+proj=utm +zone=53 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 54",
    "code": 20354,
    "projection": "+proj=utm +zone=54 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 55",
    "code": 20355,
    "projection": "+proj=utm +zone=55 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 56",
    "code": 20356,
    "projection": "+proj=utm +zone=56 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 57 (deprecated)",
    "code": 20357,
    "projection": "+proj=utm +zone=57 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "AGD84 / AMG zone 58 (deprecated)",
    "code": 20358,
    "projection": "+proj=utm +zone=58 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / UTM zone 36N",
    "code": 20436,
    "projection": "+proj=utm +zone=36 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / UTM zone 37N",
    "code": 20437,
    "projection": "+proj=utm +zone=37 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / UTM zone 38N",
    "code": 20438,
    "projection": "+proj=utm +zone=38 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / UTM zone 39N",
    "code": 20439,
    "projection": "+proj=utm +zone=39 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / UTM zone 40N",
    "code": 20440,
    "projection": "+proj=utm +zone=40 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Ain el Abd / Bahrain Grid",
    "code": 20499,
    "projection": "+proj=utm +zone=39 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Afgooye / UTM zone 38N",
    "code": 20538,
    "projection": "+proj=utm +zone=38 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Afgooye / UTM zone 39N",
    "code": 20539,
    "projection": "+proj=utm +zone=39 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Lisbon (Lisbon) / Portuguese National Grid",
    "code": 20790,
    "projection": "+proj=tmerc +lat_0=39.66666666666666 +lon_0=1 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +units=m +no_defs "
  },
  {
    "name": "Lisbon (Lisbon) / Portuguese Grid",
    "code": 20791,
    "projection": "+proj=tmerc +lat_0=39.66666666666666 +lon_0=1 +k=1 +x_0=0 +y_0=0 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +units=m +no_defs "
  },
  {
    "name": "Aratu / UTM zone 22S",
    "code": 20822,
    "projection": "+proj=utm +zone=22 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Aratu / UTM zone 23S",
    "code": 20823,
    "projection": "+proj=utm +zone=23 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Aratu / UTM zone 24S",
    "code": 20824,
    "projection": "+proj=utm +zone=24 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1950 / UTM zone 34S",
    "code": 20934,
    "projection": "+proj=utm +zone=34 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1950 / UTM zone 35S",
    "code": 20935,
    "projection": "+proj=utm +zone=35 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1950 / UTM zone 36S",
    "code": 20936,
    "projection": "+proj=utm +zone=36 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 35S",
    "code": 21035,
    "projection": "+proj=utm +zone=35 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 36S",
    "code": 21036,
    "projection": "+proj=utm +zone=36 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 37S",
    "code": 21037,
    "projection": "+proj=utm +zone=37 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 35N",
    "code": 21095,
    "projection": "+proj=utm +zone=35 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 36N",
    "code": 21096,
    "projection": "+proj=utm +zone=36 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Arc 1960 / UTM zone 37N",
    "code": 21097,
    "projection": "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Batavia (Jakarta) / NEIEZ (deprecated)",
    "code": 21100,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "Batavia / UTM zone 48S",
    "code": 21148,
    "projection": "+proj=utm +zone=48 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Batavia / UTM zone 49S",
    "code": 21149,
    "projection": "+proj=utm +zone=49 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Batavia / UTM zone 50S",
    "code": 21150,
    "projection": "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Barbados 1938 / British West Indies Grid",
    "code": 21291,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Barbados 1938 / Barbados National Grid",
    "code": 21292,
    "projection": "+proj=tmerc +lat_0=13.17638888888889 +lon_0=-59.55972222222222 +k=0.9999986 +x_0=30000 +y_0=75000 +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 13",
    "code": 21413,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 14",
    "code": 21414,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 15",
    "code": 21415,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 16",
    "code": 21416,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 17",
    "code": 21417,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 18",
    "code": 21418,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 19",
    "code": 21419,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 20",
    "code": 21420,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 21",
    "code": 21421,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 22",
    "code": 21422,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger zone 23",
    "code": 21423,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 75E",
    "code": 21453,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 81E",
    "code": 21454,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 87E",
    "code": 21455,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 93E",
    "code": 21456,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 99E",
    "code": 21457,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 105E",
    "code": 21458,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 111E",
    "code": 21459,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 117E",
    "code": 21460,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 123E",
    "code": 21461,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 129E",
    "code": 21462,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger CM 135E",
    "code": 21463,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 13N (deprecated)",
    "code": 21473,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 14N (deprecated)",
    "code": 21474,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 15N (deprecated)",
    "code": 21475,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 16N (deprecated)",
    "code": 21476,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 17N (deprecated)",
    "code": 21477,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 18N (deprecated)",
    "code": 21478,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 19N (deprecated)",
    "code": 21479,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 20N (deprecated)",
    "code": 21480,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 21N (deprecated)",
    "code": 21481,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 22N (deprecated)",
    "code": 21482,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Beijing 1954 / Gauss-Kruger 23N (deprecated)",
    "code": 21483,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Belge 1950 (Brussels) / Belge Lambert 50",
    "code": 21500,
    "projection": "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=90 +lon_0=0 +x_0=150000 +y_0=5400000 +ellps=intl +pm=brussels +units=m +no_defs "
  },
  {
    "name": "Bern 1898 (Bern) / LV03C",
    "code": 21780,
    "projection": "+proj=somerc +lat_0=46.95240555555556 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +pm=bern +units=m +no_defs "
  },
  {
    "name": "CH1903 / LV03",
    "code": 21781,
    "projection": "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "CH1903 / LV03C-G",
    "code": 21782,
    "projection": "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / UTM zone 17N (deprecated)",
    "code": 21817,
    "projection": "+proj=utm +zone=17 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / UTM zone 18N",
    "code": 21818,
    "projection": "+proj=utm +zone=18 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia West zone (deprecated)",
    "code": 21891,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia Bogota zone (deprecated)",
    "code": 21892,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia East Central zone (deprecated)",
    "code": 21893,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia East (deprecated)",
    "code": 21894,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia West zone",
    "code": 21896,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia Bogota zone",
    "code": 21897,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia East Central zone",
    "code": 21898,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Bogota 1975 / Colombia East",
    "code": 21899,
    "projection": "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Camacupa / UTM zone 32S",
    "code": 22032,
    "projection": "+proj=utm +zone=32 +south +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Camacupa / UTM zone 33S",
    "code": 22033,
    "projection": "+proj=utm +zone=33 +south +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Camacupa / TM 11.30 SE",
    "code": 22091,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Camacupa / TM 12 SE",
    "code": 22092,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 1",
    "code": 22171,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 2",
    "code": 22172,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 3",
    "code": 22173,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 4",
    "code": 22174,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 5",
    "code": 22175,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 6",
    "code": 22176,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 / Argentina 7",
    "code": 22177,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 1",
    "code": 22181,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 2",
    "code": 22182,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 3",
    "code": 22183,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 4",
    "code": 22184,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 5",
    "code": 22185,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 6",
    "code": 22186,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94 / Argentina 7",
    "code": 22187,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 1",
    "code": 22191,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 2",
    "code": 22192,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 3",
    "code": 22193,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 4",
    "code": 22194,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 5",
    "code": 22195,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 6",
    "code": 22196,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Campo Inchauspe / Argentina 7",
    "code": 22197,
    "projection": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / UTM zone 34S",
    "code": 22234,
    "projection": "+proj=utm +zone=34 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / UTM zone 35S",
    "code": 22235,
    "projection": "+proj=utm +zone=35 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / UTM zone 36S (deprecated)",
    "code": 22236,
    "projection": "+proj=utm +zone=36 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo15",
    "code": 22275,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo17",
    "code": 22277,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo19",
    "code": 22279,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo21",
    "code": 22281,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo23",
    "code": 22283,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo25",
    "code": 22285,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo27",
    "code": 22287,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo29",
    "code": 22289,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo31",
    "code": 22291,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Cape / Lo33",
    "code": 22293,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Carthage / UTM zone 32N",
    "code": 22332,
    "projection": "+proj=utm +zone=32 +datum=carthage +units=m +no_defs "
  },
  {
    "name": "Carthage / Nord Tunisie",
    "code": 22391,
    "projection": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=9.9 +k_0=0.999625544 +x_0=500000 +y_0=300000 +datum=carthage +units=m +no_defs "
  },
  {
    "name": "Carthage / Sud Tunisie",
    "code": 22392,
    "projection": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=9.9 +k_0=0.999625769 +x_0=500000 +y_0=300000 +datum=carthage +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72 / UTM zone 21S",
    "code": 22521,
    "projection": "+proj=utm +zone=21 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72 / UTM zone 22S",
    "code": 22522,
    "projection": "+proj=utm +zone=22 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72 / UTM zone 23S",
    "code": 22523,
    "projection": "+proj=utm +zone=23 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72 / UTM zone 24S",
    "code": 22524,
    "projection": "+proj=utm +zone=24 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Corrego Alegre 1970-72 / UTM zone 25S",
    "code": 22525,
    "projection": "+proj=utm +zone=25 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Deir ez Zor / Levant Zone",
    "code": 22700,
    "projection": "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Deir ez Zor / Syria Lambert",
    "code": 22770,
    "projection": "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Deir ez Zor / Levant Stereographic",
    "code": 22780,
    "projection": "+proj=sterea +lat_0=34.2 +lon_0=39.15 +k=0.9995341 +x_0=0 +y_0=0 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Douala / UTM zone 32N (deprecated)",
    "code": 22832,
    "projection": "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Egypt 1907 / Blue Belt",
    "code": 22991,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=35 +k=1 +x_0=300000 +y_0=1100000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Egypt 1907 / Red Belt",
    "code": 22992,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Egypt 1907 / Purple Belt",
    "code": 22993,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Egypt 1907 / Extended Purple Belt",
    "code": 22994,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=1200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 28N",
    "code": 23028,
    "projection": "+proj=utm +zone=28 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 29N",
    "code": 23029,
    "projection": "+proj=utm +zone=29 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 30N",
    "code": 23030,
    "projection": "+proj=utm +zone=30 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 31N",
    "code": 23031,
    "projection": "+proj=utm +zone=31 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 32N",
    "code": 23032,
    "projection": "+proj=utm +zone=32 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 33N",
    "code": 23033,
    "projection": "+proj=utm +zone=33 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 34N",
    "code": 23034,
    "projection": "+proj=utm +zone=34 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 35N",
    "code": 23035,
    "projection": "+proj=utm +zone=35 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 36N",
    "code": 23036,
    "projection": "+proj=utm +zone=36 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 37N",
    "code": 23037,
    "projection": "+proj=utm +zone=37 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / UTM zone 38N",
    "code": 23038,
    "projection": "+proj=utm +zone=38 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM 0 N",
    "code": 23090,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=0 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ED50 / TM 5 NE",
    "code": 23095,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Fahud / UTM zone 39N",
    "code": 23239,
    "projection": "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +units=m +no_defs "
  },
  {
    "name": "Fahud / UTM zone 40N",
    "code": 23240,
    "projection": "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +units=m +no_defs "
  },
  {
    "name": "Garoua / UTM zone 33N (deprecated)",
    "code": 23433,
    "projection": "+proj=utm +zone=33 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "HD72 / EOV",
    "code": 23700,
    "projection": "+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 46.2",
    "code": 23830,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=94.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 47.1",
    "code": 23831,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=97.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 47.2",
    "code": 23832,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=100.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 48.1",
    "code": 23833,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=103.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 48.2",
    "code": 23834,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 49.1",
    "code": 23835,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=109.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 49.2",
    "code": 23836,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 50.1",
    "code": 23837,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=115.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 50.2",
    "code": 23838,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=118.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 51.1",
    "code": 23839,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 51.2",
    "code": 23840,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=124.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 52.1",
    "code": 23841,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=127.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 52.2",
    "code": 23842,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=130.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 53.1",
    "code": 23843,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=133.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 53.2",
    "code": 23844,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=136.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / Indonesia TM-3 zone 54.1",
    "code": 23845,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=139.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 46N",
    "code": 23846,
    "projection": "+proj=utm +zone=46 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 47N",
    "code": 23847,
    "projection": "+proj=utm +zone=47 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 48N",
    "code": 23848,
    "projection": "+proj=utm +zone=48 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 49N",
    "code": 23849,
    "projection": "+proj=utm +zone=49 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 50N",
    "code": 23850,
    "projection": "+proj=utm +zone=50 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 51N",
    "code": 23851,
    "projection": "+proj=utm +zone=51 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 52N",
    "code": 23852,
    "projection": "+proj=utm +zone=52 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 53N (deprecated)",
    "code": 23853,
    "projection": "+proj=utm +zone=53 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 46N",
    "code": 23866,
    "projection": "+proj=utm +zone=46 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 47N",
    "code": 23867,
    "projection": "+proj=utm +zone=47 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 48N",
    "code": 23868,
    "projection": "+proj=utm +zone=48 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 49N",
    "code": 23869,
    "projection": "+proj=utm +zone=49 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 50N",
    "code": 23870,
    "projection": "+proj=utm +zone=50 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 51N",
    "code": 23871,
    "projection": "+proj=utm +zone=51 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 52N",
    "code": 23872,
    "projection": "+proj=utm +zone=52 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 47S",
    "code": 23877,
    "projection": "+proj=utm +zone=47 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 48S",
    "code": 23878,
    "projection": "+proj=utm +zone=48 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 49S",
    "code": 23879,
    "projection": "+proj=utm +zone=49 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 50S",
    "code": 23880,
    "projection": "+proj=utm +zone=50 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 51S",
    "code": 23881,
    "projection": "+proj=utm +zone=51 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 52S",
    "code": 23882,
    "projection": "+proj=utm +zone=52 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 53S",
    "code": 23883,
    "projection": "+proj=utm +zone=53 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "DGN95 / UTM zone 54S",
    "code": 23884,
    "projection": "+proj=utm +zone=54 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 46S (deprecated)",
    "code": 23886,
    "projection": "+proj=utm +zone=46 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 47S",
    "code": 23887,
    "projection": "+proj=utm +zone=47 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 48S",
    "code": 23888,
    "projection": "+proj=utm +zone=48 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 49S",
    "code": 23889,
    "projection": "+proj=utm +zone=49 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 50S",
    "code": 23890,
    "projection": "+proj=utm +zone=50 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 51S",
    "code": 23891,
    "projection": "+proj=utm +zone=51 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 52S",
    "code": 23892,
    "projection": "+proj=utm +zone=52 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 53S",
    "code": 23893,
    "projection": "+proj=utm +zone=53 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ID74 / UTM zone 54S",
    "code": 23894,
    "projection": "+proj=utm +zone=54 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1954 / UTM zone 46N",
    "code": 23946,
    "projection": "+proj=utm +zone=46 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1954 / UTM zone 47N",
    "code": 23947,
    "projection": "+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1954 / UTM zone 48N",
    "code": 23948,
    "projection": "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1975 / UTM zone 47N",
    "code": 24047,
    "projection": "+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Indian 1975 / UTM zone 48N",
    "code": 24048,
    "projection": "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Jamaica 1875 / Jamaica (Old Grid)",
    "code": 24100,
    "projection": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=167638.49597 +y_0=121918.90616 +a=6378249.144808011 +b=6356514.966204134 +to_meter=0.3047972654 +no_defs "
  },
  {
    "name": "JAD69 / Jamaica National Grid",
    "code": 24200,
    "projection": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=250000 +y_0=150000 +ellps=clrk66 +towgs84=70,207,389.5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1937 / UTM zone 45N",
    "code": 24305,
    "projection": "+proj=utm +zone=45 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1937 / UTM zone 46N",
    "code": 24306,
    "projection": "+proj=utm +zone=46 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1962 / UTM zone 41N",
    "code": 24311,
    "projection": "+proj=utm +zone=41 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1962 / UTM zone 42N",
    "code": 24312,
    "projection": "+proj=utm +zone=42 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1962 / UTM zone 43N",
    "code": 24313,
    "projection": "+proj=utm +zone=43 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 42N",
    "code": 24342,
    "projection": "+proj=utm +zone=42 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 43N",
    "code": 24343,
    "projection": "+proj=utm +zone=43 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 44N",
    "code": 24344,
    "projection": "+proj=utm +zone=44 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 45N",
    "code": 24345,
    "projection": "+proj=utm +zone=45 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 46N",
    "code": 24346,
    "projection": "+proj=utm +zone=46 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / UTM zone 47N",
    "code": 24347,
    "projection": "+proj=utm +zone=47 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone 0",
    "code": 24370,
    "projection": "+proj=lcc +lat_1=39.5 +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.194628102 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone I",
    "code": 24371,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone IIa",
    "code": 24372,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone IIIa",
    "code": 24373,
    "projection": "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone IVa",
    "code": 24374,
    "projection": "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1937 / India zone IIb",
    "code": 24375,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1962 / India zone I",
    "code": 24376,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1962 / India zone IIa",
    "code": 24377,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / India zone I",
    "code": 24378,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / India zone IIa",
    "code": 24379,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / India zone IIb",
    "code": 24380,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1975 / India zone IIIa",
    "code": 24381,
    "projection": "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kalianpur 1880 / India zone IIb",
    "code": 24382,
    "projection": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs "
  },
  {
    "name": "Kalianpur 1975 / India zone IVa",
    "code": 24383,
    "projection": "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / Singapore Grid",
    "code": 24500,
    "projection": "+proj=cass +lat_0=1.287646666666667 +lon_0=103.8530022222222 +x_0=30000 +y_0=30000 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / UTM zone 47N",
    "code": 24547,
    "projection": "+proj=utm +zone=47 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau 1968 / UTM zone 48N",
    "code": 24548,
    "projection": "+proj=utm +zone=48 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Kertau / R.S.O. Malaya (ch) (deprecated)",
    "code": 24571,
    "projection": "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=804671.2997750348 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +to_meter=20.11678249437587 +no_defs "
  },
  {
    "name": "KOC Lambert",
    "code": 24600,
    "projection": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "La Canoa / UTM zone 18N",
    "code": 24718,
    "projection": "+proj=utm +zone=18 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "La Canoa / UTM zone 19N",
    "code": 24719,
    "projection": "+proj=utm +zone=19 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "La Canoa / UTM zone 20N",
    "code": 24720,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 17N",
    "code": 24817,
    "projection": "+proj=utm +zone=17 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 18N",
    "code": 24818,
    "projection": "+proj=utm +zone=18 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 19N",
    "code": 24819,
    "projection": "+proj=utm +zone=19 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 20N",
    "code": 24820,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 21N",
    "code": 24821,
    "projection": "+proj=utm +zone=21 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 17S",
    "code": 24877,
    "projection": "+proj=utm +zone=17 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 18S",
    "code": 24878,
    "projection": "+proj=utm +zone=18 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 19S",
    "code": 24879,
    "projection": "+proj=utm +zone=19 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 20S",
    "code": 24880,
    "projection": "+proj=utm +zone=20 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 21S",
    "code": 24881,
    "projection": "+proj=utm +zone=21 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / UTM zone 22S",
    "code": 24882,
    "projection": "+proj=utm +zone=22 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / Peru west zone",
    "code": 24891,
    "projection": "+proj=tmerc +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / Peru central zone",
    "code": 24892,
    "projection": "+proj=tmerc +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "PSAD56 / Peru east zone",
    "code": 24893,
    "projection": "+proj=tmerc +lat_0=-9.5 +lon_0=-70.5 +k=0.99952992 +x_0=1324000 +y_0=1040084.558 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Leigon / Ghana Metre Grid",
    "code": 25000,
    "projection": "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.51 +y_0=0 +ellps=clrk80 +towgs84=-130,29,364,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Lome / UTM zone 31N",
    "code": 25231,
    "projection": "+proj=utm +zone=31 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Luzon 1911 / Philippines zone I",
    "code": 25391,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Luzon 1911 / Philippines zone II",
    "code": 25392,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Luzon 1911 / Philippines zone III",
    "code": 25393,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Luzon 1911 / Philippines zone IV",
    "code": 25394,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Luzon 1911 / Philippines zone V",
    "code": 25395,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Makassar (Jakarta) / NEIEZ (deprecated)",
    "code": 25700,
    "projection": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 28N",
    "code": 25828,
    "projection": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 29N",
    "code": 25829,
    "projection": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 30N",
    "code": 25830,
    "projection": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31N",
    "code": 25831,
    "projection": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N",
    "code": 25832,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N",
    "code": 25833,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 34N",
    "code": 25834,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 35N",
    "code": 25835,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 36N",
    "code": 25836,
    "projection": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 37N",
    "code": 25837,
    "projection": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 38N (deprecated)",
    "code": 25838,
    "projection": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ETRS89 / TM Baltic93",
    "code": 25884,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Malongo 1987 / UTM zone 32S",
    "code": 25932,
    "projection": "+proj=utm +zone=32 +south +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Merchich / Nord Maroc",
    "code": 26191,
    "projection": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Merchich / Sud Maroc",
    "code": 26192,
    "projection": "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.9996155960000001 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Merchich / Sahara (deprecated)",
    "code": 26193,
    "projection": "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.9996 +x_0=1200000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Merchich / Sahara Nord",
    "code": 26194,
    "projection": "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Merchich / Sahara Sud",
    "code": 26195,
    "projection": "+proj=lcc +lat_1=22.5 +lat_0=22.5 +lon_0=-5.4 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Massawa / UTM zone 37N",
    "code": 26237,
    "projection": "+proj=utm +zone=37 +ellps=bessel +towgs84=639,405,60,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Minna / UTM zone 31N",
    "code": 26331,
    "projection": "+proj=utm +zone=31 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Minna / UTM zone 32N",
    "code": 26332,
    "projection": "+proj=utm +zone=32 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Minna / Nigeria West Belt",
    "code": 26391,
    "projection": "+proj=tmerc +lat_0=4 +lon_0=4.5 +k=0.99975 +x_0=230738.26 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Minna / Nigeria Mid Belt",
    "code": 26392,
    "projection": "+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Minna / Nigeria East Belt",
    "code": 26393,
    "projection": "+proj=tmerc +lat_0=4 +lon_0=12.5 +k=0.99975 +x_0=1110369.7 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Mhast / UTM zone 32S (deprecated)",
    "code": 26432,
    "projection": "+proj=utm +zone=32 +south +ellps=intl +towgs84=-252.95,-4.11,-96.38,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Monte Mario (Rome) / Italy zone 1 (deprecated)",
    "code": 26591,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-3.45233333333333 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +units=m +no_defs "
  },
  {
    "name": "Monte Mario (Rome) / Italy zone 2 (deprecated)",
    "code": 26592,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=2.54766666666666 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +units=m +no_defs "
  },
  {
    "name": "M'poraloko / UTM zone 32N",
    "code": 26632,
    "projection": "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "M'poraloko / UTM zone 32S",
    "code": 26692,
    "projection": "+proj=utm +zone=32 +south +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 1N",
    "code": 26701,
    "projection": "+proj=utm +zone=1 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 2N",
    "code": 26702,
    "projection": "+proj=utm +zone=2 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 3N",
    "code": 26703,
    "projection": "+proj=utm +zone=3 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 4N",
    "code": 26704,
    "projection": "+proj=utm +zone=4 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 5N",
    "code": 26705,
    "projection": "+proj=utm +zone=5 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 6N",
    "code": 26706,
    "projection": "+proj=utm +zone=6 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 7N",
    "code": 26707,
    "projection": "+proj=utm +zone=7 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 8N",
    "code": 26708,
    "projection": "+proj=utm +zone=8 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 9N",
    "code": 26709,
    "projection": "+proj=utm +zone=9 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 10N",
    "code": 26710,
    "projection": "+proj=utm +zone=10 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 11N",
    "code": 26711,
    "projection": "+proj=utm +zone=11 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 12N",
    "code": 26712,
    "projection": "+proj=utm +zone=12 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 13N",
    "code": 26713,
    "projection": "+proj=utm +zone=13 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 14N",
    "code": 26714,
    "projection": "+proj=utm +zone=14 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 15N",
    "code": 26715,
    "projection": "+proj=utm +zone=15 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 16N",
    "code": 26716,
    "projection": "+proj=utm +zone=16 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 17N",
    "code": 26717,
    "projection": "+proj=utm +zone=17 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 18N",
    "code": 26718,
    "projection": "+proj=utm +zone=18 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 19N",
    "code": 26719,
    "projection": "+proj=utm +zone=19 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 20N",
    "code": 26720,
    "projection": "+proj=utm +zone=20 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 21N",
    "code": 26721,
    "projection": "+proj=utm +zone=21 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / UTM zone 22N",
    "code": 26722,
    "projection": "+proj=utm +zone=22 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Alabama East",
    "code": 26729,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alabama West",
    "code": 26730,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 1",
    "code": 26731,
    "projection": "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000.001016002 +y_0=-5000000.001016002 +no_uoff +gamma=323.1301023611111 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 2",
    "code": 26732,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 3",
    "code": 26733,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 4",
    "code": 26734,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 5",
    "code": 26735,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 6",
    "code": 26736,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 7",
    "code": 26737,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=213360.4267208534 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 8",
    "code": 26738,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 9",
    "code": 26739,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Alaska zone 10",
    "code": 26740,
    "projection": "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=914401.8288036576 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone I",
    "code": 26741,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone II",
    "code": 26742,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone III",
    "code": 26743,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone IV",
    "code": 26744,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone V",
    "code": 26745,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone VI",
    "code": 26746,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone VII (deprecated)",
    "code": 26747,
    "projection": "+proj=lcc +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333 +lon_0=-118.3333333333333 +x_0=1276106.450596901 +y_0=127079.524511049 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Arizona East",
    "code": 26748,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Arizona Central",
    "code": 26749,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Arizona West",
    "code": 26750,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Arkansas North",
    "code": 26751,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Arkansas South",
    "code": 26752,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Colorado North",
    "code": 26753,
    "projection": "+proj=lcc +lat_1=39.71666666666667 +lat_2=40.78333333333333 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Colorado Central",
    "code": 26754,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Colorado South",
    "code": 26755,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Connecticut",
    "code": 26756,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Delaware",
    "code": 26757,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Florida East",
    "code": 26758,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Florida West",
    "code": 26759,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Florida North",
    "code": 26760,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Georgia East",
    "code": 26766,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Georgia West",
    "code": 26767,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Idaho East",
    "code": 26768,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Idaho Central",
    "code": 26769,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Idaho West",
    "code": 26770,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Illinois East",
    "code": 26771,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Illinois West",
    "code": 26772,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Indiana East",
    "code": 26773,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Indiana West",
    "code": 26774,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Iowa North",
    "code": 26775,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Iowa South",
    "code": 26776,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Kansas North",
    "code": 26777,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Kansas South",
    "code": 26778,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Kentucky North",
    "code": 26779,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Kentucky South",
    "code": 26780,
    "projection": "+proj=lcc +lat_1=36.73333333333333 +lat_2=37.93333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Louisiana North",
    "code": 26781,
    "projection": "+proj=lcc +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.66666666666667 +lon_0=-92.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Louisiana South",
    "code": 26782,
    "projection": "+proj=lcc +lat_1=29.3 +lat_2=30.7 +lat_0=28.66666666666667 +lon_0=-91.33333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Maine East",
    "code": 26783,
    "projection": "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-68.5 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Maine West",
    "code": 26784,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Maryland",
    "code": 26785,
    "projection": "+proj=lcc +lat_1=38.3 +lat_2=39.45 +lat_0=37.83333333333334 +lon_0=-77 +x_0=243840.4876809754 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Massachusetts Mainland",
    "code": 26786,
    "projection": "+proj=lcc +lat_1=41.71666666666667 +lat_2=42.68333333333333 +lat_0=41 +lon_0=-71.5 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Massachusetts Island",
    "code": 26787,
    "projection": "+proj=lcc +lat_1=41.28333333333333 +lat_2=41.48333333333333 +lat_0=41 +lon_0=-70.5 +x_0=60960.12192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Minnesota North",
    "code": 26791,
    "projection": "+proj=lcc +lat_1=47.03333333333333 +lat_2=48.63333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Minnesota Central",
    "code": 26792,
    "projection": "+proj=lcc +lat_1=45.61666666666667 +lat_2=47.05 +lat_0=45 +lon_0=-94.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Minnesota South",
    "code": 26793,
    "projection": "+proj=lcc +lat_1=43.78333333333333 +lat_2=45.21666666666667 +lat_0=43 +lon_0=-94 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Mississippi East",
    "code": 26794,
    "projection": "+proj=tmerc +lat_0=29.66666666666667 +lon_0=-88.83333333333333 +k=0.99996 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Mississippi West",
    "code": 26795,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-90.33333333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Missouri East",
    "code": 26796,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Missouri Central",
    "code": 26797,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Missouri West",
    "code": 26798,
    "projection": "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / California zone VII",
    "code": 26799,
    "projection": "+proj=lcc +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333 +lon_0=-118.3333333333333 +x_0=1276106.450596901 +y_0=1268253.006858014 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan East (deprecated)",
    "code": 26801,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k=0.999942857 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan Old Central (deprecated)",
    "code": 26802,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan West (deprecated)",
    "code": 26803,
    "projection": "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan North (deprecated)",
    "code": 26811,
    "projection": "+proj=lcc +lat_1=45.48333333333333 +lat_2=47.08333333333334 +lat_0=44.78333333333333 +lon_0=-87 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan Central (deprecated)",
    "code": 26812,
    "projection": "+proj=lcc +lat_1=44.18333333333333 +lat_2=45.7 +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD Michigan / Michigan South (deprecated)",
    "code": 26813,
    "projection": "+proj=lcc +lat_1=42.1 +lat_2=43.66666666666666 +lat_0=41.5 +lon_0=-84.33333333333333 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Maine East (ftUS) (deprecated)",
    "code": 26814,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine West (ftUS) (deprecated)",
    "code": 26815,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota North (ftUS) (deprecated)",
    "code": 26819,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota Central (ftUS) (deprecated)",
    "code": 26820,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota South (ftUS) (deprecated)",
    "code": 26821,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Nebraska (ftUS) (deprecated)",
    "code": 26822,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / West Virginia North (ftUS) (deprecated)",
    "code": 26823,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / West Virginia South (ftUS) (deprecated)",
    "code": 26824,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine East (ftUS) (deprecated)",
    "code": 26825,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine West (ftUS) (deprecated)",
    "code": 26826,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota North (ftUS) (deprecated)",
    "code": 26830,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota Central (ftUS) (deprecated)",
    "code": 26831,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota South (ftUS) (deprecated)",
    "code": 26832,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nebraska (ftUS) (deprecated)",
    "code": 26833,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia North (ftUS) (deprecated)",
    "code": 26834,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia South (ftUS) (deprecated)",
    "code": 26835,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine East (ftUS) (deprecated)",
    "code": 26836,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine West (ftUS) (deprecated)",
    "code": 26837,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota North (ftUS) (deprecated)",
    "code": 26841,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota Central (ftUS) (deprecated)",
    "code": 26842,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota South (ftUS) (deprecated)",
    "code": 26843,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nebraska (ftUS) (deprecated)",
    "code": 26844,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia North (ftUS) (deprecated)",
    "code": 26845,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia South (ftUS) (deprecated)",
    "code": 26846,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine East (ftUS)",
    "code": 26847,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Maine West (ftUS)",
    "code": 26848,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Minnesota North (ftUS)",
    "code": 26849,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Minnesota Central (ftUS)",
    "code": 26850,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Minnesota South (ftUS)",
    "code": 26851,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Nebraska (ftUS)",
    "code": 26852,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / West Virginia North (ftUS)",
    "code": 26853,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / West Virginia South (ftUS)",
    "code": 26854,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine East (ftUS)",
    "code": 26855,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Maine West (ftUS)",
    "code": 26856,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota North (ftUS)",
    "code": 26857,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota Central (ftUS)",
    "code": 26858,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Minnesota South (ftUS)",
    "code": 26859,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / Nebraska (ftUS)",
    "code": 26860,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia North (ftUS)",
    "code": 26861,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(HARN) / West Virginia South (ftUS)",
    "code": 26862,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine East (ftUS)",
    "code": 26863,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Maine West (ftUS)",
    "code": 26864,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota North (ftUS)",
    "code": 26865,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota Central (ftUS)",
    "code": 26866,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Minnesota South (ftUS)",
    "code": 26867,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / Nebraska (ftUS)",
    "code": 26868,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia North (ftUS)",
    "code": 26869,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) / West Virginia South (ftUS)",
    "code": 26870,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 11",
    "code": 26891,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 12",
    "code": 26892,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 13",
    "code": 26893,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 14",
    "code": 26894,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 15",
    "code": 26895,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 16",
    "code": 26896,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 17",
    "code": 26897,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 1",
    "code": 26898,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / MTM zone 2",
    "code": 26899,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 1N",
    "code": 26901,
    "projection": "+proj=utm +zone=1 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 2N",
    "code": 26902,
    "projection": "+proj=utm +zone=2 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 3N",
    "code": 26903,
    "projection": "+proj=utm +zone=3 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 4N",
    "code": 26904,
    "projection": "+proj=utm +zone=4 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 5N",
    "code": 26905,
    "projection": "+proj=utm +zone=5 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 6N",
    "code": 26906,
    "projection": "+proj=utm +zone=6 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 7N",
    "code": 26907,
    "projection": "+proj=utm +zone=7 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 8N",
    "code": 26908,
    "projection": "+proj=utm +zone=8 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 9N",
    "code": 26909,
    "projection": "+proj=utm +zone=9 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 10N",
    "code": 26910,
    "projection": "+proj=utm +zone=10 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 11N",
    "code": 26911,
    "projection": "+proj=utm +zone=11 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 12N",
    "code": 26912,
    "projection": "+proj=utm +zone=12 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 13N",
    "code": 26913,
    "projection": "+proj=utm +zone=13 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 14N",
    "code": 26914,
    "projection": "+proj=utm +zone=14 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 15N",
    "code": 26915,
    "projection": "+proj=utm +zone=15 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 16N",
    "code": 26916,
    "projection": "+proj=utm +zone=16 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 17N",
    "code": 26917,
    "projection": "+proj=utm +zone=17 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 18N",
    "code": 26918,
    "projection": "+proj=utm +zone=18 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 19N",
    "code": 26919,
    "projection": "+proj=utm +zone=19 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 20N",
    "code": 26920,
    "projection": "+proj=utm +zone=20 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 21N",
    "code": 26921,
    "projection": "+proj=utm +zone=21 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 22N",
    "code": 26922,
    "projection": "+proj=utm +zone=22 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / UTM zone 23N",
    "code": 26923,
    "projection": "+proj=utm +zone=23 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alabama East",
    "code": 26929,
    "projection": "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alabama West",
    "code": 26930,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 1",
    "code": 26931,
    "projection": "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 2",
    "code": 26932,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 3",
    "code": 26933,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 4",
    "code": 26934,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 5",
    "code": 26935,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 6",
    "code": 26936,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 7",
    "code": 26937,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 8",
    "code": 26938,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 9",
    "code": 26939,
    "projection": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Alaska zone 10",
    "code": 26940,
    "projection": "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 1",
    "code": 26941,
    "projection": "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 2",
    "code": 26942,
    "projection": "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 3",
    "code": 26943,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 4",
    "code": 26944,
    "projection": "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 5",
    "code": 26945,
    "projection": "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / California zone 6",
    "code": 26946,
    "projection": "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arizona East",
    "code": 26948,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arizona Central",
    "code": 26949,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arizona West",
    "code": 26950,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arkansas North",
    "code": 26951,
    "projection": "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Arkansas South",
    "code": 26952,
    "projection": "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Colorado North",
    "code": 26953,
    "projection": "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Colorado Central",
    "code": 26954,
    "projection": "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Colorado South",
    "code": 26955,
    "projection": "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Connecticut",
    "code": 26956,
    "projection": "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Delaware",
    "code": 26957,
    "projection": "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Florida East",
    "code": 26958,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Florida West",
    "code": 26959,
    "projection": "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Florida North",
    "code": 26960,
    "projection": "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 1",
    "code": 26961,
    "projection": "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 2",
    "code": 26962,
    "projection": "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 3",
    "code": 26963,
    "projection": "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 4",
    "code": 26964,
    "projection": "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Hawaii zone 5",
    "code": 26965,
    "projection": "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Georgia East",
    "code": 26966,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Georgia West",
    "code": 26967,
    "projection": "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Idaho East",
    "code": 26968,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Idaho Central",
    "code": 26969,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Idaho West",
    "code": 26970,
    "projection": "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Illinois East",
    "code": 26971,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Illinois West",
    "code": 26972,
    "projection": "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Indiana East",
    "code": 26973,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Indiana West",
    "code": 26974,
    "projection": "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Iowa North",
    "code": 26975,
    "projection": "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Iowa South",
    "code": 26976,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kansas North",
    "code": 26977,
    "projection": "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kansas South",
    "code": 26978,
    "projection": "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kentucky North (deprecated)",
    "code": 26979,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=37.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Kentucky South",
    "code": 26980,
    "projection": "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Louisiana North",
    "code": 26981,
    "projection": "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Louisiana South",
    "code": 26982,
    "projection": "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine East",
    "code": 26983,
    "projection": "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maine West",
    "code": 26984,
    "projection": "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Maryland",
    "code": 26985,
    "projection": "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Massachusetts Mainland",
    "code": 26986,
    "projection": "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Massachusetts Island",
    "code": 26987,
    "projection": "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Michigan North",
    "code": 26988,
    "projection": "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Michigan Central",
    "code": 26989,
    "projection": "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Michigan South",
    "code": 26990,
    "projection": "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota North",
    "code": 26991,
    "projection": "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota Central",
    "code": 26992,
    "projection": "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Minnesota South",
    "code": 26993,
    "projection": "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Mississippi East",
    "code": 26994,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Mississippi West",
    "code": 26995,
    "projection": "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Missouri East",
    "code": 26996,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Missouri Central",
    "code": 26997,
    "projection": "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Missouri West",
    "code": 26998,
    "projection": "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1967 / UTM zone 37N (deprecated)",
    "code": 27037,
    "projection": "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1967 / UTM zone 38N (deprecated)",
    "code": 27038,
    "projection": "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1967 / UTM zone 39N",
    "code": 27039,
    "projection": "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Nahrwan 1967 / UTM zone 40N",
    "code": 27040,
    "projection": "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Naparima 1972 / UTM zone 20N",
    "code": 27120,
    "projection": "+proj=utm +zone=20 +ellps=intl +towgs84=-10,375,165,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / New Zealand Map Grid",
    "code": 27200,
    "projection": "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Mount Eden Circuit",
    "code": 27205,
    "projection": "+proj=tmerc +lat_0=-36.87986527777778 +lon_0=174.7643393611111 +k=0.9999 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Bay of Plenty Circuit",
    "code": 27206,
    "projection": "+proj=tmerc +lat_0=-37.76124980555556 +lon_0=176.46619725 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Poverty Bay Circuit",
    "code": 27207,
    "projection": "+proj=tmerc +lat_0=-38.62470277777778 +lon_0=177.8856362777778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Hawkes Bay Circuit",
    "code": 27208,
    "projection": "+proj=tmerc +lat_0=-39.65092930555556 +lon_0=176.6736805277778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Taranaki Circuit",
    "code": 27209,
    "projection": "+proj=tmerc +lat_0=-39.13575830555556 +lon_0=174.22801175 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Tuhirangi Circuit",
    "code": 27210,
    "projection": "+proj=tmerc +lat_0=-39.51247038888889 +lon_0=175.6400368055556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Wanganui Circuit",
    "code": 27211,
    "projection": "+proj=tmerc +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Wairarapa Circuit",
    "code": 27212,
    "projection": "+proj=tmerc +lat_0=-40.92553263888889 +lon_0=175.6473496666667 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Wellington Circuit",
    "code": 27213,
    "projection": "+proj=tmerc +lat_0=-41.30131963888888 +lon_0=174.7766231111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Collingwood Circuit",
    "code": 27214,
    "projection": "+proj=tmerc +lat_0=-40.71475905555556 +lon_0=172.6720465 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Nelson Circuit",
    "code": 27215,
    "projection": "+proj=tmerc +lat_0=-41.27454472222222 +lon_0=173.2993168055555 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Karamea Circuit",
    "code": 27216,
    "projection": "+proj=tmerc +lat_0=-41.28991152777778 +lon_0=172.1090281944444 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Buller Circuit",
    "code": 27217,
    "projection": "+proj=tmerc +lat_0=-41.81080286111111 +lon_0=171.5812600555556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Grey Circuit",
    "code": 27218,
    "projection": "+proj=tmerc +lat_0=-42.33369427777778 +lon_0=171.5497713055556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Amuri Circuit",
    "code": 27219,
    "projection": "+proj=tmerc +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Marlborough Circuit",
    "code": 27220,
    "projection": "+proj=tmerc +lat_0=-41.54448666666666 +lon_0=173.8020741111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Hokitika Circuit",
    "code": 27221,
    "projection": "+proj=tmerc +lat_0=-42.88632236111111 +lon_0=170.9799935 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Okarito Circuit",
    "code": 27222,
    "projection": "+proj=tmerc +lat_0=-43.11012813888889 +lon_0=170.2609258333333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Jacksons Bay Circuit",
    "code": 27223,
    "projection": "+proj=tmerc +lat_0=-43.97780288888889 +lon_0=168.606267 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Mount Pleasant Circuit",
    "code": 27224,
    "projection": "+proj=tmerc +lat_0=-43.59063758333333 +lon_0=172.7271935833333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Gawler Circuit",
    "code": 27225,
    "projection": "+proj=tmerc +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Timaru Circuit",
    "code": 27226,
    "projection": "+proj=tmerc +lat_0=-44.40222036111111 +lon_0=171.0572508333333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Lindis Peak Circuit",
    "code": 27227,
    "projection": "+proj=tmerc +lat_0=-44.73526797222222 +lon_0=169.4677550833333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Mount Nicholas Circuit",
    "code": 27228,
    "projection": "+proj=tmerc +lat_0=-45.13290258333333 +lon_0=168.3986411944444 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Mount York Circuit",
    "code": 27229,
    "projection": "+proj=tmerc +lat_0=-45.56372616666666 +lon_0=167.7388617777778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Observation Point Circuit",
    "code": 27230,
    "projection": "+proj=tmerc +lat_0=-45.81619661111111 +lon_0=170.6285951666667 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / North Taieri Circuit",
    "code": 27231,
    "projection": "+proj=tmerc +lat_0=-45.86151336111111 +lon_0=170.2825891111111 +k=0.99996 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / Bluff Circuit",
    "code": 27232,
    "projection": "+proj=tmerc +lat_0=-46.60000961111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58 +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / UTM zone 58S",
    "code": 27258,
    "projection": "+proj=utm +zone=58 +south +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / UTM zone 59S",
    "code": 27259,
    "projection": "+proj=utm +zone=59 +south +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / UTM zone 60S",
    "code": 27260,
    "projection": "+proj=utm +zone=60 +south +datum=nzgd49 +units=m +no_defs "
  },
  {
    "name": "NZGD49 / North Island Grid",
    "code": 27291,
    "projection": "+proj=tmerc +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.5243848086 +y_0=365759.3658464114 +datum=nzgd49 +to_meter=0.9143984146160287 +no_defs "
  },
  {
    "name": "NZGD49 / South Island Grid",
    "code": 27292,
    "projection": "+proj=tmerc +lat_0=-44 +lon_0=171.5 +k=1 +x_0=457199.2073080143 +y_0=457199.2073080143 +datum=nzgd49 +to_meter=0.9143984146160287 +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone I",
    "code": 27391,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=-4.666666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone II",
    "code": 27392,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=-2.333333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone III",
    "code": 27393,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone IV",
    "code": 27394,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=2.5 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone V",
    "code": 27395,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=6.166666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone VI",
    "code": 27396,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=10.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone VII",
    "code": 27397,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=14.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "NGO 1948 (Oslo) / NGO zone VIII",
    "code": 27398,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=18.33333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs "
  },
  {
    "name": "Datum 73 / UTM zone 29N",
    "code": 27429,
    "projection": "+proj=utm +zone=29 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Datum 73 / Modified Portuguese Grid (deprecated)",
    "code": 27492,
    "projection": "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=180.598 +y_0=-86.98999999999999 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Datum 73 / Modified Portuguese Grid",
    "code": 27493,
    "projection": "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=180.598 +y_0=-86.98999999999999 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "ATF (Paris) / Nord de Guerre",
    "code": 27500,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=5.399999999999999 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +b=6355862.933255573 +pm=2.337208333333333 +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert Nord France",
    "code": 27561,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert Centre France",
    "code": 27562,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert Sud France",
    "code": 27563,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert Corse",
    "code": 27564,
    "projection": "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone I",
    "code": 27571,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone II",
    "code": 27572,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone III",
    "code": 27573,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone IV",
    "code": 27574,
    "projection": "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France I (deprecated)",
    "code": 27581,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France II (deprecated)",
    "code": 27582,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France III (deprecated)",
    "code": 27583,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France IV (deprecated)",
    "code": 27584,
    "projection": "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Nord France (deprecated)",
    "code": 27591,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Centre France (deprecated)",
    "code": 27592,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Sud France (deprecated)",
    "code": 27593,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Corse (deprecated)",
    "code": 27594,
    "projection": "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "OSGB 1936 / British National Grid",
    "code": 27700,
    "projection": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +datum=OSGB36 +units=m +no_defs "
  },
  {
    "name": "Palestine 1923 / Palestine Grid",
    "code": 28191,
    "projection": "+proj=cass +lat_0=31.73409694444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs "
  },
  {
    "name": "Palestine 1923 / Palestine Belt",
    "code": 28192,
    "projection": "+proj=tmerc +lat_0=31.73409694444445 +lon_0=35.21208055555556 +k=1 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs "
  },
  {
    "name": "Palestine 1923 / Israeli CS Grid",
    "code": 28193,
    "projection": "+proj=cass +lat_0=31.73409694444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs "
  },
  {
    "name": "Pointe Noire / UTM zone 32S",
    "code": 28232,
    "projection": "+proj=utm +zone=32 +south +a=6378249.2 +b=6356515 +towgs84=-148,51,-291,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 48",
    "code": 28348,
    "projection": "+proj=utm +zone=48 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 49",
    "code": 28349,
    "projection": "+proj=utm +zone=49 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 50",
    "code": 28350,
    "projection": "+proj=utm +zone=50 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 51",
    "code": 28351,
    "projection": "+proj=utm +zone=51 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 52",
    "code": 28352,
    "projection": "+proj=utm +zone=52 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 53",
    "code": 28353,
    "projection": "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 54",
    "code": 28354,
    "projection": "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 55",
    "code": 28355,
    "projection": "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 56",
    "code": 28356,
    "projection": "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 57",
    "code": 28357,
    "projection": "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "GDA94 / MGA zone 58",
    "code": 28358,
    "projection": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 2 (deprecated)",
    "code": 28402,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 3 (deprecated)",
    "code": 28403,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 4",
    "code": 28404,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 5",
    "code": 28405,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 6",
    "code": 28406,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 7",
    "code": 28407,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 8",
    "code": 28408,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 9",
    "code": 28409,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 10",
    "code": 28410,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 11",
    "code": 28411,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 12",
    "code": 28412,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 13",
    "code": 28413,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 14",
    "code": 28414,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 15",
    "code": 28415,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 16",
    "code": 28416,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 17",
    "code": 28417,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 18",
    "code": 28418,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 19",
    "code": 28419,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 20",
    "code": 28420,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 21",
    "code": 28421,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 22",
    "code": 28422,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 23",
    "code": 28423,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 24",
    "code": 28424,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 25",
    "code": 28425,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 26",
    "code": 28426,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 27",
    "code": 28427,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 28",
    "code": 28428,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 29",
    "code": 28429,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 30",
    "code": 28430,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 31",
    "code": 28431,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger zone 32",
    "code": 28432,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 2N (deprecated)",
    "code": 28462,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 3N (deprecated)",
    "code": 28463,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 4N (deprecated)",
    "code": 28464,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 5N (deprecated)",
    "code": 28465,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 6N (deprecated)",
    "code": 28466,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 7N (deprecated)",
    "code": 28467,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 8N (deprecated)",
    "code": 28468,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 9N (deprecated)",
    "code": 28469,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 10N (deprecated)",
    "code": 28470,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 11N (deprecated)",
    "code": 28471,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 12N (deprecated)",
    "code": 28472,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 13N (deprecated)",
    "code": 28473,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 14N (deprecated)",
    "code": 28474,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 15N (deprecated)",
    "code": 28475,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 16N (deprecated)",
    "code": 28476,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 17N (deprecated)",
    "code": 28477,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 18N (deprecated)",
    "code": 28478,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 19N (deprecated)",
    "code": 28479,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 20N (deprecated)",
    "code": 28480,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 21N (deprecated)",
    "code": 28481,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 22N (deprecated)",
    "code": 28482,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 23N (deprecated)",
    "code": 28483,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 24N (deprecated)",
    "code": 28484,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 25N (deprecated)",
    "code": 28485,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 26N (deprecated)",
    "code": 28486,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 27N (deprecated)",
    "code": 28487,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 28N (deprecated)",
    "code": 28488,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 29N (deprecated)",
    "code": 28489,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 30N (deprecated)",
    "code": 28490,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 31N (deprecated)",
    "code": 28491,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Pulkovo 1942 / Gauss-Kruger 32N (deprecated)",
    "code": 28492,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs "
  },
  {
    "name": "Qatar 1974 / Qatar National Grid",
    "code": 28600,
    "projection": "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-128.16,-282.42,21.93,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Amersfoort / RD Old",
    "code": 28991,
    "projection": "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=0 +y_0=0 +ellps=bessel +towgs84=565.2369,50.0087,465.658,-0.406857,0.350733,-1.87035,4.0812 +units=m +no_defs "
  },
  {
    "name": "Amersfoort / RD New",
    "code": 28992,
    "projection": "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.2369,50.0087,465.658,-0.406857,0.350733,-1.87035,4.0812 +units=m +no_defs "
  },
  {
    "name": "SAD69 / Brazil Polyconic (deprecated)",
    "code": 29100,
    "projection": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / Brazil Polyconic",
    "code": 29101,
    "projection": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 18N (deprecated)",
    "code": 29118,
    "projection": "+proj=utm +zone=18 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 19N (deprecated)",
    "code": 29119,
    "projection": "+proj=utm +zone=19 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 20N (deprecated)",
    "code": 29120,
    "projection": "+proj=utm +zone=20 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 21N (deprecated)",
    "code": 29121,
    "projection": "+proj=utm +zone=21 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 22N (deprecated)",
    "code": 29122,
    "projection": "+proj=utm +zone=22 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 18N",
    "code": 29168,
    "projection": "+proj=utm +zone=18 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 19N",
    "code": 29169,
    "projection": "+proj=utm +zone=19 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 20N",
    "code": 29170,
    "projection": "+proj=utm +zone=20 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 21N",
    "code": 29171,
    "projection": "+proj=utm +zone=21 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 22N",
    "code": 29172,
    "projection": "+proj=utm +zone=22 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 17S (deprecated)",
    "code": 29177,
    "projection": "+proj=utm +zone=17 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 18S (deprecated)",
    "code": 29178,
    "projection": "+proj=utm +zone=18 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 19S (deprecated)",
    "code": 29179,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 20S (deprecated)",
    "code": 29180,
    "projection": "+proj=utm +zone=20 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 21S (deprecated)",
    "code": 29181,
    "projection": "+proj=utm +zone=21 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 22S (deprecated)",
    "code": 29182,
    "projection": "+proj=utm +zone=22 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 23S (deprecated)",
    "code": 29183,
    "projection": "+proj=utm +zone=23 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 24S (deprecated)",
    "code": 29184,
    "projection": "+proj=utm +zone=24 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 25S (deprecated)",
    "code": 29185,
    "projection": "+proj=utm +zone=25 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 17S",
    "code": 29187,
    "projection": "+proj=utm +zone=17 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 18S",
    "code": 29188,
    "projection": "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 19S",
    "code": 29189,
    "projection": "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 20S",
    "code": 29190,
    "projection": "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 21S",
    "code": 29191,
    "projection": "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 22S",
    "code": 29192,
    "projection": "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 23S",
    "code": 29193,
    "projection": "+proj=utm +zone=23 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 24S",
    "code": 29194,
    "projection": "+proj=utm +zone=24 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SAD69 / UTM zone 25S",
    "code": 29195,
    "projection": "+proj=utm +zone=25 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Sapper Hill 1943 / UTM zone 20S",
    "code": 29220,
    "projection": "+proj=utm +zone=20 +south +ellps=intl +towgs84=-355,21,72,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Sapper Hill 1943 / UTM zone 21S",
    "code": 29221,
    "projection": "+proj=utm +zone=21 +south +ellps=intl +towgs84=-355,21,72,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Schwarzeck / UTM zone 33S",
    "code": 29333,
    "projection": "+proj=utm +zone=33 +south +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/11",
    "code": 29371,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=11 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/13",
    "code": 29373,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=13 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/15",
    "code": 29375,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/17",
    "code": 29377,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/19",
    "code": 29379,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/21",
    "code": 29381,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/23",
    "code": 29383,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Schwarzeck / Lo22/25",
    "code": 29385,
    "projection": "+proj=tmerc +lat_0=-22 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs "
  },
  {
    "name": "Sudan / UTM zone 35N (deprecated)",
    "code": 29635,
    "projection": "+proj=utm +zone=35 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Sudan / UTM zone 36N (deprecated)",
    "code": 29636,
    "projection": "+proj=utm +zone=36 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Tananarive (Paris) / Laborde Grid (deprecated)",
    "code": 29700,
    "projection": "+proj=omerc +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9 +k=0.9995000000000001 +x_0=400000 +y_0=800000 +gamma=18.9 +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "Tananarive (Paris) / Laborde Grid approximation",
    "code": 29702,
    "projection": "+proj=omerc +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9 +k=0.9995000000000001 +x_0=400000 +y_0=800000 +gamma=18.9 +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +units=m +no_defs "
  },
  {
    "name": "Tananarive / UTM zone 38S",
    "code": 29738,
    "projection": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tananarive / UTM zone 39S",
    "code": 29739,
    "projection": "+proj=utm +zone=39 +south +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Timbalai 1948 / UTM zone 49N",
    "code": 29849,
    "projection": "+proj=utm +zone=49 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Timbalai 1948 / UTM zone 50N",
    "code": 29850,
    "projection": "+proj=utm +zone=50 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Timbalai 1948 / RSO Borneo (ch)",
    "code": 29871,
    "projection": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.8714630401 +y_0=442857.653094361 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=20.11676512155263 +no_defs "
  },
  {
    "name": "Timbalai 1948 / RSO Borneo (ftSe)",
    "code": 29872,
    "projection": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.8727431979 +y_0=442857.6545573985 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=0.3047994715386762 +no_defs "
  },
  {
    "name": "Timbalai 1948 / RSO Borneo (m)",
    "code": 29873,
    "projection": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.87 +y_0=442857.65 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "TM65 / Irish National Grid (deprecated)",
    "code": 29900,
    "projection": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +datum=ire65 +units=m +no_defs "
  },
  {
    "name": "OSNI 1952 / Irish National Grid",
    "code": 29901,
    "projection": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1 +x_0=200000 +y_0=250000 +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs "
  },
  {
    "name": "TM65 / Irish Grid",
    "code": 29902,
    "projection": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +datum=ire65 +units=m +no_defs "
  },
  {
    "name": "TM75 / Irish Grid",
    "code": 29903,
    "projection": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS I",
    "code": 30161,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS II",
    "code": 30162,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS III",
    "code": 30163,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS IV",
    "code": 30164,
    "projection": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS V",
    "code": 30165,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS VI",
    "code": 30166,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS VII",
    "code": 30167,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS VIII",
    "code": 30168,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS IX",
    "code": 30169,
    "projection": "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS X",
    "code": 30170,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XI",
    "code": 30171,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XII",
    "code": 30172,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XIII",
    "code": 30173,
    "projection": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XIV",
    "code": 30174,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XV",
    "code": 30175,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XVI",
    "code": 30176,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XVII",
    "code": 30177,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XVIII",
    "code": 30178,
    "projection": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Tokyo / Japan Plane Rectangular CS XIX",
    "code": 30179,
    "projection": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Trinidad 1903 / Trinidad Grid",
    "code": 30200,
    "projection": "+proj=cass +lat_0=10.44166666666667 +lon_0=-61.33333333333334 +x_0=86501.46392051999 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +to_meter=0.201166195164 +no_defs "
  },
  {
    "name": "TC(1948) / UTM zone 39N",
    "code": 30339,
    "projection": "+proj=utm +zone=39 +ellps=helmert +units=m +no_defs "
  },
  {
    "name": "TC(1948) / UTM zone 40N",
    "code": 30340,
    "projection": "+proj=utm +zone=40 +ellps=helmert +units=m +no_defs "
  },
  {
    "name": "Voirol 1875 / Nord Algerie (ancienne)",
    "code": 30491,
    "projection": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Voirol 1875 / Sud Algerie (ancienne)",
    "code": 30492,
    "projection": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Voirol 1879 / Nord Algerie (ancienne)",
    "code": 30493,
    "projection": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Voirol 1879 / Sud Algerie (ancienne)",
    "code": 30494,
    "projection": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / UTM zone 29N",
    "code": 30729,
    "projection": "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / UTM zone 30N",
    "code": 30730,
    "projection": "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / UTM zone 31N",
    "code": 30731,
    "projection": "+proj=utm +zone=31 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / UTM zone 32N",
    "code": 30732,
    "projection": "+proj=utm +zone=32 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / Nord Algerie",
    "code": 30791,
    "projection": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "Nord Sahara 1959 / Sud Algerie",
    "code": 30792,
    "projection": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs "
  },
  {
    "name": "RT38 2.5 gon W (deprecated)",
    "code": 30800,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "Yoff / UTM zone 28N",
    "code": 31028,
    "projection": "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-30,190,89,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Zanderij / UTM zone 21N",
    "code": 31121,
    "projection": "+proj=utm +zone=21 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Zanderij / TM 54 NW",
    "code": 31154,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-54 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Zanderij / Suriname Old TM",
    "code": 31170,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Zanderij / Suriname TM",
    "code": 31171,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k=0.9999 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria GK West Zone",
    "code": 31251,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria GK Central Zone",
    "code": 31252,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria GK East Zone",
    "code": 31253,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK West",
    "code": 31254,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK Central",
    "code": 31255,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK East",
    "code": 31256,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK M28",
    "code": 31257,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK M31",
    "code": 31258,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / Austria GK M34",
    "code": 31259,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI / 3-degree Gauss zone 5 (deprecated)",
    "code": 31265,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / 3-degree Gauss zone 6 (deprecated)",
    "code": 31266,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / 3-degree Gauss zone 7 (deprecated)",
    "code": 31267,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / 3-degree Gauss zone 8 (deprecated)",
    "code": 31268,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Balkans zone 5 (deprecated)",
    "code": 31275,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Balkans zone 6 (deprecated)",
    "code": 31276,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Balkans zone 7 (deprecated)",
    "code": 31277,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Balkans zone 8 (deprecated)",
    "code": 31278,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Balkans zone 8 (deprecated)",
    "code": 31279,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria West Zone",
    "code": 31281,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria Central Zone",
    "code": 31282,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria East Zone",
    "code": 31283,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI / Austria M28",
    "code": 31284,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Austria M31",
    "code": 31285,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Austria M34",
    "code": 31286,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Austria Lambert",
    "code": 31287,
    "projection": "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / M28",
    "code": 31288,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / M31",
    "code": 31289,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / M34",
    "code": 31290,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria West Zone (deprecated)",
    "code": 31291,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria Central Zone (deprecated)",
    "code": 31292,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI (Ferro) / Austria East Zone (deprecated)",
    "code": 31293,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs "
  },
  {
    "name": "MGI / M28 (deprecated)",
    "code": 31294,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / M31 (deprecated)",
    "code": 31295,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / M34 (deprecated)",
    "code": 31296,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=0 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "MGI / Austria Lambert (deprecated)",
    "code": 31297,
    "projection": "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +datum=hermannskogel +units=m +no_defs "
  },
  {
    "name": "Belge 1972 / Belge Lambert 72",
    "code": 31300,
    "projection": "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=90 +lon_0=4.356939722222222 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs "
  },
  {
    "name": "Belge 1972 / Belgian Lambert 72",
    "code": 31370,
    "projection": "+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss zone 1 (deprecated)",
    "code": 31461,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss zone 2 (deprecated)",
    "code": 31462,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss zone 3 (deprecated)",
    "code": 31463,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss zone 4 (deprecated)",
    "code": 31464,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss zone 5 (deprecated)",
    "code": 31465,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 2",
    "code": 31466,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 3",
    "code": 31467,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 4",
    "code": 31468,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "DHDN / 3-degree Gauss-Kruger zone 5",
    "code": 31469,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs "
  },
  {
    "name": "Conakry 1905 / UTM zone 28N",
    "code": 31528,
    "projection": "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Conakry 1905 / UTM zone 29N",
    "code": 31529,
    "projection": "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Dealul Piscului 1930 / Stereo 33",
    "code": 31600,
    "projection": "+proj=sterea +lat_0=45.9 +lon_0=25.39246588888889 +k=0.9996667 +x_0=500000 +y_0=500000 +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "Dealul Piscului 1970/ Stereo 70 (deprecated)",
    "code": 31700,
    "projection": "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=28,-121,-77,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NGN / UTM zone 38N",
    "code": 31838,
    "projection": "+proj=utm +zone=38 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NGN / UTM zone 39N",
    "code": 31839,
    "projection": "+proj=utm +zone=39 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "KUDAMS / KTM (deprecated)",
    "code": 31900,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "KUDAMS / KTM",
    "code": 31901,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 11N",
    "code": 31965,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 12N",
    "code": 31966,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 13N",
    "code": 31967,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 14N",
    "code": 31968,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 15N",
    "code": 31969,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 16N",
    "code": 31970,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 17N",
    "code": 31971,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 18N",
    "code": 31972,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 19N",
    "code": 31973,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 20N",
    "code": 31974,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 21N",
    "code": 31975,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 22N",
    "code": 31976,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 17S",
    "code": 31977,
    "projection": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 18S",
    "code": 31978,
    "projection": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 19S",
    "code": 31979,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 20S",
    "code": 31980,
    "projection": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 21S",
    "code": 31981,
    "projection": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 22S",
    "code": 31982,
    "projection": "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 23S",
    "code": 31983,
    "projection": "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 24S",
    "code": 31984,
    "projection": "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000 / UTM zone 25S",
    "code": 31985,
    "projection": "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 17N",
    "code": 31986,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 18N",
    "code": 31987,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 19N",
    "code": 31988,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 20N",
    "code": 31989,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 21N",
    "code": 31990,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 22N",
    "code": 31991,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 17S",
    "code": 31992,
    "projection": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 18S",
    "code": 31993,
    "projection": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 19S",
    "code": 31994,
    "projection": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 20S",
    "code": 31995,
    "projection": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 21S",
    "code": 31996,
    "projection": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 22S",
    "code": 31997,
    "projection": "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 23S",
    "code": 31998,
    "projection": "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 24S",
    "code": 31999,
    "projection": "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995 / UTM zone 25S",
    "code": 32000,
    "projection": "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Montana North",
    "code": 32001,
    "projection": "+proj=lcc +lat_1=48.71666666666667 +lat_2=47.85 +lat_0=47 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Montana Central",
    "code": 32002,
    "projection": "+proj=lcc +lat_1=47.88333333333333 +lat_2=46.45 +lat_0=45.83333333333334 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Montana South",
    "code": 32003,
    "projection": "+proj=lcc +lat_1=46.4 +lat_2=44.86666666666667 +lat_0=44 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Nebraska North",
    "code": 32005,
    "projection": "+proj=lcc +lat_1=41.85 +lat_2=42.81666666666667 +lat_0=41.33333333333334 +lon_0=-100 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Nebraska South",
    "code": 32006,
    "projection": "+proj=lcc +lat_1=40.28333333333333 +lat_2=41.71666666666667 +lat_0=39.66666666666666 +lon_0=-99.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Nevada East",
    "code": 32007,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Nevada Central",
    "code": 32008,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Nevada West",
    "code": 32009,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New Hampshire",
    "code": 32010,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New Jersey",
    "code": 32011,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.66666666666667 +k=0.9999749999999999 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New Mexico East",
    "code": 32012,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New Mexico Central",
    "code": 32013,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New Mexico West",
    "code": 32014,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New York East",
    "code": 32015,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-74.33333333333333 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New York Central",
    "code": 32016,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New York West",
    "code": 32017,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / New York Long Island (deprecated)",
    "code": 32018,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.5 +lon_0=-74 +x_0=304800.6096012192 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / North Carolina",
    "code": 32019,
    "projection": "+proj=lcc +lat_1=34.33333333333334 +lat_2=36.16666666666666 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / North Dakota North",
    "code": 32020,
    "projection": "+proj=lcc +lat_1=47.43333333333333 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-100.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / North Dakota South",
    "code": 32021,
    "projection": "+proj=lcc +lat_1=46.18333333333333 +lat_2=47.48333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Ohio North",
    "code": 32022,
    "projection": "+proj=lcc +lat_1=40.43333333333333 +lat_2=41.7 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Ohio South",
    "code": 32023,
    "projection": "+proj=lcc +lat_1=38.73333333333333 +lat_2=40.03333333333333 +lat_0=38 +lon_0=-82.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Oklahoma North",
    "code": 32024,
    "projection": "+proj=lcc +lat_1=35.56666666666667 +lat_2=36.76666666666667 +lat_0=35 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Oklahoma South",
    "code": 32025,
    "projection": "+proj=lcc +lat_1=33.93333333333333 +lat_2=35.23333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Oregon North",
    "code": 32026,
    "projection": "+proj=lcc +lat_1=44.33333333333334 +lat_2=46 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Oregon South",
    "code": 32027,
    "projection": "+proj=lcc +lat_1=42.33333333333334 +lat_2=44 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Pennsylvania North",
    "code": 32028,
    "projection": "+proj=lcc +lat_1=40.88333333333333 +lat_2=41.95 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Pennsylvania South (deprecated)",
    "code": 32029,
    "projection": "+proj=lcc +lat_1=39.93333333333333 +lat_2=40.8 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Rhode Island",
    "code": 32030,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.9999938 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / South Carolina North",
    "code": 32031,
    "projection": "+proj=lcc +lat_1=33.76666666666667 +lat_2=34.96666666666667 +lat_0=33 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / South Carolina South",
    "code": 32033,
    "projection": "+proj=lcc +lat_1=32.33333333333334 +lat_2=33.66666666666666 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / South Dakota North",
    "code": 32034,
    "projection": "+proj=lcc +lat_1=44.41666666666666 +lat_2=45.68333333333333 +lat_0=43.83333333333334 +lon_0=-100 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / South Dakota South",
    "code": 32035,
    "projection": "+proj=lcc +lat_1=42.83333333333334 +lat_2=44.4 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Tennessee (deprecated)",
    "code": 32036,
    "projection": "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666 +lon_0=-86 +x_0=30480.06096012192 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas North",
    "code": 32037,
    "projection": "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas North Central",
    "code": 32038,
    "projection": "+proj=lcc +lat_1=32.13333333333333 +lat_2=33.96666666666667 +lat_0=31.66666666666667 +lon_0=-97.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas Central",
    "code": 32039,
    "projection": "+proj=lcc +lat_1=30.11666666666667 +lat_2=31.88333333333333 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas South Central",
    "code": 32040,
    "projection": "+proj=lcc +lat_1=28.38333333333333 +lat_2=30.28333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas South",
    "code": 32041,
    "projection": "+proj=lcc +lat_1=26.16666666666667 +lat_2=27.83333333333333 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Utah North",
    "code": 32042,
    "projection": "+proj=lcc +lat_1=40.71666666666667 +lat_2=41.78333333333333 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Utah Central",
    "code": 32043,
    "projection": "+proj=lcc +lat_1=39.01666666666667 +lat_2=40.65 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Utah South",
    "code": 32044,
    "projection": "+proj=lcc +lat_1=37.21666666666667 +lat_2=38.35 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Vermont",
    "code": 32045,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Virginia North",
    "code": 32046,
    "projection": "+proj=lcc +lat_1=38.03333333333333 +lat_2=39.2 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Virginia South",
    "code": 32047,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=37.96666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Washington North",
    "code": 32048,
    "projection": "+proj=lcc +lat_1=47.5 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-120.8333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Washington South",
    "code": 32049,
    "projection": "+proj=lcc +lat_1=45.83333333333334 +lat_2=47.33333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / West Virginia North",
    "code": 32050,
    "projection": "+proj=lcc +lat_1=39 +lat_2=40.25 +lat_0=38.5 +lon_0=-79.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / West Virginia South",
    "code": 32051,
    "projection": "+proj=lcc +lat_1=37.48333333333333 +lat_2=38.88333333333333 +lat_0=37 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wisconsin North",
    "code": 32052,
    "projection": "+proj=lcc +lat_1=45.56666666666667 +lat_2=46.76666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wisconsin Central",
    "code": 32053,
    "projection": "+proj=lcc +lat_1=44.25 +lat_2=45.5 +lat_0=43.83333333333334 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wisconsin South",
    "code": 32054,
    "projection": "+proj=lcc +lat_1=42.73333333333333 +lat_2=44.06666666666667 +lat_0=42 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wyoming East",
    "code": 32055,
    "projection": "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-105.1666666666667 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wyoming East Central",
    "code": 32056,
    "projection": "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-107.3333333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wyoming West Central",
    "code": 32057,
    "projection": "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-108.75 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Wyoming West",
    "code": 32058,
    "projection": "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-110.0833333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Guatemala Norte (deprecated)",
    "code": 32061,
    "projection": "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Guatemala Sur (deprecated)",
    "code": 32062,
    "projection": "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / BLM 14N (ftUS)",
    "code": 32064,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 15N (ftUS)",
    "code": 32065,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 16N (ftUS)",
    "code": 32066,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 17N (ftUS)",
    "code": 32067,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 14N (feet) (deprecated)",
    "code": 32074,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 15N (feet) (deprecated)",
    "code": 32075,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 16N (feet) (deprecated)",
    "code": 32076,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / BLM 17N (feet) (deprecated)",
    "code": 32077,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 1",
    "code": 32081,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 2",
    "code": 32082,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 3",
    "code": 32083,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 4",
    "code": 32084,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 5",
    "code": 32085,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / MTM zone 6",
    "code": 32086,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Quebec Lambert",
    "code": 32098,
    "projection": "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs "
  },
  {
    "name": "NAD27 / Louisiana Offshore",
    "code": 32099,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-91.33333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / Montana",
    "code": 32100,
    "projection": "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Nebraska",
    "code": 32104,
    "projection": "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Nevada East",
    "code": 32107,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Nevada Central",
    "code": 32108,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Nevada West",
    "code": 32109,
    "projection": "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New Hampshire",
    "code": 32110,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New Jersey",
    "code": 32111,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New Mexico East",
    "code": 32112,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New Mexico Central",
    "code": 32113,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New Mexico West",
    "code": 32114,
    "projection": "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New York East",
    "code": 32115,
    "projection": "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New York Central",
    "code": 32116,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New York West",
    "code": 32117,
    "projection": "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / New York Long Island",
    "code": 32118,
    "projection": "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / North Carolina",
    "code": 32119,
    "projection": "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / North Dakota North",
    "code": 32120,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / North Dakota South",
    "code": 32121,
    "projection": "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Ohio North",
    "code": 32122,
    "projection": "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Ohio South",
    "code": 32123,
    "projection": "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oklahoma North",
    "code": 32124,
    "projection": "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oklahoma South",
    "code": 32125,
    "projection": "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oregon North",
    "code": 32126,
    "projection": "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Oregon South",
    "code": 32127,
    "projection": "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Pennsylvania North",
    "code": 32128,
    "projection": "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Pennsylvania South",
    "code": 32129,
    "projection": "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Rhode Island",
    "code": 32130,
    "projection": "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / South Carolina",
    "code": 32133,
    "projection": "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / South Dakota North",
    "code": 32134,
    "projection": "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / South Dakota South",
    "code": 32135,
    "projection": "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Tennessee",
    "code": 32136,
    "projection": "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas North",
    "code": 32137,
    "projection": "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas North Central",
    "code": 32138,
    "projection": "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas Central",
    "code": 32139,
    "projection": "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas South Central",
    "code": 32140,
    "projection": "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Texas South",
    "code": 32141,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Utah North",
    "code": 32142,
    "projection": "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Utah Central",
    "code": 32143,
    "projection": "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Utah South",
    "code": 32144,
    "projection": "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Vermont",
    "code": 32145,
    "projection": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Virginia North",
    "code": 32146,
    "projection": "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Virginia South",
    "code": 32147,
    "projection": "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Washington North",
    "code": 32148,
    "projection": "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Washington South",
    "code": 32149,
    "projection": "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / West Virginia North",
    "code": 32150,
    "projection": "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / West Virginia South",
    "code": 32151,
    "projection": "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin North",
    "code": 32152,
    "projection": "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin Central",
    "code": 32153,
    "projection": "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wisconsin South",
    "code": 32154,
    "projection": "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wyoming East",
    "code": 32155,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wyoming East Central",
    "code": 32156,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wyoming West Central",
    "code": 32157,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Wyoming West",
    "code": 32158,
    "projection": "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Puerto Rico & Virgin Is.",
    "code": 32161,
    "projection": "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / BLM 14N (ftUS)",
    "code": 32164,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 15N (ftUS)",
    "code": 32165,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 16N (ftUS)",
    "code": 32166,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / BLM 17N (ftUS)",
    "code": 32167,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs "
  },
  {
    "name": "NAD83 / SCoPQ zone 2 (deprecated)",
    "code": 32180,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 1",
    "code": 32181,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 2",
    "code": 32182,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 3",
    "code": 32183,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 4",
    "code": 32184,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 5",
    "code": 32185,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 6",
    "code": 32186,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 7",
    "code": 32187,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 8",
    "code": 32188,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 9",
    "code": 32189,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 10",
    "code": 32190,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 11",
    "code": 32191,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 12",
    "code": 32192,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 13",
    "code": 32193,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 14",
    "code": 32194,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 15",
    "code": 32195,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 16",
    "code": 32196,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / MTM zone 17",
    "code": 32197,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Quebec Lambert",
    "code": 32198,
    "projection": "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "NAD83 / Louisiana Offshore",
    "code": 32199,
    "projection": "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 1N",
    "code": 32201,
    "projection": "+proj=utm +zone=1 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 2N",
    "code": 32202,
    "projection": "+proj=utm +zone=2 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 3N",
    "code": 32203,
    "projection": "+proj=utm +zone=3 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 4N",
    "code": 32204,
    "projection": "+proj=utm +zone=4 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 5N",
    "code": 32205,
    "projection": "+proj=utm +zone=5 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 6N",
    "code": 32206,
    "projection": "+proj=utm +zone=6 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 7N",
    "code": 32207,
    "projection": "+proj=utm +zone=7 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 8N",
    "code": 32208,
    "projection": "+proj=utm +zone=8 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 9N",
    "code": 32209,
    "projection": "+proj=utm +zone=9 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 10N",
    "code": 32210,
    "projection": "+proj=utm +zone=10 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 11N",
    "code": 32211,
    "projection": "+proj=utm +zone=11 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 12N",
    "code": 32212,
    "projection": "+proj=utm +zone=12 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 13N",
    "code": 32213,
    "projection": "+proj=utm +zone=13 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 14N",
    "code": 32214,
    "projection": "+proj=utm +zone=14 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 15N",
    "code": 32215,
    "projection": "+proj=utm +zone=15 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 16N",
    "code": 32216,
    "projection": "+proj=utm +zone=16 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 17N",
    "code": 32217,
    "projection": "+proj=utm +zone=17 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 18N",
    "code": 32218,
    "projection": "+proj=utm +zone=18 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 19N",
    "code": 32219,
    "projection": "+proj=utm +zone=19 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 20N",
    "code": 32220,
    "projection": "+proj=utm +zone=20 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 21N",
    "code": 32221,
    "projection": "+proj=utm +zone=21 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 22N",
    "code": 32222,
    "projection": "+proj=utm +zone=22 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 23N",
    "code": 32223,
    "projection": "+proj=utm +zone=23 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 24N",
    "code": 32224,
    "projection": "+proj=utm +zone=24 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 25N",
    "code": 32225,
    "projection": "+proj=utm +zone=25 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 26N",
    "code": 32226,
    "projection": "+proj=utm +zone=26 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 27N",
    "code": 32227,
    "projection": "+proj=utm +zone=27 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 28N",
    "code": 32228,
    "projection": "+proj=utm +zone=28 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 29N",
    "code": 32229,
    "projection": "+proj=utm +zone=29 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 30N",
    "code": 32230,
    "projection": "+proj=utm +zone=30 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 31N",
    "code": 32231,
    "projection": "+proj=utm +zone=31 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 32N",
    "code": 32232,
    "projection": "+proj=utm +zone=32 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 33N",
    "code": 32233,
    "projection": "+proj=utm +zone=33 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 34N",
    "code": 32234,
    "projection": "+proj=utm +zone=34 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 35N",
    "code": 32235,
    "projection": "+proj=utm +zone=35 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 36N",
    "code": 32236,
    "projection": "+proj=utm +zone=36 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 37N",
    "code": 32237,
    "projection": "+proj=utm +zone=37 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 38N",
    "code": 32238,
    "projection": "+proj=utm +zone=38 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 39N",
    "code": 32239,
    "projection": "+proj=utm +zone=39 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 40N",
    "code": 32240,
    "projection": "+proj=utm +zone=40 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 41N",
    "code": 32241,
    "projection": "+proj=utm +zone=41 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 42N",
    "code": 32242,
    "projection": "+proj=utm +zone=42 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 43N",
    "code": 32243,
    "projection": "+proj=utm +zone=43 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 44N",
    "code": 32244,
    "projection": "+proj=utm +zone=44 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 45N",
    "code": 32245,
    "projection": "+proj=utm +zone=45 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 46N",
    "code": 32246,
    "projection": "+proj=utm +zone=46 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 47N",
    "code": 32247,
    "projection": "+proj=utm +zone=47 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 48N",
    "code": 32248,
    "projection": "+proj=utm +zone=48 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 49N",
    "code": 32249,
    "projection": "+proj=utm +zone=49 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 50N",
    "code": 32250,
    "projection": "+proj=utm +zone=50 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 51N",
    "code": 32251,
    "projection": "+proj=utm +zone=51 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 52N",
    "code": 32252,
    "projection": "+proj=utm +zone=52 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 53N",
    "code": 32253,
    "projection": "+proj=utm +zone=53 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 54N",
    "code": 32254,
    "projection": "+proj=utm +zone=54 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 55N",
    "code": 32255,
    "projection": "+proj=utm +zone=55 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 56N",
    "code": 32256,
    "projection": "+proj=utm +zone=56 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 57N",
    "code": 32257,
    "projection": "+proj=utm +zone=57 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 58N",
    "code": 32258,
    "projection": "+proj=utm +zone=58 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 59N",
    "code": 32259,
    "projection": "+proj=utm +zone=59 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 60N",
    "code": 32260,
    "projection": "+proj=utm +zone=60 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 1S",
    "code": 32301,
    "projection": "+proj=utm +zone=1 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 2S",
    "code": 32302,
    "projection": "+proj=utm +zone=2 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 3S",
    "code": 32303,
    "projection": "+proj=utm +zone=3 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 4S",
    "code": 32304,
    "projection": "+proj=utm +zone=4 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 5S",
    "code": 32305,
    "projection": "+proj=utm +zone=5 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 6S",
    "code": 32306,
    "projection": "+proj=utm +zone=6 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 7S",
    "code": 32307,
    "projection": "+proj=utm +zone=7 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 8S",
    "code": 32308,
    "projection": "+proj=utm +zone=8 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 9S",
    "code": 32309,
    "projection": "+proj=utm +zone=9 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 10S",
    "code": 32310,
    "projection": "+proj=utm +zone=10 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 11S",
    "code": 32311,
    "projection": "+proj=utm +zone=11 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 12S",
    "code": 32312,
    "projection": "+proj=utm +zone=12 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 13S",
    "code": 32313,
    "projection": "+proj=utm +zone=13 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 14S",
    "code": 32314,
    "projection": "+proj=utm +zone=14 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 15S",
    "code": 32315,
    "projection": "+proj=utm +zone=15 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 16S",
    "code": 32316,
    "projection": "+proj=utm +zone=16 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 17S",
    "code": 32317,
    "projection": "+proj=utm +zone=17 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 18S",
    "code": 32318,
    "projection": "+proj=utm +zone=18 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 19S",
    "code": 32319,
    "projection": "+proj=utm +zone=19 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 20S",
    "code": 32320,
    "projection": "+proj=utm +zone=20 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 21S",
    "code": 32321,
    "projection": "+proj=utm +zone=21 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 22S",
    "code": 32322,
    "projection": "+proj=utm +zone=22 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 23S",
    "code": 32323,
    "projection": "+proj=utm +zone=23 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 24S",
    "code": 32324,
    "projection": "+proj=utm +zone=24 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 25S",
    "code": 32325,
    "projection": "+proj=utm +zone=25 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 26S",
    "code": 32326,
    "projection": "+proj=utm +zone=26 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 27S",
    "code": 32327,
    "projection": "+proj=utm +zone=27 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 28S",
    "code": 32328,
    "projection": "+proj=utm +zone=28 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 29S",
    "code": 32329,
    "projection": "+proj=utm +zone=29 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 30S",
    "code": 32330,
    "projection": "+proj=utm +zone=30 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 31S",
    "code": 32331,
    "projection": "+proj=utm +zone=31 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 32S",
    "code": 32332,
    "projection": "+proj=utm +zone=32 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 33S",
    "code": 32333,
    "projection": "+proj=utm +zone=33 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 34S",
    "code": 32334,
    "projection": "+proj=utm +zone=34 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 35S",
    "code": 32335,
    "projection": "+proj=utm +zone=35 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 36S",
    "code": 32336,
    "projection": "+proj=utm +zone=36 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 37S",
    "code": 32337,
    "projection": "+proj=utm +zone=37 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 38S",
    "code": 32338,
    "projection": "+proj=utm +zone=38 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 39S",
    "code": 32339,
    "projection": "+proj=utm +zone=39 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 40S",
    "code": 32340,
    "projection": "+proj=utm +zone=40 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 41S",
    "code": 32341,
    "projection": "+proj=utm +zone=41 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 42S",
    "code": 32342,
    "projection": "+proj=utm +zone=42 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 43S",
    "code": 32343,
    "projection": "+proj=utm +zone=43 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 44S",
    "code": 32344,
    "projection": "+proj=utm +zone=44 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 45S",
    "code": 32345,
    "projection": "+proj=utm +zone=45 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 46S",
    "code": 32346,
    "projection": "+proj=utm +zone=46 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 47S",
    "code": 32347,
    "projection": "+proj=utm +zone=47 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 48S",
    "code": 32348,
    "projection": "+proj=utm +zone=48 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 49S",
    "code": 32349,
    "projection": "+proj=utm +zone=49 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 50S",
    "code": 32350,
    "projection": "+proj=utm +zone=50 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 51S",
    "code": 32351,
    "projection": "+proj=utm +zone=51 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 52S",
    "code": 32352,
    "projection": "+proj=utm +zone=52 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 53S",
    "code": 32353,
    "projection": "+proj=utm +zone=53 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 54S",
    "code": 32354,
    "projection": "+proj=utm +zone=54 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 55S",
    "code": 32355,
    "projection": "+proj=utm +zone=55 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 56S",
    "code": 32356,
    "projection": "+proj=utm +zone=56 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 57S",
    "code": 32357,
    "projection": "+proj=utm +zone=57 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 58S",
    "code": 32358,
    "projection": "+proj=utm +zone=58 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 59S",
    "code": 32359,
    "projection": "+proj=utm +zone=59 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72 / UTM zone 60S",
    "code": 32360,
    "projection": "+proj=utm +zone=60 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 1N",
    "code": 32401,
    "projection": "+proj=utm +zone=1 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 2N",
    "code": 32402,
    "projection": "+proj=utm +zone=2 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 3N",
    "code": 32403,
    "projection": "+proj=utm +zone=3 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 4N",
    "code": 32404,
    "projection": "+proj=utm +zone=4 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 5N",
    "code": 32405,
    "projection": "+proj=utm +zone=5 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 6N",
    "code": 32406,
    "projection": "+proj=utm +zone=6 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 7N",
    "code": 32407,
    "projection": "+proj=utm +zone=7 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 8N",
    "code": 32408,
    "projection": "+proj=utm +zone=8 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 9N",
    "code": 32409,
    "projection": "+proj=utm +zone=9 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 10N",
    "code": 32410,
    "projection": "+proj=utm +zone=10 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 11N",
    "code": 32411,
    "projection": "+proj=utm +zone=11 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 12N",
    "code": 32412,
    "projection": "+proj=utm +zone=12 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 13N",
    "code": 32413,
    "projection": "+proj=utm +zone=13 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 14N",
    "code": 32414,
    "projection": "+proj=utm +zone=14 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 15N",
    "code": 32415,
    "projection": "+proj=utm +zone=15 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 16N",
    "code": 32416,
    "projection": "+proj=utm +zone=16 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 17N",
    "code": 32417,
    "projection": "+proj=utm +zone=17 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 18N",
    "code": 32418,
    "projection": "+proj=utm +zone=18 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 19N",
    "code": 32419,
    "projection": "+proj=utm +zone=19 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 20N",
    "code": 32420,
    "projection": "+proj=utm +zone=20 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 21N",
    "code": 32421,
    "projection": "+proj=utm +zone=21 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 22N",
    "code": 32422,
    "projection": "+proj=utm +zone=22 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 23N",
    "code": 32423,
    "projection": "+proj=utm +zone=23 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 24N",
    "code": 32424,
    "projection": "+proj=utm +zone=24 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 25N",
    "code": 32425,
    "projection": "+proj=utm +zone=25 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 26N",
    "code": 32426,
    "projection": "+proj=utm +zone=26 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 27N",
    "code": 32427,
    "projection": "+proj=utm +zone=27 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 28N",
    "code": 32428,
    "projection": "+proj=utm +zone=28 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 29N",
    "code": 32429,
    "projection": "+proj=utm +zone=29 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 30N",
    "code": 32430,
    "projection": "+proj=utm +zone=30 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 31N",
    "code": 32431,
    "projection": "+proj=utm +zone=31 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 32N",
    "code": 32432,
    "projection": "+proj=utm +zone=32 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 33N",
    "code": 32433,
    "projection": "+proj=utm +zone=33 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 34N",
    "code": 32434,
    "projection": "+proj=utm +zone=34 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 35N",
    "code": 32435,
    "projection": "+proj=utm +zone=35 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 36N",
    "code": 32436,
    "projection": "+proj=utm +zone=36 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 37N",
    "code": 32437,
    "projection": "+proj=utm +zone=37 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 38N",
    "code": 32438,
    "projection": "+proj=utm +zone=38 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 39N",
    "code": 32439,
    "projection": "+proj=utm +zone=39 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 40N",
    "code": 32440,
    "projection": "+proj=utm +zone=40 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 41N",
    "code": 32441,
    "projection": "+proj=utm +zone=41 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 42N",
    "code": 32442,
    "projection": "+proj=utm +zone=42 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 43N",
    "code": 32443,
    "projection": "+proj=utm +zone=43 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 44N",
    "code": 32444,
    "projection": "+proj=utm +zone=44 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 45N",
    "code": 32445,
    "projection": "+proj=utm +zone=45 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 46N",
    "code": 32446,
    "projection": "+proj=utm +zone=46 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 47N",
    "code": 32447,
    "projection": "+proj=utm +zone=47 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 48N",
    "code": 32448,
    "projection": "+proj=utm +zone=48 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 49N",
    "code": 32449,
    "projection": "+proj=utm +zone=49 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 50N",
    "code": 32450,
    "projection": "+proj=utm +zone=50 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 51N",
    "code": 32451,
    "projection": "+proj=utm +zone=51 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 52N",
    "code": 32452,
    "projection": "+proj=utm +zone=52 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 53N",
    "code": 32453,
    "projection": "+proj=utm +zone=53 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 54N",
    "code": 32454,
    "projection": "+proj=utm +zone=54 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 55N",
    "code": 32455,
    "projection": "+proj=utm +zone=55 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 56N",
    "code": 32456,
    "projection": "+proj=utm +zone=56 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 57N",
    "code": 32457,
    "projection": "+proj=utm +zone=57 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 58N",
    "code": 32458,
    "projection": "+proj=utm +zone=58 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 59N",
    "code": 32459,
    "projection": "+proj=utm +zone=59 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 60N",
    "code": 32460,
    "projection": "+proj=utm +zone=60 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 1S",
    "code": 32501,
    "projection": "+proj=utm +zone=1 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 2S",
    "code": 32502,
    "projection": "+proj=utm +zone=2 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 3S",
    "code": 32503,
    "projection": "+proj=utm +zone=3 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 4S",
    "code": 32504,
    "projection": "+proj=utm +zone=4 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 5S",
    "code": 32505,
    "projection": "+proj=utm +zone=5 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 6S",
    "code": 32506,
    "projection": "+proj=utm +zone=6 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 7S",
    "code": 32507,
    "projection": "+proj=utm +zone=7 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 8S",
    "code": 32508,
    "projection": "+proj=utm +zone=8 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 9S",
    "code": 32509,
    "projection": "+proj=utm +zone=9 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 10S",
    "code": 32510,
    "projection": "+proj=utm +zone=10 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 11S",
    "code": 32511,
    "projection": "+proj=utm +zone=11 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 12S",
    "code": 32512,
    "projection": "+proj=utm +zone=12 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 13S",
    "code": 32513,
    "projection": "+proj=utm +zone=13 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 14S",
    "code": 32514,
    "projection": "+proj=utm +zone=14 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 15S",
    "code": 32515,
    "projection": "+proj=utm +zone=15 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 16S",
    "code": 32516,
    "projection": "+proj=utm +zone=16 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 17S",
    "code": 32517,
    "projection": "+proj=utm +zone=17 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 18S",
    "code": 32518,
    "projection": "+proj=utm +zone=18 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 19S",
    "code": 32519,
    "projection": "+proj=utm +zone=19 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 20S",
    "code": 32520,
    "projection": "+proj=utm +zone=20 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 21S",
    "code": 32521,
    "projection": "+proj=utm +zone=21 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 22S",
    "code": 32522,
    "projection": "+proj=utm +zone=22 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 23S",
    "code": 32523,
    "projection": "+proj=utm +zone=23 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 24S",
    "code": 32524,
    "projection": "+proj=utm +zone=24 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 25S",
    "code": 32525,
    "projection": "+proj=utm +zone=25 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 26S",
    "code": 32526,
    "projection": "+proj=utm +zone=26 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 27S",
    "code": 32527,
    "projection": "+proj=utm +zone=27 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 28S",
    "code": 32528,
    "projection": "+proj=utm +zone=28 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 29S",
    "code": 32529,
    "projection": "+proj=utm +zone=29 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 30S",
    "code": 32530,
    "projection": "+proj=utm +zone=30 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 31S",
    "code": 32531,
    "projection": "+proj=utm +zone=31 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 32S",
    "code": 32532,
    "projection": "+proj=utm +zone=32 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 33S",
    "code": 32533,
    "projection": "+proj=utm +zone=33 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 34S",
    "code": 32534,
    "projection": "+proj=utm +zone=34 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 35S",
    "code": 32535,
    "projection": "+proj=utm +zone=35 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 36S",
    "code": 32536,
    "projection": "+proj=utm +zone=36 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 37S",
    "code": 32537,
    "projection": "+proj=utm +zone=37 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 38S",
    "code": 32538,
    "projection": "+proj=utm +zone=38 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 39S",
    "code": 32539,
    "projection": "+proj=utm +zone=39 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 40S",
    "code": 32540,
    "projection": "+proj=utm +zone=40 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 41S",
    "code": 32541,
    "projection": "+proj=utm +zone=41 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 42S",
    "code": 32542,
    "projection": "+proj=utm +zone=42 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 43S",
    "code": 32543,
    "projection": "+proj=utm +zone=43 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 44S",
    "code": 32544,
    "projection": "+proj=utm +zone=44 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 45S",
    "code": 32545,
    "projection": "+proj=utm +zone=45 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 46S",
    "code": 32546,
    "projection": "+proj=utm +zone=46 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 47S",
    "code": 32547,
    "projection": "+proj=utm +zone=47 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 48S",
    "code": 32548,
    "projection": "+proj=utm +zone=48 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 49S",
    "code": 32549,
    "projection": "+proj=utm +zone=49 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 50S",
    "code": 32550,
    "projection": "+proj=utm +zone=50 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 51S",
    "code": 32551,
    "projection": "+proj=utm +zone=51 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 52S",
    "code": 32552,
    "projection": "+proj=utm +zone=52 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 53S",
    "code": 32553,
    "projection": "+proj=utm +zone=53 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 54S",
    "code": 32554,
    "projection": "+proj=utm +zone=54 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 55S",
    "code": 32555,
    "projection": "+proj=utm +zone=55 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 56S",
    "code": 32556,
    "projection": "+proj=utm +zone=56 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 57S",
    "code": 32557,
    "projection": "+proj=utm +zone=57 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 58S",
    "code": 32558,
    "projection": "+proj=utm +zone=58 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 59S",
    "code": 32559,
    "projection": "+proj=utm +zone=59 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE / UTM zone 60S",
    "code": 32560,
    "projection": "+proj=utm +zone=60 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 1N",
    "code": 32601,
    "projection": "+proj=utm +zone=1 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 2N",
    "code": 32602,
    "projection": "+proj=utm +zone=2 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 3N",
    "code": 32603,
    "projection": "+proj=utm +zone=3 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 4N",
    "code": 32604,
    "projection": "+proj=utm +zone=4 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 5N",
    "code": 32605,
    "projection": "+proj=utm +zone=5 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 6N",
    "code": 32606,
    "projection": "+proj=utm +zone=6 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 7N",
    "code": 32607,
    "projection": "+proj=utm +zone=7 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 8N",
    "code": 32608,
    "projection": "+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 9N",
    "code": 32609,
    "projection": "+proj=utm +zone=9 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 10N",
    "code": 32610,
    "projection": "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 11N",
    "code": 32611,
    "projection": "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 12N",
    "code": 32612,
    "projection": "+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 13N",
    "code": 32613,
    "projection": "+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 14N",
    "code": 32614,
    "projection": "+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 15N",
    "code": 32615,
    "projection": "+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 16N",
    "code": 32616,
    "projection": "+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 17N",
    "code": 32617,
    "projection": "+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 18N",
    "code": 32618,
    "projection": "+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 19N",
    "code": 32619,
    "projection": "+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 20N",
    "code": 32620,
    "projection": "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 21N",
    "code": 32621,
    "projection": "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 22N",
    "code": 32622,
    "projection": "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 23N",
    "code": 32623,
    "projection": "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 24N",
    "code": 32624,
    "projection": "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 25N",
    "code": 32625,
    "projection": "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 26N",
    "code": 32626,
    "projection": "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 27N",
    "code": 32627,
    "projection": "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 28N",
    "code": 32628,
    "projection": "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 29N",
    "code": 32629,
    "projection": "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 30N",
    "code": 32630,
    "projection": "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 31N",
    "code": 32631,
    "projection": "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 32N",
    "code": 32632,
    "projection": "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 33N",
    "code": 32633,
    "projection": "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 34N",
    "code": 32634,
    "projection": "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 35N",
    "code": 32635,
    "projection": "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 36N",
    "code": 32636,
    "projection": "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 37N",
    "code": 32637,
    "projection": "+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 38N",
    "code": 32638,
    "projection": "+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 39N",
    "code": 32639,
    "projection": "+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 40N",
    "code": 32640,
    "projection": "+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 41N",
    "code": 32641,
    "projection": "+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 42N",
    "code": 32642,
    "projection": "+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 43N",
    "code": 32643,
    "projection": "+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 44N",
    "code": 32644,
    "projection": "+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 45N",
    "code": 32645,
    "projection": "+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 46N",
    "code": 32646,
    "projection": "+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 47N",
    "code": 32647,
    "projection": "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 48N",
    "code": 32648,
    "projection": "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 49N",
    "code": 32649,
    "projection": "+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 50N",
    "code": 32650,
    "projection": "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 51N",
    "code": 32651,
    "projection": "+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 52N",
    "code": 32652,
    "projection": "+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 53N",
    "code": 32653,
    "projection": "+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 54N",
    "code": 32654,
    "projection": "+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 55N",
    "code": 32655,
    "projection": "+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 56N",
    "code": 32656,
    "projection": "+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 57N",
    "code": 32657,
    "projection": "+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 58N",
    "code": 32658,
    "projection": "+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 59N",
    "code": 32659,
    "projection": "+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 60N",
    "code": 32660,
    "projection": "+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UPS North (N,E)",
    "code": 32661,
    "projection": "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / Plate Carree (deprecated)",
    "code": 32662,
    "projection": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / World Equidistant Cylindrical (deprecated)",
    "code": 32663,
    "projection": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / BLM 14N (ftUS)",
    "code": 32664,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / BLM 15N (ftUS)",
    "code": 32665,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / BLM 16N (ftUS)",
    "code": 32666,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / BLM 17N (ftUS)",
    "code": 32667,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 1S",
    "code": 32701,
    "projection": "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 2S",
    "code": 32702,
    "projection": "+proj=utm +zone=2 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 3S",
    "code": 32703,
    "projection": "+proj=utm +zone=3 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 4S",
    "code": 32704,
    "projection": "+proj=utm +zone=4 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 5S",
    "code": 32705,
    "projection": "+proj=utm +zone=5 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 6S",
    "code": 32706,
    "projection": "+proj=utm +zone=6 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 7S",
    "code": 32707,
    "projection": "+proj=utm +zone=7 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 8S",
    "code": 32708,
    "projection": "+proj=utm +zone=8 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 9S",
    "code": 32709,
    "projection": "+proj=utm +zone=9 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 10S",
    "code": 32710,
    "projection": "+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 11S",
    "code": 32711,
    "projection": "+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 12S",
    "code": 32712,
    "projection": "+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 13S",
    "code": 32713,
    "projection": "+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 14S",
    "code": 32714,
    "projection": "+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 15S",
    "code": 32715,
    "projection": "+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 16S",
    "code": 32716,
    "projection": "+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 17S",
    "code": 32717,
    "projection": "+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 18S",
    "code": 32718,
    "projection": "+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 19S",
    "code": 32719,
    "projection": "+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 20S",
    "code": 32720,
    "projection": "+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 21S",
    "code": 32721,
    "projection": "+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 22S",
    "code": 32722,
    "projection": "+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 23S",
    "code": 32723,
    "projection": "+proj=utm +zone=23 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 24S",
    "code": 32724,
    "projection": "+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 25S",
    "code": 32725,
    "projection": "+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 26S",
    "code": 32726,
    "projection": "+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 27S",
    "code": 32727,
    "projection": "+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 28S",
    "code": 32728,
    "projection": "+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 29S",
    "code": 32729,
    "projection": "+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 30S",
    "code": 32730,
    "projection": "+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 31S",
    "code": 32731,
    "projection": "+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 32S",
    "code": 32732,
    "projection": "+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 33S",
    "code": 32733,
    "projection": "+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 34S",
    "code": 32734,
    "projection": "+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 35S",
    "code": 32735,
    "projection": "+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 36S",
    "code": 32736,
    "projection": "+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 37S",
    "code": 32737,
    "projection": "+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 38S",
    "code": 32738,
    "projection": "+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 39S",
    "code": 32739,
    "projection": "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 40S",
    "code": 32740,
    "projection": "+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 41S",
    "code": 32741,
    "projection": "+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 42S",
    "code": 32742,
    "projection": "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 43S",
    "code": 32743,
    "projection": "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 44S",
    "code": 32744,
    "projection": "+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 45S",
    "code": 32745,
    "projection": "+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 46S",
    "code": 32746,
    "projection": "+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 47S",
    "code": 32747,
    "projection": "+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 48S",
    "code": 32748,
    "projection": "+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 49S",
    "code": 32749,
    "projection": "+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 50S",
    "code": 32750,
    "projection": "+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 51S",
    "code": 32751,
    "projection": "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 52S",
    "code": 32752,
    "projection": "+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 53S",
    "code": 32753,
    "projection": "+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 54S",
    "code": 32754,
    "projection": "+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 55S",
    "code": 32755,
    "projection": "+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 56S",
    "code": 32756,
    "projection": "+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 57S",
    "code": 32757,
    "projection": "+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 58S",
    "code": 32758,
    "projection": "+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 59S",
    "code": 32759,
    "projection": "+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UTM zone 60S",
    "code": 32760,
    "projection": "+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / UPS South (N,E)",
    "code": 32761,
    "projection": "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 / TM 36 SE",
    "code": 32766,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "TWD97",
    "code": 3822,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IGRS",
    "code": 3887,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "MOLDREF99",
    "code": 4000,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGRDC 2005",
    "code": 4039,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SREF98",
    "code": 4073,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "REGCAN95",
    "code": 4079,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (geocentric)",
    "code": 4328,
    "projection": "+proj=geocent +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "ITRF88 (geocentric)",
    "code": 4330,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF89 (geocentric)",
    "code": 4331,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF90 (geocentric)",
    "code": 4332,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF91 (geocentric)",
    "code": 4333,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF92 (geocentric)",
    "code": 4334,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF93 (geocentric)",
    "code": 4335,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF94 (geocentric)",
    "code": 4336,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF96 (geocentric)",
    "code": 4337,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF97 (geocentric)",
    "code": 4338,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Australian Antarctic (geocentric)",
    "code": 4340,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "EST97 (geocentric)",
    "code": 4342,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CHTRF95 (geocentric)",
    "code": 4344,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ETRS89 (geocentric)",
    "code": 4346,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA94 (geocentric)",
    "code": 4348,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94 (geocentric)",
    "code": 4350,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "IRENET95 (geocentric)",
    "code": 4352,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2000 (geocentric)",
    "code": 4354,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "LKS94 (ETRS89) (geocentric)",
    "code": 4356,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Moznet (geocentric)",
    "code": 4358,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) (geocentric)",
    "code": 4360,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN) (geocentric)",
    "code": 4362,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NZGD2000 (geocentric)",
    "code": 4364,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98 (geocentric)",
    "code": 4366,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "REGVEN (geocentric)",
    "code": 4368,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGF93 (geocentric)",
    "code": 4370,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGFG95 (geocentric)",
    "code": 4372,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGR92 (geocentric)",
    "code": 4374,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SIRGAS (geocentric)",
    "code": 4376,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SWEREF99 (geocentric)",
    "code": 4378,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96 (geocentric)",
    "code": 4380,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "RGNC 1991 (geocentric)",
    "code": 4382,
    "projection": "+proj=geocent +ellps=intl +units=m +no_defs "
  },
  {
    "name": "RRAF 1991 (geocentric)",
    "code": 4384,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "ITRF2000 (geocentric)",
    "code": 4385,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ISN93 (geocentric)",
    "code": 4387,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "LKS92 (geocentric)",
    "code": 4389,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGSPM06",
    "code": 4465,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGM04",
    "code": 4468,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Cadastre 1997",
    "code": 4473,
    "projection": "+proj=geocent +ellps=intl +units=m +no_defs "
  },
  {
    "name": "China Geodetic Coordinate System 2000",
    "code": 4479,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF92",
    "code": 4481,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RRAF 1991",
    "code": 4556,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Slovenia 1996",
    "code": 4882,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RSRGD2000",
    "code": 4884,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BDA2000",
    "code": 4886,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "HTRS96",
    "code": 4888,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 66",
    "code": 4890,
    "projection": "+proj=geocent +ellps=WGS66 +units=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007)",
    "code": 4892,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JAD2001",
    "code": 4894,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "ITRF2005",
    "code": 4896,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "DGN95",
    "code": 4897,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "LGD2006",
    "code": 4899,
    "projection": "+proj=geocent +ellps=intl +units=m +no_defs "
  },
  {
    "name": "RGNC91-93",
    "code": 4906,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GR96",
    "code": 4908,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF88",
    "code": 4910,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF89",
    "code": 4911,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF90",
    "code": 4912,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF91",
    "code": 4913,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF92",
    "code": 4914,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF93",
    "code": 4915,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF94",
    "code": 4916,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF96",
    "code": 4917,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF97",
    "code": 4918,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF2000",
    "code": 4919,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDM2000",
    "code": 4920,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "PZ-90",
    "code": 4922,
    "projection": "+proj=geocent +a=6378136 +b=6356751.361745712 +units=m +no_defs "
  },
  {
    "name": "Mauritania 1999",
    "code": 4924,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Korea 2000",
    "code": 4926,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "POSGAR 94",
    "code": 4928,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "Australian Antarctic",
    "code": 4930,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CHTRF95",
    "code": 4932,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "EST97",
    "code": 4934,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ETRS89",
    "code": 4936,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDA94",
    "code": 4938,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Hartebeesthoek94",
    "code": 4940,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "IRENET95",
    "code": 4942,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ISN93",
    "code": 4944,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2000",
    "code": 4946,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "LKS92",
    "code": 4948,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "LKS94",
    "code": 4950,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Moznet",
    "code": 4952,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83(CSRS)",
    "code": 4954,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(HARN)",
    "code": 4956,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NZGD2000",
    "code": 4958,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "POSGAR 98",
    "code": 4960,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "REGVEN",
    "code": 4962,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGF93",
    "code": 4964,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGFG95",
    "code": 4966,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGNC 1991",
    "code": 4968,
    "projection": "+proj=geocent +ellps=intl +units=m +no_defs "
  },
  {
    "name": "RGR92",
    "code": 4970,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RRAF 1991",
    "code": 4972,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 1995",
    "code": 4974,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SWEREF99",
    "code": 4976,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84",
    "code": 4978,
    "projection": "+proj=geocent +datum=WGS84 +units=m +no_defs "
  },
  {
    "name": "Yemen NGN96",
    "code": 4980,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "IGM95",
    "code": 4982,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 72",
    "code": 4984,
    "projection": "+proj=geocent +ellps=WGS72 +units=m +no_defs "
  },
  {
    "name": "WGS 72BE",
    "code": 4986,
    "projection": "+proj=geocent +ellps=WGS72 +units=m +no_defs "
  },
  {
    "name": "SIRGAS 2000",
    "code": 4988,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Lao 1993",
    "code": 4990,
    "projection": "+proj=geocent +ellps=krass +units=m +no_defs "
  },
  {
    "name": "Lao 1997",
    "code": 4992,
    "projection": "+proj=geocent +ellps=krass +units=m +no_defs "
  },
  {
    "name": "PRS92",
    "code": 4994,
    "projection": "+proj=geocent +ellps=clrk66 +units=m +no_defs "
  },
  {
    "name": "MAGNA-SIRGAS",
    "code": 4996,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGPF",
    "code": 4998,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "PTRA08",
    "code": 5011,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "GDBD2009",
    "code": 5244,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "TUREF",
    "code": 5250,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "DRUKREF 03",
    "code": 5262,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ISN2004",
    "code": 5322,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF2008",
    "code": 5332,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "POSGAR 2007",
    "code": 5341,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "MARGEN",
    "code": 5352,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-Chile",
    "code": 5358,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CR05",
    "code": 5363,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "MACARIO SOLIS",
    "code": 5368,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Peru96",
    "code": 5369,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "SIRGAS-ROU98",
    "code": 5379,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "SIRGAS_ES2007.8",
    "code": 5391,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGAF09",
    "code": 5487,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "PNG94",
    "code": 5544,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "UCS-2000",
    "code": 5558,
    "projection": "+proj=geocent +ellps=krass +units=m +no_defs "
  },
  {
    "name": "FEH2010",
    "code": 5591,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "DB_REF",
    "code": 5828,
    "projection": "+proj=geocent +ellps=bessel +units=m +no_defs "
  },
  {
    "name": "TGD2005",
    "code": 5884,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CIGD11",
    "code": 6133,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "CGRS93",
    "code": 6309,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "NAD83(2011)",
    "code": 6317,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(PA11)",
    "code": 6320,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(MA11)",
    "code": 6323,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "Mexico ITRF2008",
    "code": 6363,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "JGD2011",
    "code": 6666,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RDN2008",
    "code": 6704,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "NAD83(CORS96)",
    "code": 6781,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IGS08",
    "code": 6934,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IGD05",
    "code": 6978,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IG05 Intermediate CRS",
    "code": 6981,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IGD05/12",
    "code": 6985,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IG05/12 Intermediate CRS",
    "code": 6988,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "RGTAAF07",
    "code": 7071,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "IGD05",
    "code": 7134,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "IGD05/12",
    "code": 7137,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "ONGD14",
    "code": 7371,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (G730)",
    "code": 7656,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (G873)",
    "code": 7658,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (G1150)",
    "code": 7660,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (G1674)",
    "code": 7662,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (G1762)",
    "code": 7664,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "PZ-90.02",
    "code": 7677,
    "projection": "+proj=geocent +a=6378136 +b=6356751.361745712 +units=m +no_defs "
  },
  {
    "name": "PZ-90.11",
    "code": 7679,
    "projection": "+proj=geocent +a=6378136 +b=6356751.361745712 +units=m +no_defs "
  },
  {
    "name": "GSK-2011",
    "code": 7681,
    "projection": "+proj=geocent +a=6378136.5 +b=6356751.757955603 +units=m +no_defs "
  },
  {
    "name": "Kyrg-06",
    "code": 7684,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "ITRF2014",
    "code": 7789,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "BGS2005",
    "code": 7796,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "WGS 84 (Transit)",
    "code": 7815,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "GDA2020",
    "code": 7842,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "St. Helena Tritan",
    "code": 7879,
    "projection": "+proj=geocent +ellps=WGS84 +units=m +no_defs "
  },
  {
    "name": "SHGD2015",
    "code": 7884,
    "projection": "+proj=geocent +ellps=GRS80 +units=m +no_defs "
  },
  {
    "name": "KKJ / Finland Uniform Coordinate System + N60 height",
    "code": 3901,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / TM35FIN(N,E) + N60 height",
    "code": 3902,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / TM35FIN(N,E) + N2000 height",
    "code": 3903,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM1 + DVR90 height",
    "code": 4097,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM2 + DVR90 height",
    "code": 4098,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM3 + DVR90 height",
    "code": 4099,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / DKTM4 + DVR90 height",
    "code": 4100,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / Faroe TM + FVR09 height",
    "code": 5318,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83 + NAVD88 height",
    "code": 5498,
    "projection": "+proj=longlat +datum=NAD83 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs "
  },
  {
    "name": "NAD83(HARN) + NAVD88 height",
    "code": 5499,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs "
  },
  {
    "name": "NAD83(NSRS2007) + NAVD88 height",
    "code": 5500,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31N + DHHN92 height",
    "code": 5554,
    "projection": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N + DHHN92 height",
    "code": 5555,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N + DHHN92 height",
    "code": 5556,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "FEH2010 / Fehmarnbelt TM + FCSVR10 height",
    "code": 5598,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=11.33333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 + RH2000 height",
    "code": 5628,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "RGF93 / Lambert-93 + NGF-IGN69 height",
    "code": 5698,
    "projection": "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "RGF93 / Lambert-93 + NGF-IGN78 height",
    "code": 5699,
    "projection": "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone I + NGF-IGN69 height",
    "code": 5707,
    "projection": "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone IV + NGF-IGN78 height",
    "code": 5708,
    "projection": "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 2 (E-N) + DHHN92 height",
    "code": 5832,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 3 (E-N) + DHHN92 height",
    "code": 5833,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 4 (E-N) + DHHN92 height",
    "code": 5834,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs "
  },
  {
    "name": "DB_REF / 3-degree Gauss-Kruger zone 5 (E-N) + DHHN92 height",
    "code": 5835,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 TM + RH2000 height",
    "code": 5845,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 12 00 + RH2000 height",
    "code": 5846,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 13 30 + RH2000 height",
    "code": 5847,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 15 00 + RH2000 height",
    "code": 5848,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 16 30 + RH2000 height",
    "code": 5849,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 18 00 + RH2000 height",
    "code": 5850,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 14 15 + RH2000 height",
    "code": 5851,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 15 45 + RH2000 height",
    "code": 5852,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 17 15 + RH2000 height",
    "code": 5853,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 18 45 + RH2000 height",
    "code": 5854,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 20 15 + RH2000 height",
    "code": 5855,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 21 45 + RH2000 height",
    "code": 5856,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SWEREF99 23 15 + RH2000 height",
    "code": 5857,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 + NN2000 height",
    "code": 5942,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 5 + NN2000 height",
    "code": 5945,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 6 + NN2000 height",
    "code": 5946,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 7 + NN2000 height",
    "code": 5947,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 8 + NN2000 height",
    "code": 5948,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 9 + NN2000 height",
    "code": 5949,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 10 + NN2000 height",
    "code": 5950,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 11 + NN2000 height",
    "code": 5951,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 12 + NN2000 height",
    "code": 5952,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 13 + NN2000 height",
    "code": 5953,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 14 + NN2000 height",
    "code": 5954,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 15 + NN2000 height",
    "code": 5955,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 16 + NN2000 height",
    "code": 5956,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 17 + NN2000 height",
    "code": 5957,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 18 + NN2000 height",
    "code": 5958,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 19 + NN2000 height",
    "code": 5959,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 20 + NN2000 height",
    "code": 5960,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 21 + NN2000 height",
    "code": 5961,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 22 + NN2000 height",
    "code": 5962,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 23 + NN2000 height",
    "code": 5963,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 24 + NN2000 height",
    "code": 5964,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 25 + NN2000 height",
    "code": 5965,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 26 + NN2000 height",
    "code": 5966,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 27 + NN2000 height",
    "code": 5967,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 28 + NN2000 height",
    "code": 5968,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 29 + NN2000 height",
    "code": 5969,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 30 + NN2000 height",
    "code": 5970,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31 + NN2000 height",
    "code": 5971,
    "projection": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32 + NN2000 height",
    "code": 5972,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33 + NN2000 height",
    "code": 5973,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 34 + NN2000 height",
    "code": 5974,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 35 + NN2000 height",
    "code": 5975,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 36 + NN2000 height",
    "code": 5976,
    "projection": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 + NN54 height",
    "code": 6144,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 5 + NN54 height",
    "code": 6145,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 6 + NN54 height",
    "code": 6146,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 7 + NN54 height",
    "code": 6147,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 8 + NN54 height",
    "code": 6148,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 9 + NN54 height",
    "code": 6149,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 10 + NN54 height",
    "code": 6150,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 11 + NN54 height",
    "code": 6151,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 12 + NN54 height",
    "code": 6152,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 13 + NN54 height",
    "code": 6153,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 14 + NN54 height",
    "code": 6154,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 15 + NN54 height",
    "code": 6155,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 16 + NN54 height",
    "code": 6156,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 17 + NN54 height",
    "code": 6157,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 18 + NN54 height",
    "code": 6158,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 19 + NN54 height",
    "code": 6159,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 20 + NN54 height",
    "code": 6160,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 21 + NN54 height",
    "code": 6161,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 22 + NN54 height",
    "code": 6162,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 23 + NN54 height",
    "code": 6163,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 24 + NN54 height",
    "code": 6164,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 25 + NN54 height",
    "code": 6165,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 26 + NN54 height",
    "code": 6166,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 27 + NN54 height",
    "code": 6167,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 28 + NN54 height",
    "code": 6168,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 29 + NN54 height",
    "code": 6169,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / NTM zone 30 + NN54 height",
    "code": 6170,
    "projection": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 31 + NN54 height",
    "code": 6171,
    "projection": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32 + NN54 height",
    "code": 6172,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33 + NN54 height",
    "code": 6173,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 34 + NN54 height",
    "code": 6174,
    "projection": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 35 + NN54 height",
    "code": 6175,
    "projection": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 36 + NN54 height",
    "code": 6176,
    "projection": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "Belge 1972 / Belgian Lambert 72 + Ostend height",
    "code": 6190,
    "projection": "+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(2011) + NAVD88 height",
    "code": 6349,
    "projection": "+proj=longlat +ellps=GRS80 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) + CGVD2013 height",
    "code": 6649,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 7N + CGVD2013 height",
    "code": 6650,
    "projection": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 8N + CGVD2013 height",
    "code": 6651,
    "projection": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 9N + CGVD2013 height",
    "code": 6652,
    "projection": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 10N + CGVD2013 height",
    "code": 6653,
    "projection": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 11N + CGVD2013 height",
    "code": 6654,
    "projection": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 12N + CGVD2013 height",
    "code": 6655,
    "projection": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 13N + CGVD2013 height",
    "code": 6656,
    "projection": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 14N + CGVD2013 height",
    "code": 6657,
    "projection": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 15N + CGVD2013 height",
    "code": 6658,
    "projection": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 16N + CGVD2013 height",
    "code": 6659,
    "projection": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 17N + CGVD2013 height",
    "code": 6660,
    "projection": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 18N + CGVD2013 height",
    "code": 6661,
    "projection": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 19N + CGVD2013 height",
    "code": 6662,
    "projection": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 20N + CGVD2013 height",
    "code": 6663,
    "projection": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 21N + CGVD2013 height",
    "code": 6664,
    "projection": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD83(CSRS) / UTM zone 22N + CGVD2013 height",
    "code": 6665,
    "projection": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "JGD2000 + JGD2000 (vertical) height",
    "code": 6696,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "JGD2011 + JGD2011 (vertical) height",
    "code": 6697,
    "projection": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs "
  },
  {
    "name": "Tokyo + JSLD72 height",
    "code": 6700,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "WGS 84 / Pseudo-Mercator +  EGM2008 geoid height",
    "code": 6871,
    "projection": "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +geoidgrids=egm08_25.gtx +vunits=m +no_defs "
  },
  {
    "name": "WGS 84 / World Mercator +  EGM2008 height",
    "code": 6893,
    "projection": "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +geoidgrids=egm08_25.gtx +vunits=m +no_defs "
  },
  {
    "name": "SVY21 + SHD height",
    "code": 6917,
    "projection": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs "
  },
  {
    "name": "SVY21 / Singapore TM + SHD height",
    "code": 6927,
    "projection": "+proj=tmerc +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) + NGF IGN69 height",
    "code": 7400,
    "projection": "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France II + NGF Lallemand",
    "code": 7401,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France II + NGF IGN69",
    "code": 7402,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / France III + NGF IGN69",
    "code": 7403,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "RT90 + RH70 height",
    "code": 7404,
    "projection": "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +vunits=m +no_defs "
  },
  {
    "name": "OSGB 1936 / British National Grid + ODN height",
    "code": 7405,
    "projection": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +datum=OSGB36 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NAD27 + NGVD29 height",
    "code": 7406,
    "projection": "+proj=longlat +datum=NAD27 +vunits=us-ft +no_defs "
  },
  {
    "name": "NAD27 / Texas North + NGVD29 height",
    "code": 7407,
    "projection": "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +vunits=us-ft +no_defs "
  },
  {
    "name": "RD/NAP",
    "code": 7408,
    "projection": "+proj=longlat +ellps=bessel +towgs84=565.2369,50.0087,465.658,-0.406857,0.350733,-1.87035,4.0812 +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 + EVRF2000 height",
    "code": 7409,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "PSHD93",
    "code": 7410,
    "projection": "+proj=longlat +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone II + NGF Lallemand height",
    "code": 7411,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone II + NGF IGN69",
    "code": 7412,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone III + NGF IGN69",
    "code": 7413,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "Tokyo + JSLD69 height",
    "code": 7414,
    "projection": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "Amersfoort / RD New + NAP height",
    "code": 7415,
    "projection": "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.2369,50.0087,465.658,-0.406857,0.350733,-1.87035,4.0812 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 32N + DVR90 height",
    "code": 7416,
    "projection": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / UTM zone 33N + DVR90 height",
    "code": 7417,
    "projection": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Jutland + DVR90 height",
    "code": 7418,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Zealand + DVR90 height",
    "code": 7419,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 / Kp2000 Bornholm + DVR90 height",
    "code": 7420,
    "projection": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone II + NGF-IGN69 height",
    "code": 7421,
    "projection": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "NTF (Paris) / Lambert zone III + NGF-IGN69 height",
    "code": 7422,
    "projection": "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs "
  },
  {
    "name": "ETRS89 + EVRF2007 height",
    "code": 7423,
    "projection": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs "
  },
  {
    "name": "Astro DOS 71 / UTM zone 30S + Jamestown 1971 height",
    "code": 7954,
    "projection": "+proj=utm +zone=30 +south +ellps=intl +towgs84=-320,550,-494,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "St. Helena Tritan / UTM zone 30S +  Tritan 2011 height",
    "code": 7955,
    "projection": "+proj=utm +zone=30 +south +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +vunits=m +no_defs "
  },
  {
    "name": "SHMG2015 +  SHVD2015 height",
    "code": 7956,
    "projection": "+proj=utm +zone=30 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs "
  }
];